import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never
    }
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any }
}

export type AdminPeriodStats = {
  __typename?: 'AdminPeriodStats'
  activeUsers: Scalars['Int']['output']
  /** Sum of completed charge billings with paidAt in [from, to) */
  billingTotal: Scalars['Float']['output']
  newNodes: Scalars['Int']['output']
}

export type Article = {
  __typename?: 'Article'
  archivedAt?: Maybe<Scalars['DateTime']['output']>
  articleVotes: Array<ArticleVote>
  cluster: Cluster
  clusterId: Scalars['ID']['output']
  contributionCount: Scalars['Int']['output']
  contributions: Array<Contribution>
  /** Accepted Contributors of an article. */
  contributors: Array<User>
  createdAt: Scalars['DateTime']['output']
  hasUserVote: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  isAutoTitle: Scalars['Boolean']['output']
  isOwner: Scalars['Boolean']['output']
  latestContent: Scalars['String']['output']
  minCoRank?: Maybe<Scalars['Int']['output']>
  originalContent: Scalars['String']['output']
  owner?: Maybe<User>
  ownerId?: Maybe<Scalars['ID']['output']>
  title: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
  version: Scalars['Int']['output']
  voteCount: Scalars['Int']['output']
}

export type ArticleListInput = {
  clusterId: Scalars['ID']['input']
  limit?: InputMaybe<Scalars['Float']['input']>
  offset?: InputMaybe<Scalars['Float']['input']>
}

export type ArticleListResponse = {
  __typename?: 'ArticleListResponse'
  results: Array<Article>
  total: Scalars['Float']['output']
}

export type ArticleVote = {
  __typename?: 'ArticleVote'
  article: Article
  articleId: Scalars['ID']['output']
  clusterId: Scalars['ID']['output']
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  isRemoved: Scalars['Boolean']['output']
  justification?: Maybe<Scalars['String']['output']>
  user: User
  userId: Scalars['ID']['output']
}

export type ArticleVoteListDto = {
  __typename?: 'ArticleVoteListDto'
  results: Array<ArticleVote>
  total: Scalars['Float']['output']
}

export type ArticleWithPosition = {
  __typename?: 'ArticleWithPosition'
  archivedAt?: Maybe<Scalars['DateTime']['output']>
  articleVotes: Array<ArticleVote>
  cluster: Cluster
  clusterId: Scalars['ID']['output']
  contributionCount: Scalars['Int']['output']
  contributions: Array<Contribution>
  /** Accepted Contributors of an article. */
  contributors: Array<User>
  createdAt: Scalars['DateTime']['output']
  dbPosition: Scalars['Int']['output']
  hasUserVote: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  isAutoTitle: Scalars['Boolean']['output']
  isOwner: Scalars['Boolean']['output']
  latestContent: Scalars['String']['output']
  minCoRank?: Maybe<Scalars['Int']['output']>
  originalContent: Scalars['String']['output']
  owner?: Maybe<User>
  ownerId?: Maybe<Scalars['ID']['output']>
  title: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
  version: Scalars['Int']['output']
  voteCount: Scalars['Int']['output']
}

export type AssignCollaboratorToListInput = {
  collaboratorId: Scalars['String']['input']
  listId: Scalars['String']['input']
}

export type AssignTaskInput = {
  assignedId: Scalars['String']['input']
  taskId: Scalars['ID']['input']
}

export type Billing = {
  __typename?: 'Billing'
  amount: Scalars['Float']['output']
  billingId: Scalars['ID']['output']
  billingType: Scalars['String']['output']
  createdAt: Scalars['DateTime']['output']
  description: Scalars['String']['output']
  errorMessage?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  newNodeTierPayload?: Maybe<NewNodeTierPayload>
  paidAt?: Maybe<Scalars['DateTime']['output']>
  paymentIntentId?: Maybe<Scalars['String']['output']>
  paymentMethod?: Maybe<Scalars['String']['output']>
  renovatePayload?: Maybe<RenovateNodeTierPayload>
  status: Scalars['String']['output']
  tierDowngradePayload?: Maybe<TierDowngradePayload>
  tierUpgradePayload?: Maybe<TierUpgradePayload>
  transactionId?: Maybe<Scalars['String']['output']>
  type: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
  userId: Scalars['ID']['output']
}

export type BillingFilterInput = {
  status?: InputMaybe<Scalars['String']['input']>
}

export type BillingStatusDto = {
  __typename?: 'BillingStatusDto'
  message?: Maybe<Scalars['String']['output']>
  paidAt?: Maybe<Scalars['DateTime']['output']>
  processedAt?: Maybe<Scalars['DateTime']['output']>
  status: Scalars['String']['output']
}

export type BumpContributionInput = {
  contributionId: Scalars['ID']['input']
  reason?: InputMaybe<Scalars['String']['input']>
  value: Scalars['Int']['input']
}

export type Cluster = {
  __typename?: 'Cluster'
  articleVotes: Array<ArticleVote>
  articles: Array<Article>
  articlesCount: Scalars['Float']['output']
  contentUpdatedAt: Scalars['DateTime']['output']
  contributionsCount: Scalars['Float']['output']
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  isModerator: Scalars['Boolean']['output']
  isOwner: Scalars['Boolean']['output']
  isPrivate: Scalars['Boolean']['output']
  moderators: Array<ClusterMember>
  node: Node
  nodeId: Scalars['ID']['output']
  owner?: Maybe<User>
  ownerId?: Maybe<Scalars['ID']['output']>
  showModerators: Scalars['Boolean']['output']
  showPerspectiveOwners: Scalars['Boolean']['output']
  topic: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
  votesCount: Scalars['Float']['output']
}

export type ClusterListInput = {
  nodeId: Scalars['ID']['input']
  searchQuery?: InputMaybe<Scalars['String']['input']>
}

export type ClusterMember = {
  __typename?: 'ClusterMember'
  clusterId: Scalars['ID']['output']
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  isModerator: Scalars['Boolean']['output']
  updatedAt: Scalars['DateTime']['output']
  user: User
  userId: Scalars['ID']['output']
}

export enum CoRankNodeScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
}

export type CollaboratorListDto = {
  __typename?: 'CollaboratorListDto'
  collaborators?: Maybe<Array<User>>
  color?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  ownerId: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type CollaboratorListWithMembersResponse = {
  __typename?: 'CollaboratorListWithMembersResponse'
  collaboratorCount: Scalars['Int']['output']
  list: CollaboratorListDto
}

export type CollaboratorPaginationResponse = {
  __typename?: 'CollaboratorPaginationResponse'
  total: Scalars['Int']['output']
  users: Array<CollaboratorUser>
}

export type CollaboratorUser = {
  __typename?: 'CollaboratorUser'
  bio?: Maybe<Scalars['String']['output']>
  collaboratorId?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  emailAddress?: Maybe<Scalars['String']['output']>
  firstName: Scalars['String']['output']
  googleSync?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  incompleteTasks?: Maybe<Array<Tasks>>
  isClusterMember?: Maybe<Scalars['Boolean']['output']>
  isEmailVerified?: Maybe<Scalars['Boolean']['output']>
  isMobileVerified?: Maybe<Scalars['Boolean']['output']>
  isNodeMember?: Maybe<Scalars['Boolean']['output']>
  isPushNotificationsEnabled: Scalars['Boolean']['output']
  isSuperAdmin: Scalars['Boolean']['output']
  lastEvent?: Maybe<TimeLine>
  lastName: Scalars['String']['output']
  lists?: Maybe<Array<CollaboratorListDto>>
  mobileCountryCode?: Maybe<Scalars['Int']['output']>
  mobileNumber?: Maybe<Scalars['String']['output']>
  notificationsDeviceInfo?: Maybe<Scalars['String']['output']>
  publicCoRank?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  username: Scalars['String']['output']
  wechatSync?: Maybe<Scalars['Boolean']['output']>
}

export type CollaboratorUserIsClusterMemberArgs = {
  clusterId?: InputMaybe<Scalars['String']['input']>
}

export type CollaboratorUserIsNodeMemberArgs = {
  nodeId?: InputMaybe<Scalars['String']['input']>
}

export type Contribution = {
  __typename?: 'Contribution'
  appliedAsVersion: Scalars['Int']['output']
  article: Article
  articleId: Scalars['ID']['output']
  basedOnVersion: Scalars['Int']['output']
  begin: Scalars['Int']['output']
  bumpCount: Scalars['Int']['output']
  bumpScore: Scalars['Int']['output']
  bumps: Array<ContributionBump>
  cluster: Cluster
  clusterId: Scalars['ID']['output']
  contributionType: ContributionType
  createdAt: Scalars['DateTime']['output']
  decisionAt?: Maybe<Scalars['DateTime']['output']>
  end: Scalars['Int']['output']
  id: Scalars['ID']['output']
  input?: Maybe<Scalars['String']['output']>
  intendedType?: Maybe<ContributionType>
  latestContent: Scalars['String']['output']
  motivation?: Maybe<Scalars['String']['output']>
  originalText: Scalars['String']['output']
  reservedUntil?: Maybe<Scalars['DateTime']['output']>
  response?: Maybe<Scalars['String']['output']>
  status: ContributionStatus
  updatedAt: Scalars['DateTime']['output']
  user?: Maybe<User>
  userId: Scalars['ID']['output']
}

export type ContributionBump = {
  __typename?: 'ContributionBump'
  contribution: Contribution
  contributionId: Scalars['ID']['output']
  createdAt: Scalars['DateTime']['output']
  reason: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
  user: User
  userId: Scalars['ID']['output']
  value: Scalars['Int']['output']
}

export type ContributionResponse = {
  __typename?: 'ContributionResponse'
  contributions: Array<Contribution>
  percentage: Scalars['Float']['output']
}

export enum ContributionStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Censured = 'CENSURED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
}

export enum ContributionType {
  Challenge = 'CHALLENGE',
  Edit = 'EDIT',
  Inquiry = 'INQUIRY',
  OwnerEdit = 'OWNER_EDIT',
  Reserved = 'RESERVED',
}

export type CorankTimelinePoint = {
  __typename?: 'CorankTimelinePoint'
  coRank: Scalars['Int']['output']
  timestamp: Scalars['DateTime']['output']
}

export type CorankUpdatedTimelineSeries = {
  __typename?: 'CorankUpdatedTimelineSeries'
  /** How many of the 10 time buckets contain at least one CORANK_UPDATED (not total DB rows). */
  eventCount: Scalars['Int']['output']
  points: Array<CorankTimelinePoint>
  windowEnd?: Maybe<Scalars['DateTime']['output']>
  windowStart?: Maybe<Scalars['DateTime']['output']>
}

export type CorankUserDifference = {
  __typename?: 'CorankUserDifference'
  isCommonContributionContext: Scalars['Boolean']['output']
  profileUserLastUpdateScore: Scalars['Int']['output']
  viewerLastUpdateScore: Scalars['Int']['output']
}

export type CouponBillingPreview = {
  __typename?: 'CouponBillingPreview'
  amount: Scalars['Float']['output']
  appliedMonths?: Maybe<Scalars['Int']['output']>
  basePrice?: Maybe<Scalars['Float']['output']>
  billingId: Scalars['ID']['output']
  couponCode?: Maybe<Scalars['String']['output']>
  discountPercentage?: Maybe<Scalars['Int']['output']>
  isForever: Scalars['Boolean']['output']
  isFree: Scalars['Boolean']['output']
}

export type CouponDto = {
  __typename?: 'CouponDto'
  /** Optional admin-only label for context (campaign, event, etc.) */
  adminLabel?: Maybe<Scalars['String']['output']>
  /** How many months discount applies to. 0 means forever. */
  appliedMonths: Scalars['Int']['output']
  code: Scalars['String']['output']
  createdAt: Scalars['DateTime']['output']
  /** Percentage discount applied to billing amount (0-100). */
  discountPercentage: Scalars['Int']['output']
  enabled: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  maxRedeems: Scalars['Int']['output']
  /** Number of times this coupon has been redeemed */
  redeemCount: Scalars['Int']['output']
  /** Distinct users with a billing row linked to this coupon */
  redeemedByUsers: Array<User>
  updatedAt: Scalars['DateTime']['output']
  validTo: Scalars['DateTime']['output']
}

export type CouponFilterInput = {
  /** When set, only coupons with this enabled flag */
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  /** When true, only coupons with validTo on or before now; when false, only coupons with validTo after now */
  isExpired?: InputMaybe<Scalars['Boolean']['input']>
  /** Case-insensitive substring match on coupon code or admin-only label */
  search?: InputMaybe<Scalars['String']['input']>
}

export type CouponRedemptionDto = {
  __typename?: 'CouponRedemptionDto'
  /** Billing row id for this redemption */
  billingId: Scalars['ID']['output']
  /** Billing target kind, e.g. new_node_tier */
  billingType: Scalars['String']['output']
  description: Scalars['String']['output']
  /** Node id from billing payload when available (for deep links) */
  nodeId?: Maybe<Scalars['ID']['output']>
  /** Node name from billing payload when available */
  nodeLabel?: Maybe<Scalars['String']['output']>
  /** When the redemption occurred (paidAt, else processedAt, else createdAt) */
  redeemedAt: Scalars['DateTime']['output']
  status: Scalars['String']['output']
  user: User
}

export enum CouponSortField {
  Code = 'CODE',
  CreatedAt = 'CREATED_AT',
  RedeemCount = 'REDEEM_COUNT',
  ValidTo = 'VALID_TO',
}

export type CreateArticleInput = {
  clusterId: Scalars['ID']['input']
  isAutoTitle: Scalars['Boolean']['input']
  minCoRank?: InputMaybe<Scalars['Int']['input']>
  originalContent: Scalars['String']['input']
  title?: InputMaybe<Scalars['String']['input']>
}

export type CreateClusterInput = {
  isPrivate: Scalars['Boolean']['input']
  nodeId: Scalars['ID']['input']
  showModerators: Scalars['Boolean']['input']
  showPerspectiveOwners: Scalars['Boolean']['input']
  topic: Scalars['String']['input']
}

export type CreateClusterMemberInput = {
  clusterId: Scalars['ID']['input']
  isModerator: Scalars['Boolean']['input']
  userId: Scalars['ID']['input']
}

export type CreateCollaboratorListInput = {
  color?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
}

export type CreateCouponInput = {
  /** Optional admin-only name or note (e.g. campaign); not shown on public flows */
  adminLabel?: InputMaybe<Scalars['String']['input']>
  /** How many months discount applies to. 0 means forever. */
  appliedMonths?: InputMaybe<Scalars['Int']['input']>
  /** Percentage discount applied to billing amount (0-100). */
  discountPercentage?: InputMaybe<Scalars['Int']['input']>
  maxRedeems: Scalars['Int']['input']
  validTo: Scalars['DateTime']['input']
}

export type CreateInvitationInput = {
  maxUsage?: InputMaybe<Scalars['Int']['input']>
  message?: InputMaybe<Scalars['String']['input']>
  nodeId: Scalars['String']['input']
  validAfter?: InputMaybe<Scalars['DateTime']['input']>
  validBefore?: InputMaybe<Scalars['DateTime']['input']>
}

export type CreateMelddTaskInput = {
  targetId: Scalars['String']['input']
  targetType: Scalars['String']['input']
  title: Scalars['String']['input']
  type: Scalars['String']['input']
}

export type CreateNodeInput = {
  allowExtraSeats?: InputMaybe<Scalars['Boolean']['input']>
  description: Scalars['String']['input']
  isPrivate: Scalars['Boolean']['input']
  name: Scalars['String']['input']
}

export type CreateNodeMemberInput = {
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  nodeId: Scalars['ID']['input']
  userId: Scalars['ID']['input']
}

export type CreateNodeRequestInput = {
  allowExtraSeats?: InputMaybe<Scalars['Boolean']['input']>
  isPrivate: Scalars['Boolean']['input']
  nodeDescription?: InputMaybe<Scalars['String']['input']>
  nodeName?: InputMaybe<Scalars['String']['input']>
  seats: Scalars['Int']['input']
  tierName: Scalars['String']['input']
}

export type CreateNodeRequestResponse = {
  __typename?: 'CreateNodeRequestResponse'
  amount: Scalars['Float']['output']
  basePrice?: Maybe<Scalars['Float']['output']>
  billingId: Scalars['ID']['output']
  expirationDate?: Maybe<Scalars['DateTime']['output']>
  isPrivate?: Maybe<Scalars['Boolean']['output']>
  renovationTier?: Maybe<Scalars['String']['output']>
}

export type CreatePaypalOrderInput = {
  amount: Scalars['String']['input']
  cancelUrl: Scalars['String']['input']
  currency: Scalars['String']['input']
  customId: Scalars['String']['input']
  description: Scalars['String']['input']
  returnUrl: Scalars['String']['input']
}

export type CreateWechatPayOrderInput = {
  customId: Scalars['String']['input']
  description: Scalars['String']['input']
  paymentMethod: WechatPayMethod
  returnUrl?: InputMaybe<Scalars['String']['input']>
  sceneInfo?: InputMaybe<Scalars['String']['input']>
  timeExpire?: InputMaybe<Scalars['Float']['input']>
}

export type DowngradeNodeTierInput = {
  nodeTierId: Scalars['ID']['input']
  seats: Scalars['Int']['input']
}

export type ExtraSeatDto = {
  __typename?: 'ExtraSeatDto'
  extra_seat_private: Scalars['Float']['output']
  extra_seat_public: Scalars['Float']['output']
}

export type GetContributionsByTargetInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>
  targetId: Scalars['ID']['input']
  targetType: Scalars['String']['input']
  userId?: InputMaybe<Scalars['ID']['input']>
}

export type GetContributionsFilter = {
  completed?: InputMaybe<Scalars['Boolean']['input']>
  targetType?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['ID']['input']>
}

export type GetContributionsInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>
  targetType?: InputMaybe<Scalars['String']['input']>
  taskId: Scalars['String']['input']
  userId?: InputMaybe<Scalars['ID']['input']>
}

export type GetNewEventsCountInput = {
  nodeId?: InputMaybe<Scalars['ID']['input']>
}

export type GetTasksInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  assigned?: InputMaybe<Scalars['Boolean']['input']>
  assignedId?: InputMaybe<Scalars['ID']['input']>
  completed?: InputMaybe<Scalars['Boolean']['input']>
  contributed?: InputMaybe<Scalars['Boolean']['input']>
  ownerId?: InputMaybe<Scalars['ID']['input']>
  targetId?: InputMaybe<Scalars['String']['input']>
  targetType?: InputMaybe<Array<Scalars['String']['input']>>
  title?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Array<Scalars['String']['input']>>
}

export type GoogleLoginInput = {
  os: Scalars['String']['input']
  token: Scalars['String']['input']
}

export type GoogleTokenInput = {
  os: Scalars['String']['input']
  token: Scalars['String']['input']
}

export type InboundOutboundResponse = {
  __typename?: 'InboundOutboundResponse'
  coRank: Scalars['Float']['output']
  /** To be dropped, use coRank instead */
  corank: Scalars['Float']['output']
  inbound: PerTypeResponse
  outbound: PerTypeResponse
}

export type Invitation = {
  __typename?: 'Invitation'
  code: Scalars['String']['output']
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  maxUsage?: Maybe<Scalars['Int']['output']>
  message?: Maybe<Scalars['String']['output']>
  node?: Maybe<Node>
  nodeId: Scalars['ID']['output']
  updatedAt: Scalars['DateTime']['output']
  usageCount: Scalars['Int']['output']
  validAfter?: Maybe<Scalars['DateTime']['output']>
  validBefore?: Maybe<Scalars['DateTime']['output']>
}

export type InviteCollaboratorToTaskInput = {
  taskId: Scalars['String']['input']
  userId: Scalars['String']['input']
}

export type InviteCollaboratorsByTaskInput = {
  sourceTaskId: Scalars['String']['input']
  targetTaskId: Scalars['String']['input']
}

export type ListInvitationsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>
  nodeId: Scalars['String']['input']
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Scalars['String']['input']>
  orderDirection?: InputMaybe<OrderDirection>
  status?: InputMaybe<Scalars['String']['input']>
}

export type LoginResponse = {
  __typename?: 'LoginResponse'
  accessToken: Scalars['String']['output']
  refreshToken: Scalars['String']['output']
  sub: Scalars['Float']['output']
  user: User
}

export type LoginSsoCheck = {
  __typename?: 'LoginSSOCheck'
  accountExists: Scalars['Boolean']['output']
  ssoName: Scalars['String']['output']
}

export type LoginUserInput = {
  password: Scalars['String']['input']
  username: Scalars['String']['input']
}

export type LoginUserMobileOtpInput = {
  googleToken?: InputMaybe<GoogleTokenInput>
  mobileCountryCode: Scalars['Float']['input']
  mobileNumber: Scalars['String']['input']
  otp: Scalars['String']['input']
  wechatCode?: InputMaybe<Scalars['String']['input']>
}

export type LoginUserOtpInput = {
  otp: Scalars['String']['input']
  username: Scalars['String']['input']
}

export type LogoutInput = {
  token: Scalars['String']['input']
}

export type LogoutResponse = {
  __typename?: 'LogoutResponse'
  isSuccess: Scalars['Boolean']['output']
}

export type Mutation = {
  __typename?: 'Mutation'
  acceptInvitation: Invitation
  applyCouponToBilling: CouponBillingPreview
  archiveTask: Scalars['Boolean']['output']
  assignCollaboratorToList: Scalars['Boolean']['output']
  assignTask: Scalars['Boolean']['output']
  bumpContribution: ContributionBump
  cancelDowngrade: Scalars['Boolean']['output']
  cancelNodeTier: Scalars['Boolean']['output']
  contributeOnTask: TasksContributor
  createArticle: Article
  createCluster: Cluster
  createClusterMember: ClusterMember
  createCollaboratorList: CollaboratorListDto
  createCoupon: CouponDto
  createInvitation: Invitation
  createNode: Node
  createNodeMember: NodeMember
  createNodeRequest: CreateNodeRequestResponse
  createPaypalOrder: PaypalOrderDto
  createPaypalVaultSetupOrder: PaypalOrderDto
  createTask: Tasks
  createWechatPayOrder: WechatPayOrderDto
  deleteAccount: Scalars['String']['output']
  deleteArticle: Scalars['ID']['output']
  deleteCluster: Scalars['ID']['output']
  deleteCollaboratorList: Scalars['Boolean']['output']
  deleteCoupon: Scalars['Boolean']['output']
  deleteInvitation: Invitation
  deleteNode: Scalars['String']['output']
  deleteTaskContribution: Scalars['Boolean']['output']
  disableUserToken: Scalars['Boolean']['output']
  downgradeNodeTier: NodeTier
  expireNodeTierForTesting: Scalars['Boolean']['output']
  expireUnpaidBillings: Scalars['Int']['output']
  generateOpinion: Scalars['String']['output']
  googleCheck: LoginSsoCheck
  googleLogin: LoginResponse
  inviteCollaboratorToTask: TasksContributor
  inviteCollaboratorsByTask: Array<TasksContributor>
  linkWithGoogle: Scalars['String']['output']
  linkWithWechat: Scalars['String']['output']
  login: LoginResponse
  loginMobileOTP: LoginResponse
  loginOTP: LoginResponse
  logout: LogoutResponse
  placeArticleVote: Array<ArticleVote>
  processCouponBilling: Scalars['Boolean']['output']
  reactivateNodeTier: Scalars['Boolean']['output']
  refresh: LoginResponse
  registerPushToken: RegisterPushTokenPayload
  removeArticleVote: Array<ArticleVote>
  removeClusterMember: Scalars['ID']['output']
  removeCollaboratorFromList: Scalars['Boolean']['output']
  removeCouponFromBilling: CouponBillingPreview
  removeNodeMember: Scalars['ID']['output']
  removeSelfFromCluster: Scalars['ID']['output']
  requestMobileVerificationCode: RequestMobileVerificationCodeResponse
  requestOTP: RequestOtpResponse
  reserveContribution: Contribution
  revokeGoogle: Scalars['String']['output']
  revokeWechat: Scalars['String']['output']
  sendTestNotification: Array<NotificationResultDto>
  setDefaultPaymentToken: Scalars['Boolean']['output']
  signUp: RegisterResponse
  simulateRenovationForTesting: Scalars['Boolean']['output']
  submitContribution: Contribution
  subscribeWebPush: User
  transferArticleOwnership: Article
  transferClusterOwnership: Cluster
  transferClusterToNode: Cluster
  transferNodeOwnership: Node
  triggerNodeTierRenovation: Scalars['Boolean']['output']
  unsubscribeWebPush: User
  updateArticle: Article
  updateCluster: Cluster
  updateClusterMember: ClusterMember
  updateCollaboratorList: CollaboratorListDto
  updateContributionStatus: Contribution
  updateCoupon: CouponDto
  updateNode: Node
  updateNodeMember: NodeMember
  updateTimelineReadUntil: Scalars['Boolean']['output']
  updateUser: User
  upgradeNodeTier: CreateNodeRequestResponse
  verifyMobile: Scalars['String']['output']
  wechatCheck: LoginSsoCheck
  wechatLogin: LoginResponse
  wechatSignature: WechatJdkSignatureResponse
}

export type MutationAcceptInvitationArgs = {
  codeOrId: Scalars['String']['input']
}

export type MutationApplyCouponToBillingArgs = {
  billingId: Scalars['ID']['input']
  couponCode: Scalars['String']['input']
}

export type MutationArchiveTaskArgs = {
  input: TaskIdInput
}

export type MutationAssignCollaboratorToListArgs = {
  input: AssignCollaboratorToListInput
}

export type MutationAssignTaskArgs = {
  input: AssignTaskInput
}

export type MutationBumpContributionArgs = {
  input: BumpContributionInput
}

export type MutationCancelDowngradeArgs = {
  id: Scalars['ID']['input']
}

export type MutationCancelNodeTierArgs = {
  id: Scalars['ID']['input']
}

export type MutationContributeOnTaskArgs = {
  input: TaskIdInput
}

export type MutationCreateArticleArgs = {
  input: CreateArticleInput
}

export type MutationCreateClusterArgs = {
  input: CreateClusterInput
}

export type MutationCreateClusterMemberArgs = {
  input: CreateClusterMemberInput
}

export type MutationCreateCollaboratorListArgs = {
  input: CreateCollaboratorListInput
}

export type MutationCreateCouponArgs = {
  input: CreateCouponInput
}

export type MutationCreateInvitationArgs = {
  input: CreateInvitationInput
}

export type MutationCreateNodeArgs = {
  input: CreateNodeInput
}

export type MutationCreateNodeMemberArgs = {
  input: CreateNodeMemberInput
}

export type MutationCreateNodeRequestArgs = {
  input: CreateNodeRequestInput
}

export type MutationCreatePaypalOrderArgs = {
  input: CreatePaypalOrderInput
}

export type MutationCreatePaypalVaultSetupOrderArgs = {
  cancelUrl: Scalars['String']['input']
  returnUrl: Scalars['String']['input']
}

export type MutationCreateTaskArgs = {
  input: CreateMelddTaskInput
}

export type MutationCreateWechatPayOrderArgs = {
  input: CreateWechatPayOrderInput
}

export type MutationDeleteArticleArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteClusterArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteCollaboratorListArgs = {
  listId: Scalars['String']['input']
}

export type MutationDeleteCouponArgs = {
  id: Scalars['String']['input']
}

export type MutationDeleteInvitationArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteNodeArgs = {
  id: Scalars['String']['input']
}

export type MutationDeleteTaskContributionArgs = {
  taskContributionId: Scalars['String']['input']
}

export type MutationDisableUserTokenArgs = {
  id: Scalars['ID']['input']
}

export type MutationDowngradeNodeTierArgs = {
  input: DowngradeNodeTierInput
}

export type MutationExpireNodeTierForTestingArgs = {
  tierId: Scalars['ID']['input']
}

export type MutationGenerateOpinionArgs = {
  clusterId: Scalars['String']['input']
  model?: InputMaybe<Scalars['String']['input']>
  prompt: Scalars['String']['input']
}

export type MutationGoogleCheckArgs = {
  input: GoogleLoginInput
}

export type MutationGoogleLoginArgs = {
  input: GoogleLoginInput
}

export type MutationInviteCollaboratorToTaskArgs = {
  input: InviteCollaboratorToTaskInput
}

export type MutationInviteCollaboratorsByTaskArgs = {
  input: InviteCollaboratorsByTaskInput
}

export type MutationLinkWithGoogleArgs = {
  input: GoogleLoginInput
}

export type MutationLinkWithWechatArgs = {
  input: WechatLoginInput
}

export type MutationLoginArgs = {
  loginUserInput: LoginUserInput
}

export type MutationLoginMobileOtpArgs = {
  input: LoginUserMobileOtpInput
}

export type MutationLoginOtpArgs = {
  input: LoginUserOtpInput
}

export type MutationLogoutArgs = {
  input?: InputMaybe<LogoutInput>
}

export type MutationPlaceArticleVoteArgs = {
  input: PlaceArticleVoteInput
}

export type MutationProcessCouponBillingArgs = {
  billingId: Scalars['ID']['input']
  couponCode: Scalars['String']['input']
}

export type MutationReactivateNodeTierArgs = {
  id: Scalars['ID']['input']
}

export type MutationRefreshArgs = {
  input: RefreshTokenInput
}

export type MutationRegisterPushTokenArgs = {
  input: RegisterPushTokenInput
}

export type MutationRemoveArticleVoteArgs = {
  input: RemoveArticleVoteInput
}

export type MutationRemoveClusterMemberArgs = {
  id: Scalars['ID']['input']
}

export type MutationRemoveCollaboratorFromListArgs = {
  input: RemoveCollaboratorFromListInput
}

export type MutationRemoveCouponFromBillingArgs = {
  billingId: Scalars['ID']['input']
}

export type MutationRemoveNodeMemberArgs = {
  id: Scalars['ID']['input']
}

export type MutationRemoveSelfFromClusterArgs = {
  clusterId: Scalars['ID']['input']
}

export type MutationRequestMobileVerificationCodeArgs = {
  input: RequestMobileVerificationInput
}

export type MutationRequestOtpArgs = {
  input: RequestOtpInput
}

export type MutationReserveContributionArgs = {
  input: ReserveContributionInput
}

export type MutationSendTestNotificationArgs = {
  message: Scalars['String']['input']
}

export type MutationSetDefaultPaymentTokenArgs = {
  id: Scalars['ID']['input']
}

export type MutationSignUpArgs = {
  input: SignUpInput
}

export type MutationSubmitContributionArgs = {
  input: SubmitContributionInput
}

export type MutationSubscribeWebPushArgs = {
  input: SubscribeWebPushInput
}

export type MutationTransferArticleOwnershipArgs = {
  input: TransferArticleOwnershipInput
}

export type MutationTransferClusterOwnershipArgs = {
  input: TransferClusterOwnershipInput
}

export type MutationTransferClusterToNodeArgs = {
  input: TransferClusterToNodeInput
}

export type MutationTransferNodeOwnershipArgs = {
  input: TransferOwnershipInput
}

export type MutationUpdateArticleArgs = {
  input: UpdateArticleInput
}

export type MutationUpdateClusterArgs = {
  input: UpdateClusterInput
}

export type MutationUpdateClusterMemberArgs = {
  input: UpdateClusterMemberInput
}

export type MutationUpdateCollaboratorListArgs = {
  input: UpdateCollaboratorListInput
  listId: Scalars['String']['input']
}

export type MutationUpdateContributionStatusArgs = {
  input: UpdateContributionInput
}

export type MutationUpdateCouponArgs = {
  input: UpdateCouponInput
}

export type MutationUpdateNodeArgs = {
  input: UpdateNodeInput
}

export type MutationUpdateNodeMemberArgs = {
  input: UpdateNodeMemberInput
}

export type MutationUpdateUserArgs = {
  input: UpdateUserInput
}

export type MutationUpgradeNodeTierArgs = {
  input: UpgradeNodeTierInput
}

export type MutationVerifyMobileArgs = {
  input: VerifyMobileInput
}

export type MutationWechatCheckArgs = {
  input: WechatLoginInput
}

export type MutationWechatLoginArgs = {
  input: WechatLoginInput
}

export type MutationWechatSignatureArgs = {
  input: WechatJdkSignatureInput
}

export type MyCollaboratorsTimelineInput = {
  actions?: InputMaybe<Array<TimeLineAction>>
  nodeId?: InputMaybe<Scalars['ID']['input']>
  pagination?: InputMaybe<PaginationInput>
  userId?: InputMaybe<Scalars['ID']['input']>
}

export type MyNodesInput = {
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Float']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  offset?: InputMaybe<Scalars['Float']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<Scalars['String']['input']>
}

export type MyNodesResponse = {
  __typename?: 'MyNodesResponse'
  results: Array<Node>
  total: Scalars['Float']['output']
}

export type MyTaskWithContributorsDto = {
  __typename?: 'MyTaskWithContributorsDto'
  contributors: Array<TasksContributor>
  task: Tasks
}

export type MyTasksWithContributorsResponse = {
  __typename?: 'MyTasksWithContributorsResponse'
  count: Scalars['Float']['output']
  results: Array<MyTaskWithContributorsDto>
}

export type NewNodeTierPayload = {
  __typename?: 'NewNodeTierPayload'
  allowExtraSeats?: Maybe<Scalars['Boolean']['output']>
  basePrice?: Maybe<Scalars['Float']['output']>
  isPrivate?: Maybe<Scalars['Boolean']['output']>
  nodeDescription?: Maybe<Scalars['String']['output']>
  nodeName?: Maybe<Scalars['String']['output']>
  seats?: Maybe<Scalars['Float']['output']>
  tierName?: Maybe<Scalars['String']['output']>
}

export type NextMonthCostEstimate = {
  __typename?: 'NextMonthCostEstimate'
  baseAmount: Scalars['Float']['output']
  extraAmount: Scalars['Float']['output']
  tierDetails: Array<TierCostDetail>
  totalAmount: Scalars['Float']['output']
}

export type Node = {
  __typename?: 'Node'
  activeTier?: Maybe<NodeTier>
  allowExtraSeats: Scalars['Boolean']['output']
  clusters: Array<Cluster>
  createdAt: Scalars['DateTime']['output']
  description: Scalars['String']['output']
  id: Scalars['ID']['output']
  isAdmin: Scalars['Boolean']['output']
  isOwner: Scalars['Boolean']['output']
  isPrivate: Scalars['Boolean']['output']
  memberCount: Scalars['Int']['output']
  name: Scalars['String']['output']
  nodeTier: NodeTier
  updatedAt: Scalars['DateTime']['output']
}

export type NodeMember = {
  __typename?: 'NodeMember'
  id: Scalars['ID']['output']
  isAdmin: Scalars['Boolean']['output']
  nodeId: Scalars['ID']['output']
  user: User
  userId: Scalars['ID']['output']
}

export type NodeMemberListDto = {
  __typename?: 'NodeMemberListDto'
  results: Array<NodeMember>
  total: Scalars['Float']['output']
}

export type NodeStats = {
  __typename?: 'NodeStats'
  contributions: Array<Contribution>
  node: Node
  nodeId: Scalars['ID']['output']
  perspectives: Array<Article>
  users: Array<User>
}

export type NodeStatsInput = {
  nodeId: Scalars['ID']['input']
}

export type NodeTier = {
  __typename?: 'NodeTier'
  activeUsers: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  currentActiveUsers?: Maybe<Scalars['Int']['output']>
  endDate?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  nodeId: Scalars['ID']['output']
  seats: Scalars['Int']['output']
  startDate?: Maybe<Scalars['DateTime']['output']>
  status: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
  userId: Scalars['ID']['output']
}

export type NodeTierConfig = {
  __typename?: 'NodeTierConfig'
  extra: ExtraSeatDto
  tiers: Array<TierConfigDto>
}

export type NodeTierDetail = {
  __typename?: 'NodeTierDetail'
  activeUsers?: Maybe<Scalars['Float']['output']>
  basePrice?: Maybe<Scalars['Float']['output']>
  currentTierId: Scalars['String']['output']
  extraSeatPrice?: Maybe<Scalars['Float']['output']>
  extraSeats?: Maybe<Scalars['Float']['output']>
  isPrivate: Scalars['Boolean']['output']
  nodeId: Scalars['String']['output']
  nodeName?: Maybe<Scalars['String']['output']>
  pricing: Scalars['Float']['output']
  seats: Scalars['Float']['output']
  tierName: Scalars['String']['output']
}

export type NodeTierFilterInput = {
  nodeId?: InputMaybe<Scalars['ID']['input']>
  status?: InputMaybe<Scalars['String']['input']>
}

export type NodeTierPaginationResponse = {
  __typename?: 'NodeTierPaginationResponse'
  nodeTiers: Array<NodeTier>
  total: Scalars['Int']['output']
}

export type NodeTopContributionsInput = {
  limit?: InputMaybe<Scalars['Float']['input']>
  nodeId: Scalars['ID']['input']
  offset?: InputMaybe<Scalars['Float']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<Scalars['String']['input']>
}

export type NodeTopContributionsResponse = {
  __typename?: 'NodeTopContributionsResponse'
  contributions: Array<Contribution>
  total: Scalars['Int']['output']
}

export type NodeTopPerspectivesInput = {
  limit?: InputMaybe<Scalars['Float']['input']>
  nodeId: Scalars['ID']['input']
  offset?: InputMaybe<Scalars['Float']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<Scalars['String']['input']>
}

export type NodeTopPerspectivesResponse = {
  __typename?: 'NodeTopPerspectivesResponse'
  perspectives: Array<ArticleWithPosition>
  total: Scalars['Int']['output']
}

export type NodeTopUsersInput = {
  limit?: InputMaybe<Scalars['Float']['input']>
  nodeId: Scalars['ID']['input']
  offset?: InputMaybe<Scalars['Float']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<Scalars['String']['input']>
}

export type NodeTopUsersResponse = {
  __typename?: 'NodeTopUsersResponse'
  total: Scalars['Int']['output']
  users: Array<UserWithCoRank>
}

export type NotificationResultDto = {
  __typename?: 'NotificationResultDto'
  message: Scalars['String']['output']
  provider: Scalars['String']['output']
  success: Scalars['Boolean']['output']
  userId: Scalars['String']['output']
}

export enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type PaginatedInvitations = {
  __typename?: 'PaginatedInvitations'
  invitations: Array<Invitation>
  limit: Scalars['Int']['output']
  offset: Scalars['Int']['output']
  total: Scalars['Int']['output']
}

export type PaginationInput = {
  limit?: InputMaybe<Scalars['Float']['input']>
  offset?: InputMaybe<Scalars['Float']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<Scalars['String']['input']>
}

export type PaypalOrderDto = {
  __typename?: 'PaypalOrderDto'
  id: Scalars['String']['output']
}

export type PendingTasksResponse = {
  __typename?: 'PendingTasksResponse'
  pendingContributions: Scalars['Int']['output']
  pendingTasks: Scalars['Int']['output']
}

export type PerTypeResponse = {
  __typename?: 'PerTypeResponse'
  challenge: ContributionResponse
  edit: ContributionResponse
  inquiry: ContributionResponse
}

export type PlaceArticleVoteInput = {
  articleId: Scalars['ID']['input']
  justification?: InputMaybe<Scalars['String']['input']>
}

export type Query = {
  __typename?: 'Query'
  /** Super-admin metrics for a half-open time range [from, to) */
  adminStatsForRange: AdminPeriodStats
  article: Article
  articleVotes: Array<ArticleVote>
  articleVotesByArticleId: ArticleVoteListDto
  articlesForCluster: ArticleListResponse
  articlesForUser: Array<Article>
  availableClusters: Array<Cluster>
  availableNodes: Array<Node>
  billing: Billing
  billingStatus: BillingStatusDto
  billings: Array<Billing>
  checkUniqTitle: Scalars['Boolean']['output']
  cluster: Cluster
  clusterById: Cluster
  clusterMembers: Array<ClusterMember>
  clusterMembersByClusterId: Array<ClusterMember>
  clusters: Array<Cluster>
  collaboratorListWithMembers?: Maybe<CollaboratorListWithMembersResponse>
  collaboratorLists: Array<CollaboratorListDto>
  collaborators: CollaboratorPaginationResponse
  contributionBumpsByContribution: Array<ContributionBump>
  contributionById: Contribution
  contributionsByArticle: Array<Contribution>
  contributionsByCluster: Array<Contribution>
  contributionsByPerspective: Array<Contribution>
  contributionsByUser: Array<Contribution>
  contributionsForMyArticles: Array<Contribution>
  corankUpdatedTimelineSeries: CorankUpdatedTimelineSeries
  corankUserDifference: CorankUserDifference
  couponRedemptions: Array<CouponRedemptionDto>
  coupons: Array<CouponDto>
  exportDocx: Scalars['String']['output']
  getHistory: TimelineListResponse
  getMyContributionByTaskId?: Maybe<TasksContributor>
  getMyContributions: TaskContributorResponse
  getNewEventsCount: Scalars['Float']['output']
  getTargetContributions: TaskContributorResponse
  getTask: Tasks
  getTaskCollaboratorInvites: TaskContributorResponse
  getTaskContributions: TaskContributorResponse
  getTasks: TasksResponse
  getTimelinePosition: TimelinePositionResponse
  inboundOutboundContributions: InboundOutboundResponse
  isTargetAllowed: Scalars['Boolean']['output']
  listInvitations: PaginatedInvitations
  myCollaboratorLists: Array<CollaboratorListDto>
  myCollaboratorsEvents: TimelineListResponse
  myCorank: Scalars['Int']['output']
  myNodes: MyNodesResponse
  myTasks: MyTasksWithContributorsResponse
  myTimelineEvents: TimelineListResponse
  nextMonthCostEstimate: NextMonthCostEstimate
  nodeById: Node
  nodeMembers: Array<NodeMember>
  nodeMembersByNodeId: NodeMemberListDto
  nodeStats: NodeStats
  nodeTier: NodeTier
  nodeTierConfig: NodeTierConfig
  nodeTiers: NodeTierPaginationResponse
  nodeTopContributions: NodeTopContributionsResponse
  nodeTopPerspectives: NodeTopPerspectivesResponse
  nodeTopUsers: NodeTopUsersResponse
  nodes: Array<Node>
  nodesWithClusters: Array<Node>
  pendingTasks?: Maybe<PendingTasksResponse>
  reservedContribution?: Maybe<Contribution>
  search: Array<SearchResult>
  suggestUsername: SuggestUsernamePayload
  tasksTypes: Array<TaskType>
  user: User
  userCorank: Scalars['Int']['output']
  userTimelineEvents: TimelineListResponse
  userTokens: Array<UserTokenDto>
  userTotalContributions: Scalars['Int']['output']
  userTotalPerspectives: Scalars['Int']['output']
  usernameAvailable: UsernameAvailablePayload
  users: Array<User>
  usersBySearchUsername: Array<User>
  validAppAccessKey: ValidAppAccessKeyPayload
  validInvitation: ValidInvitation
}

export type QueryAdminStatsForRangeArgs = {
  from: Scalars['DateTime']['input']
  to: Scalars['DateTime']['input']
}

export type QueryArticleArgs = {
  id: Scalars['ID']['input']
}

export type QueryArticleVotesByArticleIdArgs = {
  input: QueryArticleVoteInput
}

export type QueryArticlesForClusterArgs = {
  input: ArticleListInput
}

export type QueryArticlesForUserArgs = {
  userId: Scalars['ID']['input']
}

export type QueryAvailableClustersArgs = {
  input: ClusterListInput
}

export type QueryBillingArgs = {
  id: Scalars['ID']['input']
}

export type QueryBillingStatusArgs = {
  id: Scalars['ID']['input']
}

export type QueryBillingsArgs = {
  filter?: InputMaybe<BillingFilterInput>
  pagination?: InputMaybe<PaginationInput>
}

export type QueryCheckUniqTitleArgs = {
  clusterId: Scalars['ID']['input']
  title: Scalars['String']['input']
}

export type QueryClusterArgs = {
  id: Scalars['ID']['input']
}

export type QueryClusterByIdArgs = {
  id: Scalars['ID']['input']
}

export type QueryClusterMembersByClusterIdArgs = {
  clusterId: Scalars['ID']['input']
}

export type QueryCollaboratorListWithMembersArgs = {
  listId: Scalars['String']['input']
}

export type QueryCollaboratorListsArgs = {
  collaboratorId: Scalars['String']['input']
}

export type QueryCollaboratorsArgs = {
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
}

export type QueryContributionBumpsByContributionArgs = {
  contributionId: Scalars['ID']['input']
}

export type QueryContributionByIdArgs = {
  contributionId: Scalars['ID']['input']
}

export type QueryContributionsByArticleArgs = {
  articleId: Scalars['ID']['input']
  status: Array<ContributionStatus>
}

export type QueryContributionsByClusterArgs = {
  clusterId: Scalars['ID']['input']
  status?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type QueryContributionsByPerspectiveArgs = {
  articleId: Scalars['ID']['input']
  status?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type QueryContributionsByUserArgs = {
  status: Array<ContributionStatus>
  userId: Scalars['ID']['input']
}

export type QueryContributionsForMyArticlesArgs = {
  status: Array<ContributionStatus>
}

export type QueryCorankUpdatedTimelineSeriesArgs = {
  nodeId?: InputMaybe<Scalars['ID']['input']>
  userId: Scalars['ID']['input']
}

export type QueryCorankUserDifferenceArgs = {
  nodeId?: InputMaybe<Scalars['ID']['input']>
  profileUserId: Scalars['ID']['input']
}

export type QueryCouponRedemptionsArgs = {
  couponId: Scalars['String']['input']
}

export type QueryCouponsArgs = {
  filter?: InputMaybe<CouponFilterInput>
  sortBy?: InputMaybe<CouponSortField>
  sortDirection?: InputMaybe<OrderDirection>
}

export type QueryExportDocxArgs = {
  id: Scalars['ID']['input']
}

export type QueryGetHistoryArgs = {
  input: TimelineListInput
}

export type QueryGetMyContributionByTaskIdArgs = {
  taskId: Scalars['String']['input']
}

export type QueryGetMyContributionsArgs = {
  input: GetContributionsFilter
  offset: Scalars['Float']['input']
  size: Scalars['Float']['input']
}

export type QueryGetNewEventsCountArgs = {
  input: GetNewEventsCountInput
}

export type QueryGetTargetContributionsArgs = {
  input: GetContributionsByTargetInput
  offset: Scalars['Float']['input']
  size: Scalars['Float']['input']
}

export type QueryGetTaskArgs = {
  taskId: Scalars['String']['input']
}

export type QueryGetTaskCollaboratorInvitesArgs = {
  offset: Scalars['Float']['input']
  size: Scalars['Float']['input']
  taskId: Scalars['String']['input']
}

export type QueryGetTaskContributionsArgs = {
  input: GetContributionsInput
  offset: Scalars['Float']['input']
  size: Scalars['Float']['input']
}

export type QueryGetTasksArgs = {
  input: GetTasksInput
  offset: Scalars['Float']['input']
  size: Scalars['Float']['input']
}

export type QueryGetTimelinePositionArgs = {
  id: Scalars['String']['input']
}

export type QueryInboundOutboundContributionsArgs = {
  userId: Scalars['ID']['input']
}

export type QueryIsTargetAllowedArgs = {
  input: TimelineTargetInput
}

export type QueryListInvitationsArgs = {
  input: ListInvitationsInput
}

export type QueryMyCollaboratorsEventsArgs = {
  input: MyCollaboratorsTimelineInput
}

export type QueryMyCorankArgs = {
  nodeId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryMyNodesArgs = {
  input?: InputMaybe<MyNodesInput>
}

export type QueryMyTasksArgs = {
  offset: Scalars['Float']['input']
  size: Scalars['Float']['input']
}

export type QueryMyTimelineEventsArgs = {
  input: MyCollaboratorsTimelineInput
}

export type QueryNodeByIdArgs = {
  id: Scalars['ID']['input']
}

export type QueryNodeMembersByNodeIdArgs = {
  input: QueryNodeMemberInput
}

export type QueryNodeStatsArgs = {
  input: NodeStatsInput
}

export type QueryNodeTierArgs = {
  id: Scalars['ID']['input']
}

export type QueryNodeTiersArgs = {
  filter?: InputMaybe<NodeTierFilterInput>
  pagination?: InputMaybe<PaginationInput>
}

export type QueryNodeTopContributionsArgs = {
  input: NodeTopContributionsInput
}

export type QueryNodeTopPerspectivesArgs = {
  input: NodeTopPerspectivesInput
}

export type QueryNodeTopUsersArgs = {
  input: NodeTopUsersInput
}

export type QueryPendingTasksArgs = {
  targetId?: InputMaybe<Scalars['String']['input']>
}

export type QueryReservedContributionArgs = {
  articleId: Scalars['ID']['input']
}

export type QuerySearchArgs = {
  input: SearchInput
}

export type QuerySuggestUsernameArgs = {
  input: SuggestUsernameInput
}

export type QueryUserArgs = {
  id: Scalars['ID']['input']
}

export type QueryUserCorankArgs = {
  nodeId?: InputMaybe<Scalars['ID']['input']>
  userId: Scalars['ID']['input']
}

export type QueryUserTimelineEventsArgs = {
  input: MyCollaboratorsTimelineInput
  userId: Scalars['String']['input']
}

export type QueryUserTokensArgs = {
  type?: InputMaybe<Scalars['String']['input']>
}

export type QueryUserTotalContributionsArgs = {
  userId: Scalars['ID']['input']
}

export type QueryUserTotalPerspectivesArgs = {
  userId: Scalars['ID']['input']
}

export type QueryUsernameAvailableArgs = {
  username: Scalars['String']['input']
}

export type QueryUsersBySearchUsernameArgs = {
  input: SearchUserNameInput
}

export type QueryValidAppAccessKeyArgs = {
  code: Scalars['String']['input']
}

export type QueryValidInvitationArgs = {
  codeOrId: Scalars['String']['input']
}

export type QueryArticleVoteInput = {
  articleId: Scalars['ID']['input']
  limit?: InputMaybe<Scalars['Float']['input']>
  offset?: InputMaybe<Scalars['Float']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<Scalars['String']['input']>
}

export type QueryNodeMemberInput = {
  limit?: InputMaybe<Scalars['Float']['input']>
  nodeId: Scalars['ID']['input']
  offset?: InputMaybe<Scalars['Float']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<Scalars['String']['input']>
}

export type RefreshTokenInput = {
  id: Scalars['Float']['input']
}

export type RegisterPushTokenInput = {
  token: Scalars['String']['input']
}

export type RegisterPushTokenPayload = {
  __typename?: 'RegisterPushTokenPayload'
  success: Scalars['Boolean']['output']
}

export type RegisterResponse = {
  __typename?: 'RegisterResponse'
  accessToken: Scalars['String']['output']
  refreshToken: Scalars['String']['output']
  sub: Scalars['Float']['output']
  user: User
}

export type RemoveArticleVoteInput = {
  articleId: Scalars['ID']['input']
}

export type RemoveCollaboratorFromListInput = {
  collaboratorId: Scalars['String']['input']
  listId: Scalars['String']['input']
}

export type RenovateNodeTierPayload = {
  __typename?: 'RenovateNodeTierPayload'
  month?: Maybe<Scalars['Float']['output']>
  nodeTiers: Array<NodeTierDetail>
  year?: Maybe<Scalars['Float']['output']>
}

export type RequestMobileVerificationCodeResponse = {
  __typename?: 'RequestMobileVerificationCodeResponse'
  isSent: Scalars['Boolean']['output']
}

export type RequestMobileVerificationInput = {
  /** mobile code */
  mobileCountryCode: Scalars['Int']['input']
  mobileNumber: Scalars['String']['input']
}

export type RequestOtpInput = {
  /** mobile code */
  mobileCountryCode?: InputMaybe<Scalars['Int']['input']>
  mobileNumber?: InputMaybe<Scalars['String']['input']>
  username?: InputMaybe<Scalars['String']['input']>
}

export type RequestOtpResponse = {
  __typename?: 'RequestOtpResponse'
  isSent: Scalars['Boolean']['output']
}

export type ReserveContributionInput = {
  articleId: Scalars['ID']['input']
  basedOnVersion: Scalars['Int']['input']
  begin: Scalars['Int']['input']
  clusterId: Scalars['ID']['input']
  end: Scalars['Int']['input']
  intendedType?: InputMaybe<ContributionType>
}

export type SearchInput = {
  limit?: InputMaybe<Scalars['Float']['input']>
  nodeId: Scalars['String']['input']
  offset?: InputMaybe<Scalars['Float']['input']>
  query: Scalars['String']['input']
}

export type SearchResult = {
  __typename?: 'SearchResult'
  article_content: Scalars['String']['output']
  article_created_at: Scalars['DateTime']['output']
  article_id: Scalars['String']['output']
  article_title: Scalars['String']['output']
  article_updated_at: Scalars['DateTime']['output']
  cluster_id: Scalars['String']['output']
  cluster_topic: Scalars['String']['output']
  match_type: Scalars['String']['output']
  node_id: Scalars['String']['output']
}

export type SearchUserNameInput = {
  limit?: InputMaybe<Scalars['Float']['input']>
  nodeId?: InputMaybe<Scalars['ID']['input']>
  offset?: InputMaybe<Scalars['Float']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<Scalars['String']['input']>
  username: Scalars['String']['input']
}

export type SignUpInput = {
  appAccessKey: Scalars['String']['input']
  firstName: Scalars['String']['input']
  googleToken?: InputMaybe<GoogleTokenInput>
  lastName: Scalars['String']['input']
  /** mobile_country_code */
  mobileCountryCode: Scalars['Int']['input']
  mobileNumber: Scalars['String']['input']
  smsCode: Scalars['String']['input']
  username?: InputMaybe<Scalars['String']['input']>
  wechatCode?: InputMaybe<Scalars['String']['input']>
}

export enum SocketEvents {
  Refresh = 'REFRESH',
  TaskCompleted = 'TASK_COMPLETED',
  TimelineUpdate = 'TIMELINE_UPDATE',
}

export type SubmitContributionInput = {
  contributionId: Scalars['ID']['input']
  input: Scalars['String']['input']
  motivation?: InputMaybe<Scalars['String']['input']>
  type: ContributionType
}

export type SubscribeWebPushInput = {
  deviceInfo?: InputMaybe<Scalars['String']['input']>
  subscription: Scalars['String']['input']
}

export type SuggestUsernameInput = {
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
}

export type SuggestUsernamePayload = {
  __typename?: 'SuggestUsernamePayload'
  username: Scalars['String']['output']
}

export enum TargetType {
  Article = 'ARTICLE',
  Cluster = 'CLUSTER',
  Contribution = 'CONTRIBUTION',
  Node = 'NODE',
}

export type TaskCollaboratorInviteDto = {
  __typename?: 'TaskCollaboratorInviteDto'
  createdAt: Scalars['DateTime']['output']
  id: Scalars['String']['output']
  invitedBy: User
  invitedById: Scalars['String']['output']
  taskId: Scalars['String']['output']
  user: User
  userId: Scalars['String']['output']
}

export type TaskContributorResponse = {
  __typename?: 'TaskContributorResponse'
  count: Scalars['Float']['output']
  results: Array<TasksContributor>
}

export type TaskIdInput = {
  taskId: Scalars['ID']['input']
}

export type TaskType = {
  __typename?: 'TaskType'
  type?: Maybe<Array<Scalars['String']['output']>>
  value?: Maybe<Array<Scalars['String']['output']>>
}

export type Tasks = {
  __typename?: 'Tasks'
  archivedAt: Scalars['DateTime']['output']
  assigned?: Maybe<User>
  assignedId?: Maybe<Scalars['ID']['output']>
  completedAt: Scalars['DateTime']['output']
  createdAt: Scalars['DateTime']['output']
  id: Scalars['String']['output']
  isArchived: Scalars['Boolean']['output']
  isCompleted: Scalars['Boolean']['output']
  owner?: Maybe<User>
  targetId: Scalars['String']['output']
  targetType: Scalars['String']['output']
  title: Scalars['String']['output']
  type: Scalars['String']['output']
}

export type TasksContributor = {
  __typename?: 'TasksContributor'
  completedAt?: Maybe<Scalars['DateTime']['output']>
  createdAt: Scalars['DateTime']['output']
  id: Scalars['String']['output']
  isCompleted: Scalars['Boolean']['output']
  task: Tasks
  taskId: Scalars['ID']['output']
  user: User
  userId: Scalars['ID']['output']
}

export type TasksResponse = {
  __typename?: 'TasksResponse'
  count: Scalars['Float']['output']
  results: Array<Tasks>
}

export type TierConfigDto = {
  __typename?: 'TierConfigDto'
  layout: Scalars['String']['output']
  name: Scalars['String']['output']
  seat_price: Scalars['Float']['output']
  visibility: Scalars['String']['output']
}

export type TierCostDetail = {
  __typename?: 'TierCostDetail'
  activeUsers: Scalars['Float']['output']
  basePrice: Scalars['Float']['output']
  extraSeatPrice: Scalars['Float']['output']
  extraSeats: Scalars['Float']['output']
  nodeId: Scalars['String']['output']
  nodeName: Scalars['String']['output']
  seats: Scalars['Float']['output']
  tierName: Scalars['String']['output']
  totalTierCost: Scalars['Float']['output']
}

export type TierDowngradePayload = {
  __typename?: 'TierDowngradePayload'
  basePrice?: Maybe<Scalars['Float']['output']>
  currentTierId?: Maybe<Scalars['String']['output']>
  fromSeats?: Maybe<Scalars['Float']['output']>
  isPrivate?: Maybe<Scalars['Boolean']['output']>
  nodeId?: Maybe<Scalars['String']['output']>
  seats?: Maybe<Scalars['Float']['output']>
  tierName?: Maybe<Scalars['String']['output']>
  toSeats?: Maybe<Scalars['Float']['output']>
}

export type TierUpgradePayload = {
  __typename?: 'TierUpgradePayload'
  basePrice?: Maybe<Scalars['Float']['output']>
  currentTierId?: Maybe<Scalars['String']['output']>
  fromSeats?: Maybe<Scalars['Float']['output']>
  isPrivate?: Maybe<Scalars['Boolean']['output']>
  nodeId?: Maybe<Scalars['String']['output']>
  seats?: Maybe<Scalars['Float']['output']>
  tierName?: Maybe<Scalars['String']['output']>
  toSeats?: Maybe<Scalars['Float']['output']>
}

export type TimeLine = {
  __typename?: 'TimeLine'
  action: TimeLineAction
  anonymous: Scalars['Boolean']['output']
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  isNew: Scalars['Boolean']['output']
  nodeName?: Maybe<Scalars['String']['output']>
  payload: TimelinePayloadBase
  targetId: Scalars['String']['output']
  targetType: TargetType
  timestamp: Scalars['DateTime']['output']
  title: Scalars['String']['output']
  tree: Array<TreeNode>
  user?: Maybe<User>
  userId?: Maybe<Scalars['ID']['output']>
}

export enum TimeLineAction {
  ChallengeContributionCreated = 'CHALLENGE_CONTRIBUTION_CREATED',
  ClusterCreated = 'CLUSTER_CREATED',
  ClusterDeleted = 'CLUSTER_DELETED',
  ClusterUpdated = 'CLUSTER_UPDATED',
  ContributionApproved = 'CONTRIBUTION_APPROVED',
  ContributionBumpedDown = 'CONTRIBUTION_BUMPED_DOWN',
  ContributionBumpedUp = 'CONTRIBUTION_BUMPED_UP',
  ContributionBumpCancelled = 'CONTRIBUTION_BUMP_CANCELLED',
  ContributionCancelled = 'CONTRIBUTION_CANCELLED',
  ContributionCensured = 'CONTRIBUTION_CENSURED',
  ContributionRejected = 'CONTRIBUTION_REJECTED',
  CorankUpdated = 'CORANK_UPDATED',
  EditContributionCreated = 'EDIT_CONTRIBUTION_CREATED',
  InquiryContributionCreated = 'INQUIRY_CONTRIBUTION_CREATED',
  NodeCreated = 'NODE_CREATED',
  NodeDeleted = 'NODE_DELETED',
  NodeUpdated = 'NODE_UPDATED',
  OwnerEditContributionCreated = 'OWNER_EDIT_CONTRIBUTION_CREATED',
  PerspectiveCreated = 'PERSPECTIVE_CREATED',
  PerspectiveDeleted = 'PERSPECTIVE_DELETED',
  PerspectiveTransferred = 'PERSPECTIVE_TRANSFERRED',
  PerspectiveUpdated = 'PERSPECTIVE_UPDATED',
  PerspectiveVote = 'PERSPECTIVE_VOTE',
  PerspectiveVoteRemoved = 'PERSPECTIVE_VOTE_REMOVED',
  TaskCreated = 'TASK_CREATED',
}

export type TimeLineObject = {
  __typename?: 'TimeLineObject'
  action: TimeLineAction
  anonymous: Scalars['Boolean']['output']
  payload: TimelinePayloadBase
  target: TargetType
  targetId: Scalars['String']['output']
  timestamp: Scalars['String']['output']
  tree: Array<TreeNode>
  user: TimelineUser
  version?: Maybe<Scalars['String']['output']>
}

export type TimelineListInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>
  limit?: InputMaybe<Scalars['Float']['input']>
  offset?: InputMaybe<Scalars['Float']['input']>
  sort?: InputMaybe<Scalars['String']['input']>
  targetId: Scalars['ID']['input']
  targetType: Scalars['String']['input']
  to?: InputMaybe<Scalars['DateTime']['input']>
}

export type TimelineListResponse = {
  __typename?: 'TimelineListResponse'
  results: Array<TimeLine>
  total: Scalars['Float']['output']
}

export type TimelinePayloadBase = {
  __typename?: 'TimelinePayloadBase'
  articleId?: Maybe<Scalars['String']['output']>
  clusterId?: Maybe<Scalars['String']['output']>
  coRank?: Maybe<Scalars['Float']['output']>
  coRankNodeScope?: Maybe<CoRankNodeScope>
  content?: Maybe<Scalars['String']['output']>
  contributionId?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  end?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  isPrivate?: Maybe<Scalars['Boolean']['output']>
  minCoRank?: Maybe<Scalars['Float']['output']>
  motivation?: Maybe<Scalars['String']['output']>
  newOwnerId?: Maybe<Scalars['String']['output']>
  nodeId?: Maybe<Scalars['String']['output']>
  originalText?: Maybe<Scalars['String']['output']>
  reason?: Maybe<Scalars['String']['output']>
  start?: Maybe<Scalars['String']['output']>
  targetId?: Maybe<Scalars['String']['output']>
  targetType?: Maybe<Scalars['String']['output']>
  taskId?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
  type?: Maybe<Scalars['String']['output']>
  userId?: Maybe<Scalars['String']['output']>
  username?: Maybe<Scalars['String']['output']>
}

export type TimelinePositionResponse = {
  __typename?: 'TimelinePositionResponse'
  position: Scalars['Float']['output']
  total: Scalars['Float']['output']
}

export type TimelineTargetInput = {
  targetId: Scalars['ID']['input']
  targetType: Scalars['String']['input']
}

export type TimelineUser = {
  __typename?: 'TimelineUser'
  id: Scalars['String']['output']
  username: Scalars['String']['output']
}

export type TransferArticleOwnershipInput = {
  articleId: Scalars['ID']['input']
  newOwnerId: Scalars['ID']['input']
}

export type TransferClusterOwnershipInput = {
  clusterId: Scalars['ID']['input']
  newOwnerId: Scalars['ID']['input']
}

export type TransferClusterToNodeInput = {
  clusterId: Scalars['ID']['input']
  newNodeId: Scalars['ID']['input']
}

export type TransferOwnershipInput = {
  newOwnerId: Scalars['ID']['input']
  nodeId: Scalars['ID']['input']
}

export type TreeNode = {
  __typename?: 'TreeNode'
  id: Scalars['String']['output']
  target: TargetType
}

export type UpdateArticleInput = {
  id: Scalars['ID']['input']
  isAutoTitle?: InputMaybe<Scalars['Boolean']['input']>
  minCoRank?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type UpdateClusterInput = {
  clusterId: Scalars['ID']['input']
  isPrivate: Scalars['Boolean']['input']
  showModerators: Scalars['Boolean']['input']
  showPerspectiveOwners: Scalars['Boolean']['input']
  topic: Scalars['String']['input']
}

export type UpdateClusterMemberInput = {
  id: Scalars['ID']['input']
  isModerator: Scalars['Boolean']['input']
}

export type UpdateCollaboratorListInput = {
  color?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type UpdateContributionInput = {
  contributionId: Scalars['ID']['input']
  response?: InputMaybe<Scalars['String']['input']>
  status: ContributionStatus
}

export type UpdateCouponInput = {
  /** Set or clear admin-only label; omit to leave unchanged */
  adminLabel?: InputMaybe<Scalars['String']['input']>
  appliedMonths?: InputMaybe<Scalars['Int']['input']>
  discountPercentage?: InputMaybe<Scalars['Int']['input']>
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['ID']['input']
  maxRedeems?: InputMaybe<Scalars['Int']['input']>
  validTo?: InputMaybe<Scalars['DateTime']['input']>
}

export type UpdateNodeInput = {
  allowExtraSeats?: InputMaybe<Scalars['Boolean']['input']>
  description: Scalars['String']['input']
  id: Scalars['ID']['input']
  name: Scalars['String']['input']
}

export type UpdateNodeMemberInput = {
  id: Scalars['ID']['input']
  isAdmin: Scalars['Boolean']['input']
}

export type UpdateUserInput = {
  bio?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  lastName?: InputMaybe<Scalars['String']['input']>
  username?: InputMaybe<Scalars['String']['input']>
}

export type UpgradeNodeTierInput = {
  nodeTierId: Scalars['ID']['input']
  seats: Scalars['Int']['input']
}

export type User = {
  __typename?: 'User'
  bio?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  emailAddress?: Maybe<Scalars['String']['output']>
  firstName: Scalars['String']['output']
  googleSync?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  incompleteTasks?: Maybe<Array<Tasks>>
  isClusterMember?: Maybe<Scalars['Boolean']['output']>
  isEmailVerified?: Maybe<Scalars['Boolean']['output']>
  isMobileVerified?: Maybe<Scalars['Boolean']['output']>
  isNodeMember?: Maybe<Scalars['Boolean']['output']>
  isPushNotificationsEnabled: Scalars['Boolean']['output']
  isSuperAdmin: Scalars['Boolean']['output']
  lastName: Scalars['String']['output']
  mobileCountryCode?: Maybe<Scalars['Int']['output']>
  mobileNumber?: Maybe<Scalars['String']['output']>
  notificationsDeviceInfo?: Maybe<Scalars['String']['output']>
  publicCoRank?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  username: Scalars['String']['output']
  wechatSync?: Maybe<Scalars['Boolean']['output']>
}

export type UserIsClusterMemberArgs = {
  clusterId?: InputMaybe<Scalars['String']['input']>
}

export type UserIsNodeMemberArgs = {
  nodeId?: InputMaybe<Scalars['String']['input']>
}

export type UserTokenDto = {
  __typename?: 'UserTokenDto'
  createdAt: Scalars['DateTime']['output']
  errorMessage?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  isDefault: Scalars['Boolean']['output']
  source: Scalars['String']['output']
  type: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
  userId: Scalars['String']['output']
}

export type UserWithCoRank = {
  __typename?: 'UserWithCoRank'
  coRank: Scalars['Float']['output']
  dbPosition: Scalars['Int']['output']
  user: User
}

export type UsernameAvailablePayload = {
  __typename?: 'UsernameAvailablePayload'
  isAvailable: Scalars['Boolean']['output']
  message?: Maybe<Scalars['String']['output']>
}

export type ValidAppAccessKeyPayload = {
  __typename?: 'ValidAppAccessKeyPayload'
  isValid: Scalars['Boolean']['output']
}

export type ValidInvitation = {
  __typename?: 'ValidInvitation'
  invitation: Invitation
  isMember: Scalars['Boolean']['output']
}

export type VerifyMobileInput = {
  mobileCountryCode: Scalars['Float']['input']
  mobileNumber: Scalars['String']['input']
  otp: Scalars['String']['input']
}

export type WechatJdkSignatureInput = {
  url: Scalars['String']['input']
}

export type WechatJdkSignatureResponse = {
  __typename?: 'WechatJDKSignatureResponse'
  nonceStr: Scalars['String']['output']
  signature: Scalars['String']['output']
  timestamp: Scalars['String']['output']
}

export type WechatLoginInput = {
  code: Scalars['String']['input']
  provider: Scalars['String']['input']
}

/** WeChat Pay payment method type */
export enum WechatPayMethod {
  H5 = 'H5',
  Jsapi = 'JSAPI',
  Native = 'NATIVE',
}

export type WechatPayOrderDto = {
  __typename?: 'WechatPayOrderDto'
  codeUrl?: Maybe<Scalars['String']['output']>
  h5Url?: Maybe<Scalars['String']['output']>
  paymentMethod: Scalars['String']['output']
  paymentParameters?: Maybe<WechatPayPaymentParameters>
  prepayId?: Maybe<Scalars['String']['output']>
}

export type WechatPayPaymentParameters = {
  __typename?: 'WechatPayPaymentParameters'
  appId: Scalars['String']['output']
  nonceStr: Scalars['String']['output']
  package: Scalars['String']['output']
  paySign: Scalars['String']['output']
  signType: Scalars['String']['output']
  timeStamp: Scalars['String']['output']
}

export type AdminStatsForRangeQueryVariables = Exact<{
  from: Scalars['DateTime']['input']
  to: Scalars['DateTime']['input']
}>

export type AdminStatsForRangeQuery = {
  __typename?: 'Query'
  adminStatsForRange: {
    __typename?: 'AdminPeriodStats'
    activeUsers: number
    newNodes: number
    billingTotal: number
  }
}

export type VoteDetailFragment = {
  __typename?: 'ArticleVote'
  id: string
  userId: string
  clusterId: string
  articleId: string
  justification?: string | null
  user: { __typename?: 'User'; id: string; username: string }
}

export type PlaceVoteMutationVariables = Exact<{
  input: PlaceArticleVoteInput
}>

export type PlaceVoteMutation = {
  __typename?: 'Mutation'
  placeArticleVote: Array<{
    __typename?: 'ArticleVote'
    id: string
    userId: string
    clusterId: string
    articleId: string
    justification?: string | null
    user: { __typename?: 'User'; id: string; username: string }
  }>
}

export type RemoveVoteMutationVariables = Exact<{
  input: RemoveArticleVoteInput
}>

export type RemoveVoteMutation = {
  __typename?: 'Mutation'
  removeArticleVote: Array<{
    __typename?: 'ArticleVote'
    id: string
    userId: string
    clusterId: string
    articleId: string
    justification?: string | null
    user: { __typename?: 'User'; id: string; username: string }
  }>
}

export type ArticleVotesByArticleIdQueryVariables = Exact<{
  input: QueryArticleVoteInput
}>

export type ArticleVotesByArticleIdQuery = {
  __typename?: 'Query'
  articleVotesByArticleId: {
    __typename?: 'ArticleVoteListDto'
    total: number
    results: Array<{
      __typename?: 'ArticleVote'
      id: string
      userId: string
      clusterId: string
      articleId: string
      justification?: string | null
      user: { __typename?: 'User'; id: string; username: string }
    }>
  }
}

export type ArticleDetailFragment = {
  __typename?: 'Article'
  id: string
  title: string
  ownerId?: string | null
  clusterId: string
  isAutoTitle: boolean
  version: number
  isOwner: boolean
  minCoRank?: number | null
  cluster: { __typename?: 'Cluster'; id: string; nodeId: string; topic: string }
  owner?: { __typename?: 'User'; id: string; username: string } | null
}

export type ArticlesForClusterQueryVariables = Exact<{
  input: ArticleListInput
}>

export type ArticlesForClusterQuery = {
  __typename?: 'Query'
  articlesForCluster: {
    __typename?: 'ArticleListResponse'
    total: number
    results: Array<{
      __typename?: 'Article'
      hasUserVote: boolean
      voteCount: number
      contributionCount: number
      id: string
      title: string
      ownerId?: string | null
      clusterId: string
      isAutoTitle: boolean
      version: number
      isOwner: boolean
      minCoRank?: number | null
      contributions: Array<{
        __typename?: 'Contribution'
        input?: string | null
        response?: string | null
        motivation?: string | null
        originalText: string
        intendedType?: ContributionType | null
        reservedUntil?: any | null
        begin: number
        end: number
        id: string
        articleId: string
        status: ContributionStatus
        userId: string
        decisionAt?: any | null
        contributionType: ContributionType
        createdAt: any
        user?: {
          __typename?: 'User'
          id: string
          username: string
          firstName: string
          lastName: string
        } | null
      }>
      cluster: {
        __typename?: 'Cluster'
        id: string
        nodeId: string
        topic: string
      }
      owner?: { __typename?: 'User'; id: string; username: string } | null
    }>
  }
}

export type ArticlesForUserQueryVariables = Exact<{
  userId: Scalars['ID']['input']
}>

export type ArticlesForUserQuery = {
  __typename?: 'Query'
  articlesForUser: Array<{
    __typename?: 'Article'
    contributionCount: number
    id: string
    title: string
    ownerId?: string | null
    clusterId: string
    isAutoTitle: boolean
    version: number
    isOwner: boolean
    minCoRank?: number | null
    cluster: {
      __typename?: 'Cluster'
      id: string
      nodeId: string
      topic: string
    }
    owner?: { __typename?: 'User'; id: string; username: string } | null
  }>
}

export type ArticleQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ArticleQuery = {
  __typename?: 'Query'
  article: {
    __typename?: 'Article'
    originalContent: string
    latestContent: string
    voteCount: number
    hasUserVote: boolean
    id: string
    title: string
    ownerId?: string | null
    clusterId: string
    isAutoTitle: boolean
    version: number
    isOwner: boolean
    minCoRank?: number | null
    contributions: Array<{
      __typename?: 'Contribution'
      input?: string | null
      response?: string | null
      motivation?: string | null
      originalText: string
      intendedType?: ContributionType | null
      reservedUntil?: any | null
      begin: number
      end: number
      id: string
      articleId: string
      status: ContributionStatus
      userId: string
      decisionAt?: any | null
      contributionType: ContributionType
      createdAt: any
      user?: {
        __typename?: 'User'
        id: string
        username: string
        firstName: string
        lastName: string
      } | null
    }>
    cluster: {
      __typename?: 'Cluster'
      id: string
      nodeId: string
      topic: string
    }
    owner?: { __typename?: 'User'; id: string; username: string } | null
  }
}

export type ArticlePathQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ArticlePathQuery = {
  __typename?: 'Query'
  article: {
    __typename?: 'Article'
    id: string
    cluster: { __typename?: 'Cluster'; id: string; nodeId: string }
  }
}

export type ArticleContributorsQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ArticleContributorsQuery = {
  __typename?: 'Query'
  article: {
    __typename?: 'Article'
    id: string
    contributors: Array<{ __typename?: 'User'; id: string; username: string }>
  }
}

export type CreateArticleMutationVariables = Exact<{
  input: CreateArticleInput
}>

export type CreateArticleMutation = {
  __typename?: 'Mutation'
  createArticle: {
    __typename?: 'Article'
    latestContent: string
    id: string
    title: string
    ownerId?: string | null
    clusterId: string
    isAutoTitle: boolean
    version: number
    isOwner: boolean
    minCoRank?: number | null
    cluster: {
      __typename?: 'Cluster'
      id: string
      nodeId: string
      topic: string
    }
    owner?: { __typename?: 'User'; id: string; username: string } | null
  }
}

export type UpdateArticleMutationVariables = Exact<{
  input: UpdateArticleInput
}>

export type UpdateArticleMutation = {
  __typename?: 'Mutation'
  updateArticle: {
    __typename?: 'Article'
    latestContent: string
    id: string
    title: string
    ownerId?: string | null
    clusterId: string
    isAutoTitle: boolean
    version: number
    isOwner: boolean
    minCoRank?: number | null
    cluster: {
      __typename?: 'Cluster'
      id: string
      nodeId: string
      topic: string
    }
    owner?: { __typename?: 'User'; id: string; username: string } | null
  }
}

export type DeleteArticleMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DeleteArticleMutation = {
  __typename?: 'Mutation'
  deleteArticle: string
}

export type TransferArticleOwnershipMutationVariables = Exact<{
  input: TransferArticleOwnershipInput
}>

export type TransferArticleOwnershipMutation = {
  __typename?: 'Mutation'
  transferArticleOwnership: {
    __typename?: 'Article'
    latestContent: string
    id: string
    title: string
    ownerId?: string | null
    clusterId: string
    isAutoTitle: boolean
    version: number
    isOwner: boolean
    minCoRank?: number | null
    cluster: {
      __typename?: 'Cluster'
      id: string
      nodeId: string
      topic: string
    }
    owner?: { __typename?: 'User'; id: string; username: string } | null
  }
}

export type ExportDocxQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ExportDocxQuery = { __typename?: 'Query'; exportDocx: string }

export type CheckUniqTitleQueryVariables = Exact<{
  title: Scalars['String']['input']
  clusterId: Scalars['ID']['input']
}>

export type CheckUniqTitleQuery = {
  __typename?: 'Query'
  checkUniqTitle: boolean
}

export type GetBillingsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>
  filter?: InputMaybe<BillingFilterInput>
}>

export type GetBillingsQuery = {
  __typename?: 'Query'
  billings: Array<{
    __typename?: 'Billing'
    id: string
    billingId: string
    amount: number
    status: string
    type: string
    billingType: string
    description: string
    createdAt: any
    updatedAt: any
    paidAt?: any | null
    paymentMethod?: string | null
    transactionId?: string | null
    userId: string
    renovatePayload?: {
      __typename?: 'RenovateNodeTierPayload'
      month?: number | null
      year?: number | null
      nodeTiers: Array<{
        __typename?: 'NodeTierDetail'
        currentTierId: string
        nodeId: string
        nodeName?: string | null
        tierName: string
        seats: number
        isPrivate: boolean
        pricing: number
        basePrice?: number | null
        activeUsers?: number | null
        extraSeats?: number | null
        extraSeatPrice?: number | null
      }>
    } | null
    newNodeTierPayload?: {
      __typename?: 'NewNodeTierPayload'
      tierName?: string | null
      seats?: number | null
      isPrivate?: boolean | null
      nodeName?: string | null
      nodeDescription?: string | null
      basePrice?: number | null
    } | null
    tierUpgradePayload?: {
      __typename?: 'TierUpgradePayload'
      currentTierId?: string | null
      nodeId?: string | null
      tierName?: string | null
      fromSeats?: number | null
      toSeats?: number | null
      seats?: number | null
      isPrivate?: boolean | null
      basePrice?: number | null
    } | null
    tierDowngradePayload?: {
      __typename?: 'TierDowngradePayload'
      currentTierId?: string | null
      nodeId?: string | null
      tierName?: string | null
      fromSeats?: number | null
      toSeats?: number | null
      seats?: number | null
      isPrivate?: boolean | null
      basePrice?: number | null
    } | null
  }>
}

export type CreatePaypalOrderMutationVariables = Exact<{
  input: CreatePaypalOrderInput
}>

export type CreatePaypalOrderMutation = {
  __typename?: 'Mutation'
  createPaypalOrder: { __typename?: 'PaypalOrderDto'; id: string }
}

export type CreatePaypalVaultSetupOrderMutationVariables = Exact<{
  returnUrl: Scalars['String']['input']
  cancelUrl: Scalars['String']['input']
}>

export type CreatePaypalVaultSetupOrderMutation = {
  __typename?: 'Mutation'
  createPaypalVaultSetupOrder: { __typename?: 'PaypalOrderDto'; id: string }
}

export type ProcessCouponBillingMutationVariables = Exact<{
  billingId: Scalars['ID']['input']
  couponCode: Scalars['String']['input']
}>

export type ProcessCouponBillingMutation = {
  __typename?: 'Mutation'
  processCouponBilling: boolean
}

export type CreateWechatPayOrderMutationVariables = Exact<{
  input: CreateWechatPayOrderInput
}>

export type CreateWechatPayOrderMutation = {
  __typename?: 'Mutation'
  createWechatPayOrder: {
    __typename?: 'WechatPayOrderDto'
    prepayId?: string | null
    paymentMethod: string
    codeUrl?: string | null
    h5Url?: string | null
    paymentParameters?: {
      __typename?: 'WechatPayPaymentParameters'
      appId: string
      timeStamp: string
      nonceStr: string
      package: string
      signType: string
      paySign: string
    } | null
  }
}

export type ClusterMemberDetailFragment = {
  __typename?: 'ClusterMember'
  id: string
  clusterId: string
  userId: string
  isModerator: boolean
  user: {
    __typename?: 'User'
    id: string
    username: string
    firstName: string
    lastName: string
  }
}

export type UpdateClusterMemberMutationVariables = Exact<{
  input: UpdateClusterMemberInput
}>

export type UpdateClusterMemberMutation = {
  __typename?: 'Mutation'
  updateClusterMember: {
    __typename?: 'ClusterMember'
    id: string
    clusterId: string
    userId: string
    isModerator: boolean
    user: {
      __typename?: 'User'
      id: string
      username: string
      firstName: string
      lastName: string
    }
  }
}

export type CreateClusterMemberMutationVariables = Exact<{
  input: CreateClusterMemberInput
}>

export type CreateClusterMemberMutation = {
  __typename?: 'Mutation'
  createClusterMember: {
    __typename?: 'ClusterMember'
    id: string
    clusterId: string
    userId: string
    isModerator: boolean
    user: {
      __typename?: 'User'
      id: string
      username: string
      firstName: string
      lastName: string
    }
  }
}

export type RemoveClusterMemberMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type RemoveClusterMemberMutation = {
  __typename?: 'Mutation'
  removeClusterMember: string
}

export type TransferClusterOwnershipMutationVariables = Exact<{
  input: TransferClusterOwnershipInput
}>

export type TransferClusterOwnershipMutation = {
  __typename?: 'Mutation'
  transferClusterOwnership: {
    __typename?: 'Cluster'
    isOwner: boolean
    isModerator: boolean
    id: string
    isPrivate: boolean
    showModerators: boolean
    showPerspectiveOwners: boolean
    nodeId: string
    topic: string
    contentUpdatedAt: any
    ownerId?: string | null
  }
}

export type RemoveSelfFromClusterMutationVariables = Exact<{
  clusterId: Scalars['ID']['input']
}>

export type RemoveSelfFromClusterMutation = {
  __typename?: 'Mutation'
  removeSelfFromCluster: string
}

export type GetMembersByClusterIdQueryVariables = Exact<{
  clusterId: Scalars['ID']['input']
}>

export type GetMembersByClusterIdQuery = {
  __typename?: 'Query'
  clusterMembersByClusterId: Array<{
    __typename?: 'ClusterMember'
    id: string
    clusterId: string
    userId: string
    isModerator: boolean
    user: {
      __typename?: 'User'
      id: string
      username: string
      firstName: string
      lastName: string
    }
  }>
}

export type ClusterDetailFragment = {
  __typename?: 'Cluster'
  id: string
  isPrivate: boolean
  showModerators: boolean
  showPerspectiveOwners: boolean
  nodeId: string
  topic: string
  contentUpdatedAt: any
  ownerId?: string | null
  isOwner: boolean
  isModerator: boolean
}

export type CreateClusterMutationVariables = Exact<{
  input: CreateClusterInput
}>

export type CreateClusterMutation = {
  __typename?: 'Mutation'
  createCluster: {
    __typename?: 'Cluster'
    id: string
    isPrivate: boolean
    showModerators: boolean
    showPerspectiveOwners: boolean
    nodeId: string
    topic: string
    contentUpdatedAt: any
    ownerId?: string | null
    isOwner: boolean
    isModerator: boolean
    moderators: Array<{
      __typename?: 'ClusterMember'
      id: string
      clusterId: string
      userId: string
      isModerator: boolean
      user: {
        __typename?: 'User'
        id: string
        username: string
        firstName: string
        lastName: string
      }
    }>
  }
}

export type UpdateClusterMutationVariables = Exact<{
  input: UpdateClusterInput
}>

export type UpdateClusterMutation = {
  __typename?: 'Mutation'
  updateCluster: {
    __typename?: 'Cluster'
    id: string
    isPrivate: boolean
    showModerators: boolean
    showPerspectiveOwners: boolean
    nodeId: string
    topic: string
    contentUpdatedAt: any
    ownerId?: string | null
    isOwner: boolean
    isModerator: boolean
    moderators: Array<{
      __typename?: 'ClusterMember'
      id: string
      clusterId: string
      userId: string
      isModerator: boolean
      user: {
        __typename?: 'User'
        id: string
        username: string
        firstName: string
        lastName: string
      }
    }>
  }
}

export type DeleteClusterMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DeleteClusterMutation = {
  __typename?: 'Mutation'
  deleteCluster: string
}

export type AvailableClustersQueryVariables = Exact<{
  input: ClusterListInput
}>

export type AvailableClustersQuery = {
  __typename?: 'Query'
  availableClusters: Array<{
    __typename?: 'Cluster'
    articlesCount: number
    votesCount: number
    id: string
    isPrivate: boolean
    showModerators: boolean
    showPerspectiveOwners: boolean
    nodeId: string
    topic: string
    contentUpdatedAt: any
    ownerId?: string | null
    isOwner: boolean
    isModerator: boolean
    moderators: Array<{
      __typename?: 'ClusterMember'
      id: string
      clusterId: string
      userId: string
      isModerator: boolean
      user: {
        __typename?: 'User'
        id: string
        username: string
        firstName: string
        lastName: string
      }
    }>
  }>
}

export type ClusterListQueryVariables = Exact<{
  input: ClusterListInput
}>

export type ClusterListQuery = {
  __typename?: 'Query'
  availableClusters: Array<{
    __typename?: 'Cluster'
    articlesCount: number
    contributionsCount: number
    votesCount: number
    id: string
    isPrivate: boolean
    showModerators: boolean
    showPerspectiveOwners: boolean
    nodeId: string
    topic: string
    contentUpdatedAt: any
    ownerId?: string | null
    isOwner: boolean
    isModerator: boolean
  }>
}

export type ClusterForPerspectiveQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ClusterForPerspectiveQuery = {
  __typename?: 'Query'
  cluster: {
    __typename?: 'Cluster'
    id: string
    isPrivate: boolean
    showModerators: boolean
    showPerspectiveOwners: boolean
    nodeId: string
    topic: string
    contentUpdatedAt: any
    ownerId?: string | null
    isOwner: boolean
    isModerator: boolean
    articleVotes: Array<{
      __typename?: 'ArticleVote'
      articleId: string
      userId: string
      justification?: string | null
      user: { __typename?: 'User'; id: string; username: string }
    }>
    articles: Array<{
      __typename?: 'Article'
      title: string
      latestContent: string
      originalContent: string
      id: string
      ownerId?: string | null
      clusterId: string
      isAutoTitle: boolean
      version: number
      isOwner: boolean
      minCoRank?: number | null
      contributions: Array<{
        __typename?: 'Contribution'
        id: string
        articleId: string
        status: ContributionStatus
        userId: string
        decisionAt?: any | null
        contributionType: ContributionType
        createdAt: any
        input?: string | null
        response?: string | null
        motivation?: string | null
        originalText: string
        user?: {
          __typename?: 'User'
          id: string
          username: string
          firstName: string
          lastName: string
        } | null
      }>
      cluster: {
        __typename?: 'Cluster'
        id: string
        nodeId: string
        topic: string
      }
      owner?: { __typename?: 'User'; id: string; username: string } | null
    }>
  }
}

export type ClusterByIdQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ClusterByIdQuery = {
  __typename?: 'Query'
  clusterById: {
    __typename?: 'Cluster'
    id: string
    isPrivate: boolean
    showModerators: boolean
    showPerspectiveOwners: boolean
    nodeId: string
    topic: string
    contentUpdatedAt: any
    ownerId?: string | null
    isOwner: boolean
    isModerator: boolean
  }
}

export type TransferClusterToNodeMutationVariables = Exact<{
  input: TransferClusterToNodeInput
}>

export type TransferClusterToNodeMutation = {
  __typename?: 'Mutation'
  transferClusterToNode: {
    __typename?: 'Cluster'
    nodeId: string
    id: string
    isPrivate: boolean
    showModerators: boolean
    showPerspectiveOwners: boolean
    topic: string
    contentUpdatedAt: any
    ownerId?: string | null
    isOwner: boolean
    isModerator: boolean
  }
}

export type ContributionBumpDetailFragment = {
  __typename?: 'ContributionBump'
  contributionId: string
  userId: string
  value: number
  reason: string
  updatedAt: any
  user: { __typename?: 'User'; id: string; username: string }
}

export type BumpsForContributionQueryVariables = Exact<{
  contributionId: Scalars['ID']['input']
}>

export type BumpsForContributionQuery = {
  __typename?: 'Query'
  contributionBumpsByContribution: Array<{
    __typename?: 'ContributionBump'
    contributionId: string
    userId: string
    value: number
    reason: string
    updatedAt: any
    user: { __typename?: 'User'; id: string; username: string }
  }>
}

export type BumpContributionMutationVariables = Exact<{
  input: BumpContributionInput
}>

export type BumpContributionMutation = {
  __typename?: 'Mutation'
  bumpContribution: {
    __typename?: 'ContributionBump'
    contributionId: string
    userId: string
    value: number
    reason: string
    updatedAt: any
    user: { __typename?: 'User'; id: string; username: string }
  }
}

export type ContributionDetailFragment = {
  __typename?: 'Contribution'
  id: string
  articleId: string
  status: ContributionStatus
  userId: string
  decisionAt?: any | null
  contributionType: ContributionType
  createdAt: any
  input?: string | null
  response?: string | null
  motivation?: string | null
  originalText: string
  user?: {
    __typename?: 'User'
    id: string
    username: string
    firstName: string
    lastName: string
  } | null
}

export type FullContributionDetailFragment = {
  __typename?: 'Contribution'
  clusterId: string
  id: string
  articleId: string
  status: ContributionStatus
  userId: string
  decisionAt?: any | null
  contributionType: ContributionType
  createdAt: any
  input?: string | null
  response?: string | null
  motivation?: string | null
  originalText: string
  user?: {
    __typename?: 'User'
    id: string
    username: string
    firstName: string
    lastName: string
  } | null
  article: {
    __typename?: 'Article'
    id: string
    clusterId: string
    title: string
    isOwner: boolean
  }
}

export type ContributionEditDetailFragment = {
  __typename?: 'Contribution'
  input?: string | null
  response?: string | null
  motivation?: string | null
  originalText: string
  intendedType?: ContributionType | null
  reservedUntil?: any | null
  begin: number
  end: number
  id: string
  articleId: string
  status: ContributionStatus
  userId: string
  decisionAt?: any | null
  contributionType: ContributionType
  createdAt: any
  user?: {
    __typename?: 'User'
    id: string
    username: string
    firstName: string
    lastName: string
  } | null
}

export type ContributionDetailWithNodeFragment = {
  __typename?: 'Contribution'
  clusterId: string
  id: string
  articleId: string
  status: ContributionStatus
  userId: string
  decisionAt?: any | null
  contributionType: ContributionType
  createdAt: any
  input?: string | null
  response?: string | null
  motivation?: string | null
  originalText: string
  article: {
    __typename?: 'Article'
    id: string
    clusterId: string
    title: string
    isOwner: boolean
    cluster: {
      __typename?: 'Cluster'
      id: string
      topic: string
      node: { __typename?: 'Node'; id: string; name: string }
    }
  }
  user?: {
    __typename?: 'User'
    id: string
    username: string
    firstName: string
    lastName: string
  } | null
}

export type ContributionResponseDetailFragment = {
  __typename?: 'ContributionResponse'
  percentage: number
  contributions: Array<{
    __typename?: 'Contribution'
    clusterId: string
    id: string
    articleId: string
    status: ContributionStatus
    userId: string
    decisionAt?: any | null
    contributionType: ContributionType
    createdAt: any
    input?: string | null
    response?: string | null
    motivation?: string | null
    originalText: string
    user?: {
      __typename?: 'User'
      id: string
      username: string
      firstName: string
      lastName: string
    } | null
    article: {
      __typename?: 'Article'
      id: string
      clusterId: string
      title: string
      isOwner: boolean
    }
  }>
}

export type PerTypeResponseDetailFragment = {
  __typename?: 'PerTypeResponse'
  inquiry: {
    __typename?: 'ContributionResponse'
    percentage: number
    contributions: Array<{
      __typename?: 'Contribution'
      clusterId: string
      id: string
      articleId: string
      status: ContributionStatus
      userId: string
      decisionAt?: any | null
      contributionType: ContributionType
      createdAt: any
      input?: string | null
      response?: string | null
      motivation?: string | null
      originalText: string
      user?: {
        __typename?: 'User'
        id: string
        username: string
        firstName: string
        lastName: string
      } | null
      article: {
        __typename?: 'Article'
        id: string
        clusterId: string
        title: string
        isOwner: boolean
      }
    }>
  }
  challenge: {
    __typename?: 'ContributionResponse'
    percentage: number
    contributions: Array<{
      __typename?: 'Contribution'
      clusterId: string
      id: string
      articleId: string
      status: ContributionStatus
      userId: string
      decisionAt?: any | null
      contributionType: ContributionType
      createdAt: any
      input?: string | null
      response?: string | null
      motivation?: string | null
      originalText: string
      user?: {
        __typename?: 'User'
        id: string
        username: string
        firstName: string
        lastName: string
      } | null
      article: {
        __typename?: 'Article'
        id: string
        clusterId: string
        title: string
        isOwner: boolean
      }
    }>
  }
  edit: {
    __typename?: 'ContributionResponse'
    percentage: number
    contributions: Array<{
      __typename?: 'Contribution'
      clusterId: string
      id: string
      articleId: string
      status: ContributionStatus
      userId: string
      decisionAt?: any | null
      contributionType: ContributionType
      createdAt: any
      input?: string | null
      response?: string | null
      motivation?: string | null
      originalText: string
      user?: {
        __typename?: 'User'
        id: string
        username: string
        firstName: string
        lastName: string
      } | null
      article: {
        __typename?: 'Article'
        id: string
        clusterId: string
        title: string
        isOwner: boolean
      }
    }>
  }
}

export type InboundOutboundContributionsQueryVariables = Exact<{
  userId: Scalars['ID']['input']
}>

export type InboundOutboundContributionsQuery = {
  __typename?: 'Query'
  inboundOutboundContributions: {
    __typename?: 'InboundOutboundResponse'
    corank: number
    inbound: {
      __typename?: 'PerTypeResponse'
      inquiry: {
        __typename?: 'ContributionResponse'
        percentage: number
        contributions: Array<{
          __typename?: 'Contribution'
          clusterId: string
          id: string
          articleId: string
          status: ContributionStatus
          userId: string
          decisionAt?: any | null
          contributionType: ContributionType
          createdAt: any
          input?: string | null
          response?: string | null
          motivation?: string | null
          originalText: string
          user?: {
            __typename?: 'User'
            id: string
            username: string
            firstName: string
            lastName: string
          } | null
          article: {
            __typename?: 'Article'
            id: string
            clusterId: string
            title: string
            isOwner: boolean
          }
        }>
      }
      challenge: {
        __typename?: 'ContributionResponse'
        percentage: number
        contributions: Array<{
          __typename?: 'Contribution'
          clusterId: string
          id: string
          articleId: string
          status: ContributionStatus
          userId: string
          decisionAt?: any | null
          contributionType: ContributionType
          createdAt: any
          input?: string | null
          response?: string | null
          motivation?: string | null
          originalText: string
          user?: {
            __typename?: 'User'
            id: string
            username: string
            firstName: string
            lastName: string
          } | null
          article: {
            __typename?: 'Article'
            id: string
            clusterId: string
            title: string
            isOwner: boolean
          }
        }>
      }
      edit: {
        __typename?: 'ContributionResponse'
        percentage: number
        contributions: Array<{
          __typename?: 'Contribution'
          clusterId: string
          id: string
          articleId: string
          status: ContributionStatus
          userId: string
          decisionAt?: any | null
          contributionType: ContributionType
          createdAt: any
          input?: string | null
          response?: string | null
          motivation?: string | null
          originalText: string
          user?: {
            __typename?: 'User'
            id: string
            username: string
            firstName: string
            lastName: string
          } | null
          article: {
            __typename?: 'Article'
            id: string
            clusterId: string
            title: string
            isOwner: boolean
          }
        }>
      }
    }
    outbound: {
      __typename?: 'PerTypeResponse'
      inquiry: {
        __typename?: 'ContributionResponse'
        percentage: number
        contributions: Array<{
          __typename?: 'Contribution'
          clusterId: string
          id: string
          articleId: string
          status: ContributionStatus
          userId: string
          decisionAt?: any | null
          contributionType: ContributionType
          createdAt: any
          input?: string | null
          response?: string | null
          motivation?: string | null
          originalText: string
          user?: {
            __typename?: 'User'
            id: string
            username: string
            firstName: string
            lastName: string
          } | null
          article: {
            __typename?: 'Article'
            id: string
            clusterId: string
            title: string
            isOwner: boolean
          }
        }>
      }
      challenge: {
        __typename?: 'ContributionResponse'
        percentage: number
        contributions: Array<{
          __typename?: 'Contribution'
          clusterId: string
          id: string
          articleId: string
          status: ContributionStatus
          userId: string
          decisionAt?: any | null
          contributionType: ContributionType
          createdAt: any
          input?: string | null
          response?: string | null
          motivation?: string | null
          originalText: string
          user?: {
            __typename?: 'User'
            id: string
            username: string
            firstName: string
            lastName: string
          } | null
          article: {
            __typename?: 'Article'
            id: string
            clusterId: string
            title: string
            isOwner: boolean
          }
        }>
      }
      edit: {
        __typename?: 'ContributionResponse'
        percentage: number
        contributions: Array<{
          __typename?: 'Contribution'
          clusterId: string
          id: string
          articleId: string
          status: ContributionStatus
          userId: string
          decisionAt?: any | null
          contributionType: ContributionType
          createdAt: any
          input?: string | null
          response?: string | null
          motivation?: string | null
          originalText: string
          user?: {
            __typename?: 'User'
            id: string
            username: string
            firstName: string
            lastName: string
          } | null
          article: {
            __typename?: 'Article'
            id: string
            clusterId: string
            title: string
            isOwner: boolean
          }
        }>
      }
    }
  }
}

export type UserTotalContributionsQueryVariables = Exact<{
  userId: Scalars['ID']['input']
}>

export type UserTotalContributionsQuery = {
  __typename?: 'Query'
  userTotalContributions: number
}

export type UserTotalPerspectivesQueryVariables = Exact<{
  userId: Scalars['ID']['input']
}>

export type UserTotalPerspectivesQuery = {
  __typename?: 'Query'
  userTotalPerspectives: number
}

export type ContributionsForArticleQueryVariables = Exact<{
  articleId: Scalars['ID']['input']
  status: Array<ContributionStatus> | ContributionStatus
}>

export type ContributionsForArticleQuery = {
  __typename?: 'Query'
  contributionsByArticle: Array<{
    __typename?: 'Contribution'
    input?: string | null
    response?: string | null
    motivation?: string | null
    originalText: string
    intendedType?: ContributionType | null
    reservedUntil?: any | null
    begin: number
    end: number
    id: string
    articleId: string
    status: ContributionStatus
    userId: string
    decisionAt?: any | null
    contributionType: ContributionType
    createdAt: any
    user?: {
      __typename?: 'User'
      id: string
      username: string
      firstName: string
      lastName: string
    } | null
  }>
}

export type ContributionsForPerspectiveQueryVariables = Exact<{
  articleId: Scalars['ID']['input']
  status?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}>

export type ContributionsForPerspectiveQuery = {
  __typename?: 'Query'
  contributionsByPerspective: Array<{
    __typename?: 'Contribution'
    clusterId: string
    id: string
    articleId: string
    status: ContributionStatus
    userId: string
    decisionAt?: any | null
    contributionType: ContributionType
    createdAt: any
    input?: string | null
    response?: string | null
    motivation?: string | null
    originalText: string
    user?: {
      __typename?: 'User'
      id: string
      username: string
      firstName: string
      lastName: string
    } | null
    article: {
      __typename?: 'Article'
      id: string
      clusterId: string
      title: string
      isOwner: boolean
    }
  }>
}

export type ContributionsForClusterQueryVariables = Exact<{
  clusterId: Scalars['ID']['input']
  status?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}>

export type ContributionsForClusterQuery = {
  __typename?: 'Query'
  contributionsByCluster: Array<{
    __typename?: 'Contribution'
    clusterId: string
    id: string
    articleId: string
    status: ContributionStatus
    userId: string
    decisionAt?: any | null
    contributionType: ContributionType
    createdAt: any
    input?: string | null
    response?: string | null
    motivation?: string | null
    originalText: string
    user?: {
      __typename?: 'User'
      id: string
      username: string
      firstName: string
      lastName: string
    } | null
    article: {
      __typename?: 'Article'
      id: string
      clusterId: string
      title: string
      isOwner: boolean
    }
  }>
}

export type ContributionsForUserQueryVariables = Exact<{
  userId: Scalars['ID']['input']
  status: Array<ContributionStatus> | ContributionStatus
}>

export type ContributionsForUserQuery = {
  __typename?: 'Query'
  contributionsByUser: Array<{
    __typename?: 'Contribution'
    clusterId: string
    id: string
    articleId: string
    status: ContributionStatus
    userId: string
    decisionAt?: any | null
    contributionType: ContributionType
    createdAt: any
    input?: string | null
    response?: string | null
    motivation?: string | null
    originalText: string
    user?: {
      __typename?: 'User'
      id: string
      username: string
      firstName: string
      lastName: string
    } | null
    article: {
      __typename?: 'Article'
      id: string
      clusterId: string
      title: string
      isOwner: boolean
    }
  }>
}

export type ContributionsForMyArticlesQueryVariables = Exact<{
  status: Array<ContributionStatus> | ContributionStatus
}>

export type ContributionsForMyArticlesQuery = {
  __typename?: 'Query'
  contributionsForMyArticles: Array<{
    __typename?: 'Contribution'
    clusterId: string
    id: string
    articleId: string
    status: ContributionStatus
    userId: string
    decisionAt?: any | null
    contributionType: ContributionType
    createdAt: any
    input?: string | null
    response?: string | null
    motivation?: string | null
    originalText: string
    article: {
      __typename?: 'Article'
      id: string
      clusterId: string
      title: string
      isOwner: boolean
      cluster: {
        __typename?: 'Cluster'
        id: string
        topic: string
        node: { __typename?: 'Node'; id: string; name: string }
      }
    }
    user?: {
      __typename?: 'User'
      id: string
      username: string
      firstName: string
      lastName: string
    } | null
  }>
}

export type UpdateContributionStatusMutationVariables = Exact<{
  input: UpdateContributionInput
}>

export type UpdateContributionStatusMutation = {
  __typename?: 'Mutation'
  updateContributionStatus: {
    __typename?: 'Contribution'
    clusterId: string
    id: string
    articleId: string
    status: ContributionStatus
    userId: string
    decisionAt?: any | null
    contributionType: ContributionType
    createdAt: any
    input?: string | null
    response?: string | null
    motivation?: string | null
    originalText: string
    user?: {
      __typename?: 'User'
      id: string
      username: string
      firstName: string
      lastName: string
    } | null
    article: {
      __typename?: 'Article'
      id: string
      clusterId: string
      title: string
      isOwner: boolean
    }
  }
}

export type ReserveContributionMutationVariables = Exact<{
  input: ReserveContributionInput
}>

export type ReserveContributionMutation = {
  __typename?: 'Mutation'
  reserveContribution: {
    __typename?: 'Contribution'
    input?: string | null
    response?: string | null
    motivation?: string | null
    originalText: string
    intendedType?: ContributionType | null
    reservedUntil?: any | null
    begin: number
    end: number
    id: string
    articleId: string
    status: ContributionStatus
    userId: string
    decisionAt?: any | null
    contributionType: ContributionType
    createdAt: any
    user?: {
      __typename?: 'User'
      id: string
      username: string
      firstName: string
      lastName: string
    } | null
  }
}

export type SubmitContributionMutationVariables = Exact<{
  input: SubmitContributionInput
}>

export type SubmitContributionMutation = {
  __typename?: 'Mutation'
  submitContribution: {
    __typename?: 'Contribution'
    input?: string | null
    response?: string | null
    motivation?: string | null
    originalText: string
    intendedType?: ContributionType | null
    reservedUntil?: any | null
    begin: number
    end: number
    id: string
    articleId: string
    status: ContributionStatus
    userId: string
    decisionAt?: any | null
    contributionType: ContributionType
    createdAt: any
    user?: {
      __typename?: 'User'
      id: string
      username: string
      firstName: string
      lastName: string
    } | null
  }
}

export type ReservedContributionQueryVariables = Exact<{
  articleId: Scalars['ID']['input']
}>

export type ReservedContributionQuery = {
  __typename?: 'Query'
  reservedContribution?: {
    __typename?: 'Contribution'
    input?: string | null
    response?: string | null
    motivation?: string | null
    originalText: string
    intendedType?: ContributionType | null
    reservedUntil?: any | null
    begin: number
    end: number
    id: string
    articleId: string
    status: ContributionStatus
    userId: string
    decisionAt?: any | null
    contributionType: ContributionType
    createdAt: any
    user?: {
      __typename?: 'User'
      id: string
      username: string
      firstName: string
      lastName: string
    } | null
  } | null
}

export type ContributionByIdQueryVariables = Exact<{
  contributionId: Scalars['ID']['input']
}>

export type ContributionByIdQuery = {
  __typename?: 'Query'
  contributionById: {
    __typename?: 'Contribution'
    bumpCount: number
    id: string
    articleId: string
    status: ContributionStatus
    userId: string
    decisionAt?: any | null
    contributionType: ContributionType
    createdAt: any
    input?: string | null
    response?: string | null
    motivation?: string | null
    originalText: string
    article: {
      __typename?: 'Article'
      id: string
      title: string
      ownerId?: string | null
      clusterId: string
      isAutoTitle: boolean
      version: number
      isOwner: boolean
      minCoRank?: number | null
      cluster: {
        __typename?: 'Cluster'
        id: string
        nodeId: string
        topic: string
      }
      owner?: { __typename?: 'User'; id: string; username: string } | null
    }
    user?: {
      __typename?: 'User'
      id: string
      username: string
      firstName: string
      lastName: string
    } | null
  }
}

export type CouponRedemptionsQueryVariables = Exact<{
  couponId: Scalars['String']['input']
}>

export type CouponRedemptionsQuery = {
  __typename?: 'Query'
  couponRedemptions: Array<{
    __typename?: 'CouponRedemptionDto'
    billingId: string
    redeemedAt: any
    billingType: string
    description: string
    status: string
    nodeLabel?: string | null
    nodeId?: string | null
    user: { __typename?: 'User'; id: string; username: string }
  }>
}

export type CouponsQueryVariables = Exact<{
  filter?: InputMaybe<CouponFilterInput>
  sortBy?: InputMaybe<CouponSortField>
  sortDirection?: InputMaybe<OrderDirection>
}>

export type CouponsQuery = {
  __typename?: 'Query'
  coupons: Array<{
    __typename?: 'CouponDto'
    id: string
    code: string
    adminLabel?: string | null
    appliedMonths: number
    discountPercentage: number
    enabled: boolean
    validTo: any
    maxRedeems: number
    redeemCount: number
    redeemedByUsers: Array<{ __typename?: 'User'; id: string }>
  }>
}

export type CreateCouponMutationVariables = Exact<{
  input: CreateCouponInput
}>

export type CreateCouponMutation = {
  __typename?: 'Mutation'
  createCoupon: {
    __typename?: 'CouponDto'
    id: string
    code: string
    adminLabel?: string | null
    appliedMonths: number
    discountPercentage: number
    enabled: boolean
    validTo: any
    maxRedeems: number
    redeemCount: number
    redeemedByUsers: Array<{ __typename?: 'User'; id: string }>
  }
}

export type UpdateCouponMutationVariables = Exact<{
  input: UpdateCouponInput
}>

export type UpdateCouponMutation = {
  __typename?: 'Mutation'
  updateCoupon: {
    __typename?: 'CouponDto'
    id: string
    code: string
    adminLabel?: string | null
    appliedMonths: number
    discountPercentage: number
    enabled: boolean
    validTo: any
    maxRedeems: number
    redeemCount: number
    redeemedByUsers: Array<{ __typename?: 'User'; id: string }>
  }
}

export type DeleteCouponMutationVariables = Exact<{
  id: Scalars['String']['input']
}>

export type DeleteCouponMutation = {
  __typename?: 'Mutation'
  deleteCoupon: boolean
}

export type ApplyCouponToBillingMutationVariables = Exact<{
  billingId: Scalars['ID']['input']
  couponCode: Scalars['String']['input']
}>

export type ApplyCouponToBillingMutation = {
  __typename?: 'Mutation'
  applyCouponToBilling: {
    __typename?: 'CouponBillingPreview'
    billingId: string
    amount: number
    basePrice?: number | null
    couponCode?: string | null
    discountPercentage?: number | null
    appliedMonths?: number | null
    isForever: boolean
    isFree: boolean
  }
}

export type RemoveCouponFromBillingMutationVariables = Exact<{
  billingId: Scalars['ID']['input']
}>

export type RemoveCouponFromBillingMutation = {
  __typename?: 'Mutation'
  removeCouponFromBilling: {
    __typename?: 'CouponBillingPreview'
    billingId: string
    amount: number
    basePrice?: number | null
    couponCode?: string | null
    discountPercentage?: number | null
    appliedMonths?: number | null
    isForever: boolean
    isFree: boolean
  }
}

export type SubscribeWebPushMutationVariables = Exact<{
  input: SubscribeWebPushInput
}>

export type SubscribeWebPushMutation = {
  __typename?: 'Mutation'
  subscribeWebPush: {
    __typename?: 'User'
    id: string
    firstName: string
    lastName: string
    username: string
    mobileNumber?: string | null
    mobileCountryCode?: number | null
    googleSync?: boolean | null
    wechatSync?: boolean | null
    emailAddress?: string | null
    notificationsDeviceInfo?: string | null
    isMobileVerified?: boolean | null
    isEmailVerified?: boolean | null
    isPushNotificationsEnabled: boolean
    isSuperAdmin: boolean
  }
}

export type UnsubscribeWebPushMutationVariables = Exact<{
  [key: string]: never
}>

export type UnsubscribeWebPushMutation = {
  __typename?: 'Mutation'
  unsubscribeWebPush: {
    __typename?: 'User'
    id: string
    firstName: string
    lastName: string
    username: string
    mobileNumber?: string | null
    mobileCountryCode?: number | null
    googleSync?: boolean | null
    wechatSync?: boolean | null
    emailAddress?: string | null
    notificationsDeviceInfo?: string | null
    isMobileVerified?: boolean | null
    isEmailVerified?: boolean | null
    isPushNotificationsEnabled: boolean
    isSuperAdmin: boolean
  }
}

export type CheckInvitationQueryVariables = Exact<{
  codeOrId: Scalars['String']['input']
}>

export type CheckInvitationQuery = {
  __typename?: 'Query'
  validInvitation: {
    __typename?: 'ValidInvitation'
    isMember: boolean
    invitation: {
      __typename?: 'Invitation'
      id: string
      code: string
      nodeId: string
      message?: string | null
      maxUsage?: number | null
      usageCount: number
      validBefore?: any | null
      validAfter?: any | null
      node?: { __typename?: 'Node'; id: string; name: string } | null
    }
  }
}

export type AcceptInvitationMutationVariables = Exact<{
  codeOrId: Scalars['String']['input']
}>

export type AcceptInvitationMutation = {
  __typename?: 'Mutation'
  acceptInvitation: { __typename?: 'Invitation'; nodeId: string }
}

export type CreateInvitationMutationVariables = Exact<{
  input: CreateInvitationInput
}>

export type CreateInvitationMutation = {
  __typename?: 'Mutation'
  createInvitation: {
    __typename?: 'Invitation'
    id: string
    code: string
    nodeId: string
    message?: string | null
    maxUsage?: number | null
    usageCount: number
    validBefore?: any | null
    validAfter?: any | null
    createdAt: any
    updatedAt: any
  }
}

export type ListInvitationsQueryVariables = Exact<{
  input: ListInvitationsInput
}>

export type ListInvitationsQuery = {
  __typename?: 'Query'
  listInvitations: {
    __typename?: 'PaginatedInvitations'
    total: number
    limit: number
    offset: number
    invitations: Array<{
      __typename?: 'Invitation'
      id: string
      code: string
      nodeId: string
      message?: string | null
      maxUsage?: number | null
      usageCount: number
      validBefore?: any | null
      validAfter?: any | null
      createdAt: any
      updatedAt: any
    }>
  }
}

export type DeleteInvitationMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DeleteInvitationMutation = {
  __typename?: 'Mutation'
  deleteInvitation: { __typename?: 'Invitation'; id: string; code: string }
}

export type GenerateOpinionMutationVariables = Exact<{
  prompt: Scalars['String']['input']
  model: Scalars['String']['input']
  clusterId: Scalars['String']['input']
}>

export type GenerateOpinionMutation = {
  __typename?: 'Mutation'
  generateOpinion: string
}

export type NodeMemberDetailFragment = {
  __typename?: 'NodeMember'
  id: string
  nodeId: string
  userId: string
  isAdmin: boolean
  user: {
    __typename?: 'User'
    username: string
    firstName: string
    lastName: string
  }
}

export type CreateNodeMemberMutationVariables = Exact<{
  input: CreateNodeMemberInput
}>

export type CreateNodeMemberMutation = {
  __typename?: 'Mutation'
  createNodeMember: {
    __typename?: 'NodeMember'
    id: string
    nodeId: string
    userId: string
    isAdmin: boolean
    user: {
      __typename?: 'User'
      username: string
      firstName: string
      lastName: string
    }
  }
}

export type UpdateNodeMemberMutationVariables = Exact<{
  input: UpdateNodeMemberInput
}>

export type UpdateNodeMemberMutation = {
  __typename?: 'Mutation'
  updateNodeMember: {
    __typename?: 'NodeMember'
    id: string
    nodeId: string
    userId: string
    isAdmin: boolean
    user: {
      __typename?: 'User'
      username: string
      firstName: string
      lastName: string
    }
  }
}

export type RemoveNodeMemberMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type RemoveNodeMemberMutation = {
  __typename?: 'Mutation'
  removeNodeMember: string
}

export type NodeMembersByNodeIdQueryVariables = Exact<{
  input: QueryNodeMemberInput
}>

export type NodeMembersByNodeIdQuery = {
  __typename?: 'Query'
  nodeMembersByNodeId: {
    __typename?: 'NodeMemberListDto'
    total: number
    results: Array<{
      __typename?: 'NodeMember'
      id: string
      nodeId: string
      userId: string
      isAdmin: boolean
      user: {
        __typename?: 'User'
        username: string
        firstName: string
        lastName: string
      }
    }>
  }
}

export type ExpireNodeTierForTestingMutationVariables = Exact<{
  tierId: Scalars['ID']['input']
}>

export type ExpireNodeTierForTestingMutation = {
  __typename?: 'Mutation'
  expireNodeTierForTesting: boolean
}

export type GetNodeTierConfigQueryVariables = Exact<{ [key: string]: never }>

export type GetNodeTierConfigQuery = {
  __typename?: 'Query'
  nodeTierConfig: {
    __typename?: 'NodeTierConfig'
    tiers: Array<{
      __typename?: 'TierConfigDto'
      name: string
      visibility: string
      layout: string
      seat_price: number
    }>
    extra: {
      __typename?: 'ExtraSeatDto'
      extra_seat_public: number
      extra_seat_private: number
    }
  }
}

export type CreateNodeRequestMutationVariables = Exact<{
  input: CreateNodeRequestInput
}>

export type CreateNodeRequestMutation = {
  __typename?: 'Mutation'
  createNodeRequest: {
    __typename?: 'CreateNodeRequestResponse'
    billingId: string
    amount: number
    basePrice?: number | null
  }
}

export type GetBillingStatusQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type GetBillingStatusQuery = {
  __typename?: 'Query'
  billingStatus: {
    __typename?: 'BillingStatusDto'
    status: string
    message?: string | null
    paidAt?: any | null
    processedAt?: any | null
  }
}

export type CancelNodeTierMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type CancelNodeTierMutation = {
  __typename?: 'Mutation'
  cancelNodeTier: boolean
}

export type ReactivateNodeTierMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type ReactivateNodeTierMutation = {
  __typename?: 'Mutation'
  reactivateNodeTier: boolean
}

export type GetNextMonthCostEstimateQueryVariables = Exact<{
  [key: string]: never
}>

export type GetNextMonthCostEstimateQuery = {
  __typename?: 'Query'
  nextMonthCostEstimate: {
    __typename?: 'NextMonthCostEstimate'
    totalAmount: number
    baseAmount: number
    extraAmount: number
    tierDetails: Array<{
      __typename?: 'TierCostDetail'
      nodeId: string
      nodeName: string
      tierName: string
      basePrice: number
      seats: number
      activeUsers: number
      extraSeatPrice: number
      extraSeats: number
      totalTierCost: number
    }>
  }
}

export type UpgradeNodeTierMutationVariables = Exact<{
  input: UpgradeNodeTierInput
}>

export type UpgradeNodeTierMutation = {
  __typename?: 'Mutation'
  upgradeNodeTier: {
    __typename?: 'CreateNodeRequestResponse'
    billingId: string
    amount: number
    basePrice?: number | null
  }
}

export type DowngradeNodeTierMutationVariables = Exact<{
  input: DowngradeNodeTierInput
}>

export type DowngradeNodeTierMutation = {
  __typename?: 'Mutation'
  downgradeNodeTier: {
    __typename?: 'NodeTier'
    id: string
    name: string
    seats: number
    status: string
    startDate?: any | null
    endDate?: any | null
  }
}

export type CancelDowngradeMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type CancelDowngradeMutation = {
  __typename?: 'Mutation'
  cancelDowngrade: boolean
}

export type GetNodeTiersQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>
  filter?: InputMaybe<NodeTierFilterInput>
}>

export type GetNodeTiersQuery = {
  __typename?: 'Query'
  nodeTiers: {
    __typename?: 'NodeTierPaginationResponse'
    total: number
    nodeTiers: Array<{
      __typename?: 'NodeTier'
      id: string
      nodeId: string
      name: string
      seats: number
      status: string
      startDate?: any | null
      endDate?: any | null
      createdAt: any
      updatedAt: any
      currentActiveUsers?: number | null
    }>
  }
}

export type SimulateRenovationForTestingMutationVariables = Exact<{
  [key: string]: never
}>

export type SimulateRenovationForTestingMutation = {
  __typename?: 'Mutation'
  simulateRenovationForTesting: boolean
}

export type TriggerNodeTierRenovationMutationVariables = Exact<{
  [key: string]: never
}>

export type TriggerNodeTierRenovationMutation = {
  __typename?: 'Mutation'
  triggerNodeTierRenovation: boolean
}

export type NodeDetailFragment = {
  __typename?: 'Node'
  id: string
  name: string
  description: string
  isPrivate: boolean
  allowExtraSeats: boolean
  isAdmin: boolean
}

export type AvailableNodesQueryVariables = Exact<{ [key: string]: never }>

export type AvailableNodesQuery = {
  __typename?: 'Query'
  availableNodes: Array<{
    __typename?: 'Node'
    id: string
    name: string
    description: string
    isPrivate: boolean
    allowExtraSeats: boolean
    isAdmin: boolean
  }>
}

export type NodeStatsQueryVariables = Exact<{
  input: NodeStatsInput
}>

export type NodeStatsQuery = {
  __typename?: 'Query'
  nodeStats: {
    __typename?: 'NodeStats'
    nodeId: string
    node: {
      __typename?: 'Node'
      id: string
      name: string
      description: string
      isPrivate: boolean
      allowExtraSeats: boolean
      isAdmin: boolean
    }
    perspectives: Array<{
      __typename?: 'Article'
      id: string
      title: string
      voteCount: number
      cluster: { __typename?: 'Cluster'; id: string; topic: string }
    }>
    contributions: Array<{
      __typename?: 'Contribution'
      bumpScore: number
      clusterId: string
      id: string
      articleId: string
      status: ContributionStatus
      userId: string
      decisionAt?: any | null
      contributionType: ContributionType
      createdAt: any
      input?: string | null
      response?: string | null
      motivation?: string | null
      originalText: string
      user?: {
        __typename?: 'User'
        id: string
        username: string
        firstName: string
        lastName: string
      } | null
      article: {
        __typename?: 'Article'
        id: string
        clusterId: string
        title: string
        isOwner: boolean
      }
    }>
    users: Array<{ __typename?: 'User'; id: string; username: string }>
  }
}

export type NodeTopPerspectivesQueryVariables = Exact<{
  input: NodeTopPerspectivesInput
}>

export type NodeTopPerspectivesQuery = {
  __typename?: 'Query'
  nodeTopPerspectives: {
    __typename?: 'NodeTopPerspectivesResponse'
    total: number
    perspectives: Array<{
      __typename?: 'ArticleWithPosition'
      id: string
      title: string
      voteCount: number
      dbPosition: number
      createdAt: any
      cluster: { __typename?: 'Cluster'; id: string; topic: string }
    }>
  }
}

export type NodeTopContributionsQueryVariables = Exact<{
  input: NodeTopContributionsInput
}>

export type NodeTopContributionsQuery = {
  __typename?: 'Query'
  nodeTopContributions: {
    __typename?: 'NodeTopContributionsResponse'
    total: number
    contributions: Array<{
      __typename?: 'Contribution'
      bumpScore: number
      clusterId: string
      id: string
      articleId: string
      status: ContributionStatus
      userId: string
      decisionAt?: any | null
      contributionType: ContributionType
      createdAt: any
      input?: string | null
      response?: string | null
      motivation?: string | null
      originalText: string
      user?: {
        __typename?: 'User'
        id: string
        username: string
        firstName: string
        lastName: string
      } | null
      article: {
        __typename?: 'Article'
        id: string
        clusterId: string
        title: string
        isOwner: boolean
      }
    }>
  }
}

export type NodeTopUsersQueryVariables = Exact<{
  input: NodeTopUsersInput
}>

export type NodeTopUsersQuery = {
  __typename?: 'Query'
  nodeTopUsers: {
    __typename?: 'NodeTopUsersResponse'
    total: number
    users: Array<{
      __typename?: 'UserWithCoRank'
      coRank: number
      dbPosition: number
      user: { __typename?: 'User'; id: string; username: string }
    }>
  }
}

export type NodeTopUsersExportQueryVariables = Exact<{
  input: NodeTopUsersInput
}>

export type NodeTopUsersExportQuery = {
  __typename?: 'Query'
  nodeTopUsers: {
    __typename?: 'NodeTopUsersResponse'
    total: number
    users: Array<{
      __typename?: 'UserWithCoRank'
      coRank: number
      dbPosition: number
      user: { __typename?: 'User'; id: string; username: string }
    }>
  }
}

export type NodeByIdQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type NodeByIdQuery = {
  __typename?: 'Query'
  nodeById: {
    __typename?: 'Node'
    id: string
    name: string
    description: string
    isPrivate: boolean
    isAdmin: boolean
    isOwner: boolean
  }
}

export type MyNodeByIdQueryVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type MyNodeByIdQuery = {
  __typename?: 'Query'
  nodeById: {
    __typename?: 'Node'
    id: string
    name: string
    description: string
    isPrivate: boolean
    allowExtraSeats: boolean
    isAdmin: boolean
    isOwner: boolean
    activeTier?: {
      __typename?: 'NodeTier'
      id: string
      name: string
      seats: number
      startDate?: any | null
      createdAt: any
      updatedAt: any
      endDate?: any | null
      status: string
      currentActiveUsers?: number | null
    } | null
  }
}

export type MyNodesQueryVariables = Exact<{
  input: MyNodesInput
}>

export type MyNodesQuery = {
  __typename?: 'Query'
  myNodes: {
    __typename?: 'MyNodesResponse'
    total: number
    results: Array<{
      __typename?: 'Node'
      memberCount: number
      id: string
      name: string
      description: string
      isPrivate: boolean
      allowExtraSeats: boolean
      isAdmin: boolean
      activeTier?: {
        __typename?: 'NodeTier'
        id: string
        status: string
      } | null
    }>
  }
}

export type UpdateNodeMutationVariables = Exact<{
  input: UpdateNodeInput
}>

export type UpdateNodeMutation = {
  __typename?: 'Mutation'
  updateNode: {
    __typename?: 'Node'
    id: string
    name: string
    description: string
    isPrivate: boolean
    allowExtraSeats: boolean
    isAdmin: boolean
  }
}

export type CreateNodeMutationVariables = Exact<{
  input: CreateNodeInput
}>

export type CreateNodeMutation = {
  __typename?: 'Mutation'
  createNode: {
    __typename?: 'Node'
    id: string
    name: string
    description: string
    isPrivate: boolean
    allowExtraSeats: boolean
    isAdmin: boolean
  }
}

export type TransferNodeOwnershipMutationVariables = Exact<{
  input: TransferOwnershipInput
}>

export type TransferNodeOwnershipMutation = {
  __typename?: 'Mutation'
  transferNodeOwnership: {
    __typename?: 'Node'
    id: string
    name: string
    description: string
    isPrivate: boolean
    allowExtraSeats: boolean
    isAdmin: boolean
  }
}

export type DeleteNodeMutationVariables = Exact<{
  id: Scalars['String']['input']
}>

export type DeleteNodeMutation = { __typename?: 'Mutation'; deleteNode: string }

export type SearchResultFieldsFragment = {
  __typename?: 'SearchResult'
  match_type: string
  article_id: string
  article_title: string
  article_content: string
  article_created_at: any
  article_updated_at: any
  cluster_id: string
  cluster_topic: string
  node_id: string
}

export type SearchQueryVariables = Exact<{
  input: SearchInput
}>

export type SearchQuery = {
  __typename?: 'Query'
  search: Array<{
    __typename?: 'SearchResult'
    match_type: string
    article_id: string
    article_title: string
    article_content: string
    article_created_at: any
    article_updated_at: any
    cluster_id: string
    cluster_topic: string
    node_id: string
  }>
}

export type TaskDetailFragment = {
  __typename?: 'Tasks'
  id: string
  title: string
  type: string
  targetId: string
  targetType: string
  createdAt: any
  isArchived: boolean
  isCompleted: boolean
  assignedId?: string | null
  owner?: { __typename?: 'User'; id: string; username: string } | null
}

export type TaskContributorFragment = {
  __typename?: 'TasksContributor'
  id: string
  userId: string
  taskId: string
  isCompleted: boolean
  completedAt?: any | null
  createdAt: any
  user: { __typename?: 'User'; id: string; username: string }
  task: {
    __typename?: 'Tasks'
    id: string
    title: string
    targetId: string
    targetType: string
    type: string
  }
}

export type CreateTaskMutationVariables = Exact<{
  input: CreateMelddTaskInput
}>

export type CreateTaskMutation = {
  __typename?: 'Mutation'
  createTask: {
    __typename?: 'Tasks'
    id: string
    title: string
    type: string
    targetId: string
    targetType: string
  }
}

export type AssignTaskMutationVariables = Exact<{
  input: AssignTaskInput
}>

export type AssignTaskMutation = {
  __typename?: 'Mutation'
  assignTask: boolean
}

export type ArchiveTaskMutationVariables = Exact<{
  input: TaskIdInput
}>

export type ArchiveTaskMutation = {
  __typename?: 'Mutation'
  archiveTask: boolean
}

export type GetTaskQueryVariables = Exact<{
  taskId: Scalars['String']['input']
}>

export type GetTaskQuery = {
  __typename?: 'Query'
  getTask: {
    __typename?: 'Tasks'
    id: string
    title: string
    type: string
    targetId: string
    targetType: string
    createdAt: any
    isArchived: boolean
    isCompleted: boolean
    assignedId?: string | null
    owner?: { __typename?: 'User'; id: string; username: string } | null
  }
}

export type GetTaskContributionsQueryVariables = Exact<{
  input: GetContributionsInput
  offset: Scalars['Float']['input']
  size: Scalars['Float']['input']
}>

export type GetTaskContributionsQuery = {
  __typename?: 'Query'
  getTaskContributions: {
    __typename?: 'TaskContributorResponse'
    count: number
    results: Array<{
      __typename?: 'TasksContributor'
      id: string
      userId: string
      taskId: string
      isCompleted: boolean
      completedAt?: any | null
      createdAt: any
      user: { __typename?: 'User'; id: string; username: string }
      task: {
        __typename?: 'Tasks'
        id: string
        title: string
        targetId: string
        targetType: string
        type: string
      }
    }>
  }
}

export type GetTasksQueryVariables = Exact<{
  input: GetTasksInput
  offset: Scalars['Float']['input']
  size: Scalars['Float']['input']
}>

export type GetTasksQuery = {
  __typename?: 'Query'
  getTasks: {
    __typename?: 'TasksResponse'
    count: number
    results: Array<{
      __typename?: 'Tasks'
      id: string
      title: string
      type: string
      targetId: string
      targetType: string
      createdAt: any
      isArchived: boolean
      isCompleted: boolean
      assignedId?: string | null
      owner?: { __typename?: 'User'; id: string; username: string } | null
    }>
  }
}

export type GetTargetContributionsQueryVariables = Exact<{
  input: GetContributionsByTargetInput
  offset: Scalars['Float']['input']
  size: Scalars['Float']['input']
}>

export type GetTargetContributionsQuery = {
  __typename?: 'Query'
  getTargetContributions: {
    __typename?: 'TaskContributorResponse'
    count: number
    results: Array<{
      __typename?: 'TasksContributor'
      id: string
      userId: string
      taskId: string
      isCompleted: boolean
      completedAt?: any | null
      createdAt: any
      user: { __typename?: 'User'; id: string; username: string }
      task: {
        __typename?: 'Tasks'
        id: string
        title: string
        targetId: string
        targetType: string
        type: string
      }
    }>
  }
}

export type GetMyContributionByTaskIdQueryVariables = Exact<{
  taskId: Scalars['String']['input']
}>

export type GetMyContributionByTaskIdQuery = {
  __typename?: 'Query'
  getMyContributionByTaskId?: {
    __typename?: 'TasksContributor'
    id: string
    userId: string
    taskId: string
    isCompleted: boolean
    completedAt?: any | null
    createdAt: any
    user: { __typename?: 'User'; id: string; username: string }
    task: {
      __typename?: 'Tasks'
      id: string
      title: string
      targetId: string
      targetType: string
      type: string
    }
  } | null
}

export type GetMyContributionsQueryVariables = Exact<{
  input: GetContributionsFilter
  offset: Scalars['Float']['input']
  size: Scalars['Float']['input']
}>

export type GetMyContributionsQuery = {
  __typename?: 'Query'
  getMyContributions: {
    __typename?: 'TaskContributorResponse'
    count: number
    results: Array<{
      __typename?: 'TasksContributor'
      id: string
      userId: string
      taskId: string
      isCompleted: boolean
      completedAt?: any | null
      createdAt: any
      user: { __typename?: 'User'; id: string; username: string }
      task: {
        __typename?: 'Tasks'
        id: string
        title: string
        targetId: string
        targetType: string
        type: string
      }
    }>
  }
}

export type ContributeOnTaskMutationVariables = Exact<{
  input: TaskIdInput
}>

export type ContributeOnTaskMutation = {
  __typename?: 'Mutation'
  contributeOnTask: {
    __typename?: 'TasksContributor'
    id: string
    userId: string
    taskId: string
    isCompleted: boolean
    completedAt?: any | null
    createdAt: any
    user: { __typename?: 'User'; id: string; username: string }
    task: {
      __typename?: 'Tasks'
      id: string
      title: string
      targetId: string
      targetType: string
      type: string
    }
  }
}

export type DeleteTaskContributionMutationVariables = Exact<{
  taskContributionId: Scalars['String']['input']
}>

export type DeleteTaskContributionMutation = {
  __typename?: 'Mutation'
  deleteTaskContribution: boolean
}

export type PendingTasksQueryVariables = Exact<{
  targetId?: InputMaybe<Scalars['String']['input']>
}>

export type PendingTasksQuery = {
  __typename?: 'Query'
  pendingTasks?: {
    __typename?: 'PendingTasksResponse'
    pendingTasks: number
    pendingContributions: number
  } | null
}

export type TimelinePayloadFragment = {
  __typename?: 'TimelinePayloadBase'
  articleId?: string | null
  clusterId?: string | null
  contributionId?: string | null
  motivation?: string | null
  originalText?: string | null
  targetId?: string | null
  targetType?: string | null
  taskId?: string | null
  title: string
  type?: string | null
  id?: string | null
  reason?: string | null
  content?: string | null
  username?: string | null
  description?: string | null
  start?: string | null
  end?: string | null
  newOwnerId?: string | null
  minCoRank?: number | null
  isPrivate?: boolean | null
}

export type TimelineDetailFragment = {
  __typename?: 'TimeLine'
  id: string
  targetId: string
  targetType: TargetType
  createdAt: any
  action: TimeLineAction
  userId?: string | null
  title: string
  timestamp: any
  payload: {
    __typename?: 'TimelinePayloadBase'
    articleId?: string | null
    clusterId?: string | null
    contributionId?: string | null
    motivation?: string | null
    originalText?: string | null
    targetId?: string | null
    targetType?: string | null
    taskId?: string | null
    title: string
    type?: string | null
    id?: string | null
    reason?: string | null
    content?: string | null
    username?: string | null
    description?: string | null
    start?: string | null
    end?: string | null
    newOwnerId?: string | null
    minCoRank?: number | null
    isPrivate?: boolean | null
  }
  user?: { __typename?: 'User'; id: string; username: string } | null
  tree: Array<{ __typename?: 'TreeNode'; id: string; target: TargetType }>
}

export type IsTargetAllowedQueryVariables = Exact<{
  input: TimelineTargetInput
}>

export type IsTargetAllowedQuery = {
  __typename?: 'Query'
  isTargetAllowed: boolean
}

export type GetHistoryQueryVariables = Exact<{
  input: TimelineListInput
}>

export type GetHistoryQuery = {
  __typename?: 'Query'
  getHistory: {
    __typename?: 'TimelineListResponse'
    total: number
    results: Array<{
      __typename?: 'TimeLine'
      id: string
      targetId: string
      targetType: TargetType
      createdAt: any
      action: TimeLineAction
      userId?: string | null
      title: string
      timestamp: any
      payload: {
        __typename?: 'TimelinePayloadBase'
        articleId?: string | null
        clusterId?: string | null
        contributionId?: string | null
        motivation?: string | null
        originalText?: string | null
        targetId?: string | null
        targetType?: string | null
        taskId?: string | null
        title: string
        type?: string | null
        id?: string | null
        reason?: string | null
        content?: string | null
        username?: string | null
        description?: string | null
        start?: string | null
        end?: string | null
        newOwnerId?: string | null
        minCoRank?: number | null
        isPrivate?: boolean | null
      }
      user?: { __typename?: 'User'; id: string; username: string } | null
      tree: Array<{ __typename?: 'TreeNode'; id: string; target: TargetType }>
    }>
  }
}

export type GetTimelinePositionQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type GetTimelinePositionQuery = {
  __typename?: 'Query'
  getTimelinePosition: {
    __typename?: 'TimelinePositionResponse'
    position: number
    total: number
  }
}

export type UserDetailFragment = {
  __typename?: 'User'
  id: string
  firstName: string
  lastName: string
  username: string
  mobileNumber?: string | null
  mobileCountryCode?: number | null
  googleSync?: boolean | null
  wechatSync?: boolean | null
  emailAddress?: string | null
  notificationsDeviceInfo?: string | null
  isMobileVerified?: boolean | null
  isEmailVerified?: boolean | null
  isPushNotificationsEnabled: boolean
  isSuperAdmin: boolean
}

export type GetUserTokensQueryVariables = Exact<{
  type?: InputMaybe<Scalars['String']['input']>
}>

export type GetUserTokensQuery = {
  __typename?: 'Query'
  userTokens: Array<{
    __typename?: 'UserTokenDto'
    id: string
    userId: string
    type: string
    source: string
    isDefault: boolean
    errorMessage?: string | null
    createdAt: any
    updatedAt: any
  }>
}

export type DisableUserTokenMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DisableUserTokenMutation = {
  __typename?: 'Mutation'
  disableUserToken: boolean
}

export type SetDefaultPaymentTokenMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type SetDefaultPaymentTokenMutation = {
  __typename?: 'Mutation'
  setDefaultPaymentToken: boolean
}

export type UserWithBioDetailFragment = {
  __typename?: 'User'
  bio?: string | null
  id: string
  firstName: string
  lastName: string
  username: string
  mobileNumber?: string | null
  mobileCountryCode?: number | null
  googleSync?: boolean | null
  wechatSync?: boolean | null
  emailAddress?: string | null
  notificationsDeviceInfo?: string | null
  isMobileVerified?: boolean | null
  isEmailVerified?: boolean | null
  isPushNotificationsEnabled: boolean
  isSuperAdmin: boolean
}

export type UserQueryVariables = Exact<{
  userId: Scalars['ID']['input']
}>

export type UserQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'User'
    bio?: string | null
    id: string
    firstName: string
    lastName: string
    username: string
    mobileNumber?: string | null
    mobileCountryCode?: number | null
    googleSync?: boolean | null
    wechatSync?: boolean | null
    emailAddress?: string | null
    notificationsDeviceInfo?: string | null
    isMobileVerified?: boolean | null
    isEmailVerified?: boolean | null
    isPushNotificationsEnabled: boolean
    isSuperAdmin: boolean
  }
}

export type SearchUserQueryVariables = Exact<{
  input: SearchUserNameInput
  nodeId?: InputMaybe<Scalars['String']['input']>
  clusterId?: InputMaybe<Scalars['String']['input']>
}>

export type SearchUserQuery = {
  __typename?: 'Query'
  usersBySearchUsername: Array<{
    __typename?: 'User'
    id: string
    username: string
    isNodeMember?: boolean | null
    isClusterMember?: boolean | null
  }>
}

export type SignUpMutationVariables = Exact<{
  input: SignUpInput
}>

export type SignUpMutation = {
  __typename?: 'Mutation'
  signUp: {
    __typename?: 'RegisterResponse'
    accessToken: string
    user: {
      __typename?: 'User'
      id: string
      firstName: string
      lastName: string
      username: string
      mobileNumber?: string | null
      mobileCountryCode?: number | null
      googleSync?: boolean | null
      wechatSync?: boolean | null
      emailAddress?: string | null
      notificationsDeviceInfo?: string | null
      isMobileVerified?: boolean | null
      isEmailVerified?: boolean | null
      isPushNotificationsEnabled: boolean
      isSuperAdmin: boolean
    }
  }
}

export type LoginMutationVariables = Exact<{
  input: LoginUserInput
}>

export type LoginMutation = {
  __typename?: 'Mutation'
  login: {
    __typename?: 'LoginResponse'
    accessToken: string
    user: {
      __typename?: 'User'
      id: string
      firstName: string
      lastName: string
      username: string
      mobileNumber?: string | null
      mobileCountryCode?: number | null
      googleSync?: boolean | null
      wechatSync?: boolean | null
      emailAddress?: string | null
      notificationsDeviceInfo?: string | null
      isMobileVerified?: boolean | null
      isEmailVerified?: boolean | null
      isPushNotificationsEnabled: boolean
      isSuperAdmin: boolean
    }
  }
}

export type LoginOtpMutationVariables = Exact<{
  input: LoginUserOtpInput
}>

export type LoginOtpMutation = {
  __typename?: 'Mutation'
  loginOTP: {
    __typename?: 'LoginResponse'
    accessToken: string
    user: {
      __typename?: 'User'
      id: string
      firstName: string
      lastName: string
      username: string
      mobileNumber?: string | null
      mobileCountryCode?: number | null
      googleSync?: boolean | null
      wechatSync?: boolean | null
      emailAddress?: string | null
      notificationsDeviceInfo?: string | null
      isMobileVerified?: boolean | null
      isEmailVerified?: boolean | null
      isPushNotificationsEnabled: boolean
      isSuperAdmin: boolean
    }
  }
}

export type LoginMobileOtpMutationVariables = Exact<{
  input: LoginUserMobileOtpInput
}>

export type LoginMobileOtpMutation = {
  __typename?: 'Mutation'
  loginMobileOTP: {
    __typename?: 'LoginResponse'
    accessToken: string
    user: {
      __typename?: 'User'
      id: string
      firstName: string
      lastName: string
      username: string
      mobileNumber?: string | null
      mobileCountryCode?: number | null
      googleSync?: boolean | null
      wechatSync?: boolean | null
      emailAddress?: string | null
      notificationsDeviceInfo?: string | null
      isMobileVerified?: boolean | null
      isEmailVerified?: boolean | null
      isPushNotificationsEnabled: boolean
      isSuperAdmin: boolean
    }
  }
}

export type RequestMobileVerificationCodeMutationVariables = Exact<{
  input: RequestMobileVerificationInput
}>

export type RequestMobileVerificationCodeMutation = {
  __typename?: 'Mutation'
  requestMobileVerificationCode: {
    __typename?: 'RequestMobileVerificationCodeResponse'
    isSent: boolean
  }
}

export type RequestOtpMutationVariables = Exact<{
  input: RequestOtpInput
}>

export type RequestOtpMutation = {
  __typename?: 'Mutation'
  requestOTP: { __typename?: 'RequestOtpResponse'; isSent: boolean }
}

export type GoogleLoginMutationVariables = Exact<{
  input: GoogleLoginInput
}>

export type GoogleLoginMutation = {
  __typename?: 'Mutation'
  googleLogin: {
    __typename?: 'LoginResponse'
    accessToken: string
    user: {
      __typename?: 'User'
      id: string
      firstName: string
      lastName: string
      username: string
      mobileNumber?: string | null
      mobileCountryCode?: number | null
      googleSync?: boolean | null
      wechatSync?: boolean | null
      emailAddress?: string | null
      notificationsDeviceInfo?: string | null
      isMobileVerified?: boolean | null
      isEmailVerified?: boolean | null
      isPushNotificationsEnabled: boolean
      isSuperAdmin: boolean
    }
  }
}

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput
}>

export type UpdateUserMutation = {
  __typename?: 'Mutation'
  updateUser: {
    __typename?: 'User'
    bio?: string | null
    id: string
    firstName: string
    lastName: string
    username: string
    mobileNumber?: string | null
    mobileCountryCode?: number | null
    googleSync?: boolean | null
    wechatSync?: boolean | null
    emailAddress?: string | null
    notificationsDeviceInfo?: string | null
    isMobileVerified?: boolean | null
    isEmailVerified?: boolean | null
    isPushNotificationsEnabled: boolean
    isSuperAdmin: boolean
  }
}

export type GoogleCheckMutationVariables = Exact<{
  input: GoogleLoginInput
}>

export type GoogleCheckMutation = {
  __typename?: 'Mutation'
  googleCheck: {
    __typename?: 'LoginSSOCheck'
    accountExists: boolean
    ssoName: string
  }
}

export type LogoutMutationVariables = Exact<{
  input?: InputMaybe<LogoutInput>
}>

export type LogoutMutation = {
  __typename?: 'Mutation'
  logout: { __typename?: 'LogoutResponse'; isSuccess: boolean }
}

export type ValidAppAccessKeyQueryVariables = Exact<{
  code: Scalars['String']['input']
}>

export type ValidAppAccessKeyQuery = {
  __typename?: 'Query'
  validAppAccessKey: {
    __typename?: 'ValidAppAccessKeyPayload'
    isValid: boolean
  }
}

export type SuggestUsernameQueryVariables = Exact<{
  input: SuggestUsernameInput
}>

export type SuggestUsernameQuery = {
  __typename?: 'Query'
  suggestUsername: { __typename?: 'SuggestUsernamePayload'; username: string }
}

export type ValidUsernameQueryVariables = Exact<{
  username: Scalars['String']['input']
}>

export type ValidUsernameQuery = {
  __typename?: 'Query'
  usernameAvailable: {
    __typename?: 'UsernameAvailablePayload'
    isAvailable: boolean
    message?: string | null
  }
}

export type DeleteAccountMutationVariables = Exact<{ [key: string]: never }>

export type DeleteAccountMutation = {
  __typename?: 'Mutation'
  deleteAccount: string
}

export type RegisterPushTokenMutationVariables = Exact<{
  input: RegisterPushTokenInput
}>

export type RegisterPushTokenMutation = {
  __typename?: 'Mutation'
  registerPushToken: {
    __typename?: 'RegisterPushTokenPayload'
    success: boolean
  }
}

export type VerifyMobileMutationVariables = Exact<{
  input: VerifyMobileInput
}>

export type VerifyMobileMutation = {
  __typename?: 'Mutation'
  verifyMobile: string
}

export type LinkWithGoogleMutationVariables = Exact<{
  input: GoogleLoginInput
}>

export type LinkWithGoogleMutation = {
  __typename?: 'Mutation'
  linkWithGoogle: string
}

export type RevokeGoogleMutationVariables = Exact<{ [key: string]: never }>

export type RevokeGoogleMutation = {
  __typename?: 'Mutation'
  revokeGoogle: string
}

export type RevokeWechatMutationVariables = Exact<{ [key: string]: never }>

export type RevokeWechatMutation = {
  __typename?: 'Mutation'
  revokeWechat: string
}

export type WechatLoginMutationVariables = Exact<{
  input: WechatLoginInput
}>

export type WechatLoginMutation = {
  __typename?: 'Mutation'
  wechatLogin: {
    __typename?: 'LoginResponse'
    accessToken: string
    user: {
      __typename?: 'User'
      id: string
      firstName: string
      lastName: string
      username: string
      mobileNumber?: string | null
      mobileCountryCode?: number | null
      googleSync?: boolean | null
      wechatSync?: boolean | null
      emailAddress?: string | null
      notificationsDeviceInfo?: string | null
      isMobileVerified?: boolean | null
      isEmailVerified?: boolean | null
      isPushNotificationsEnabled: boolean
      isSuperAdmin: boolean
    }
  }
}

export type WechatCheckMutationVariables = Exact<{
  input: WechatLoginInput
}>

export type WechatCheckMutation = {
  __typename?: 'Mutation'
  wechatCheck: {
    __typename?: 'LoginSSOCheck'
    accountExists: boolean
    ssoName: string
  }
}

export type LinkWithWechatMutationVariables = Exact<{
  input: WechatLoginInput
}>

export type LinkWithWechatMutation = {
  __typename?: 'Mutation'
  linkWithWechat: string
}

export type WechatSignatureMutationVariables = Exact<{
  input: WechatJdkSignatureInput
}>

export type WechatSignatureMutation = {
  __typename?: 'Mutation'
  wechatSignature: {
    __typename?: 'WechatJDKSignatureResponse'
    nonceStr: string
    signature: string
    timestamp: string
  }
}

export type SendTestNotificationMutationVariables = Exact<{
  message: Scalars['String']['input']
}>

export type SendTestNotificationMutation = {
  __typename?: 'Mutation'
  sendTestNotification: Array<{
    __typename?: 'NotificationResultDto'
    success: boolean
    message: string
    userId: string
    provider: string
  }>
}

export type MyCorankQueryVariables = Exact<{
  nodeId?: InputMaybe<Scalars['ID']['input']>
}>

export type MyCorankQuery = { __typename?: 'Query'; myCorank: number }

export type CorankUserDifferenceQueryVariables = Exact<{
  profileUserId: Scalars['ID']['input']
  nodeId?: InputMaybe<Scalars['ID']['input']>
}>

export type CorankUserDifferenceQuery = {
  __typename?: 'Query'
  corankUserDifference: {
    __typename?: 'CorankUserDifference'
    viewerLastUpdateScore: number
    profileUserLastUpdateScore: number
    isCommonContributionContext: boolean
  }
}

export type ProfileCorankComparisonQueryVariables = Exact<{
  profileUserId: Scalars['ID']['input']
  viewerUserId: Scalars['ID']['input']
  nodeId?: InputMaybe<Scalars['ID']['input']>
}>

export type ProfileCorankComparisonQuery = {
  __typename?: 'Query'
  viewerCorank: number
  profileUserCorank: number
  viewerCorankTimeline: {
    __typename?: 'CorankUpdatedTimelineSeries'
    eventCount: number
    windowStart?: any | null
    windowEnd?: any | null
    points: Array<{
      __typename?: 'CorankTimelinePoint'
      coRank: number
      timestamp: any
    }>
  }
  profileCorankTimeline: {
    __typename?: 'CorankUpdatedTimelineSeries'
    eventCount: number
    windowStart?: any | null
    windowEnd?: any | null
    points: Array<{
      __typename?: 'CorankTimelinePoint'
      coRank: number
      timestamp: any
    }>
  }
}

export type UpdateTimelineReadUntilMutationVariables = Exact<{
  [key: string]: never
}>

export type UpdateTimelineReadUntilMutation = {
  __typename?: 'Mutation'
  updateTimelineReadUntil: boolean
}

export type CollaboratorsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>
  search?: InputMaybe<Scalars['String']['input']>
}>

export type CollaboratorsQuery = {
  __typename?: 'Query'
  collaborators: {
    __typename?: 'CollaboratorPaginationResponse'
    total: number
    users: Array<{
      __typename?: 'CollaboratorUser'
      id: string
      username: string
      firstName: string
      lastName: string
      bio?: string | null
      publicCoRank?: number | null
      collaboratorId?: string | null
      lists?: Array<{
        __typename?: 'CollaboratorListDto'
        id: string
        name: string
        color?: string | null
      }> | null
      lastEvent?: {
        __typename?: 'TimeLine'
        id: string
        title: string
        timestamp: any
        action: TimeLineAction
        targetType: TargetType
        targetId: string
        nodeName?: string | null
        payload: { __typename?: 'TimelinePayloadBase'; type?: string | null }
      } | null
      incompleteTasks?: Array<{
        __typename?: 'Tasks'
        id: string
        title: string
        type: string
        targetId: string
        targetType: string
        createdAt: any
        isArchived: boolean
        isCompleted: boolean
      }> | null
    }>
  }
}

export type MyCollaboratorsTimelineQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>
  actions?: InputMaybe<Array<TimeLineAction> | TimeLineAction>
  userId?: InputMaybe<Scalars['ID']['input']>
  nodeId?: InputMaybe<Scalars['ID']['input']>
}>

export type MyCollaboratorsTimelineQuery = {
  __typename?: 'Query'
  myCollaboratorsEvents: {
    __typename?: 'TimelineListResponse'
    total: number
    results: Array<{
      __typename?: 'TimeLine'
      id: string
      action: TimeLineAction
      timestamp: any
      isNew: boolean
      targetId: string
      targetType: TargetType
      title: string
      nodeName?: string | null
      user?: { __typename?: 'User'; id: string; username: string } | null
      payload: {
        __typename?: 'TimelinePayloadBase'
        title: string
        type?: string | null
        originalText?: string | null
      }
    }>
  }
}

export type MyTimelineEventsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>
  actions?: InputMaybe<Array<TimeLineAction> | TimeLineAction>
  nodeId?: InputMaybe<Scalars['ID']['input']>
}>

export type MyTimelineEventsQuery = {
  __typename?: 'Query'
  myTimelineEvents: {
    __typename?: 'TimelineListResponse'
    total: number
    results: Array<{
      __typename?: 'TimeLine'
      id: string
      action: TimeLineAction
      timestamp: any
      targetId: string
      targetType: TargetType
      title: string
      nodeName?: string | null
      user?: { __typename?: 'User'; id: string; username: string } | null
      payload: {
        __typename?: 'TimelinePayloadBase'
        title: string
        type?: string | null
        originalText?: string | null
      }
    }>
  }
}

export type UserTimelineEventsQueryVariables = Exact<{
  userId: Scalars['String']['input']
  pagination?: InputMaybe<PaginationInput>
  actions?: InputMaybe<Array<TimeLineAction> | TimeLineAction>
  nodeId?: InputMaybe<Scalars['ID']['input']>
}>

export type UserTimelineEventsQuery = {
  __typename?: 'Query'
  userTimelineEvents: {
    __typename?: 'TimelineListResponse'
    total: number
    results: Array<{
      __typename?: 'TimeLine'
      id: string
      action: TimeLineAction
      timestamp: any
      targetId: string
      targetType: TargetType
      title: string
      nodeName?: string | null
      user?: { __typename?: 'User'; id: string; username: string } | null
      payload: {
        __typename?: 'TimelinePayloadBase'
        title: string
        type?: string | null
        originalText?: string | null
      }
    }>
  }
}

export type GetNewEventsCountQueryVariables = Exact<{
  input: GetNewEventsCountInput
}>

export type GetNewEventsCountQuery = {
  __typename?: 'Query'
  getNewEventsCount: number
}

export type MyCollaboratorListsQueryVariables = Exact<{ [key: string]: never }>

export type MyCollaboratorListsQuery = {
  __typename?: 'Query'
  myCollaboratorLists: Array<{
    __typename?: 'CollaboratorListDto'
    id: string
    ownerId: string
    name: string
    color?: string | null
    createdAt: any
    updatedAt: any
  }>
}

export type CreateCollaboratorListMutationVariables = Exact<{
  input: CreateCollaboratorListInput
}>

export type CreateCollaboratorListMutation = {
  __typename?: 'Mutation'
  createCollaboratorList: {
    __typename?: 'CollaboratorListDto'
    id: string
    ownerId: string
    name: string
    color?: string | null
    createdAt: any
    updatedAt: any
  }
}

export type UpdateCollaboratorListMutationVariables = Exact<{
  listId: Scalars['String']['input']
  input: UpdateCollaboratorListInput
}>

export type UpdateCollaboratorListMutation = {
  __typename?: 'Mutation'
  updateCollaboratorList: {
    __typename?: 'CollaboratorListDto'
    id: string
    ownerId: string
    name: string
    color?: string | null
    createdAt: any
    updatedAt: any
  }
}

export type DeleteCollaboratorListMutationVariables = Exact<{
  listId: Scalars['String']['input']
}>

export type DeleteCollaboratorListMutation = {
  __typename?: 'Mutation'
  deleteCollaboratorList: boolean
}

export type AssignCollaboratorToListMutationVariables = Exact<{
  input: AssignCollaboratorToListInput
}>

export type AssignCollaboratorToListMutation = {
  __typename?: 'Mutation'
  assignCollaboratorToList: boolean
}

export type RemoveCollaboratorFromListMutationVariables = Exact<{
  input: RemoveCollaboratorFromListInput
}>

export type RemoveCollaboratorFromListMutation = {
  __typename?: 'Mutation'
  removeCollaboratorFromList: boolean
}

export type CollaboratorListWithMembersQueryVariables = Exact<{
  listId: Scalars['String']['input']
}>

export type CollaboratorListWithMembersQuery = {
  __typename?: 'Query'
  collaboratorListWithMembers?: {
    __typename?: 'CollaboratorListWithMembersResponse'
    collaboratorCount: number
    list: {
      __typename?: 'CollaboratorListDto'
      id: string
      ownerId: string
      name: string
      color?: string | null
      createdAt: any
      updatedAt: any
      collaborators?: Array<{
        __typename?: 'User'
        id: string
        username: string
        firstName: string
        lastName: string
      }> | null
    }
  } | null
}

export type MyTasksQueryVariables = Exact<{
  offset: Scalars['Float']['input']
  size: Scalars['Float']['input']
}>

export type MyTasksQuery = {
  __typename?: 'Query'
  myTasks: {
    __typename?: 'MyTasksWithContributorsResponse'
    count: number
    results: Array<{
      __typename?: 'MyTaskWithContributorsDto'
      task: {
        __typename?: 'Tasks'
        id: string
        title: string
        type: string
        targetId: string
        targetType: string
        createdAt: any
        isArchived: boolean
        isCompleted: boolean
      }
      contributors: Array<{
        __typename?: 'TasksContributor'
        id: string
        userId: string
        user: {
          __typename?: 'User'
          id: string
          username: string
          firstName: string
          lastName: string
        }
      }>
    }>
  }
}

export type InviteCollaboratorsByTaskMutationVariables = Exact<{
  input: InviteCollaboratorsByTaskInput
}>

export type InviteCollaboratorsByTaskMutation = {
  __typename?: 'Mutation'
  inviteCollaboratorsByTask: Array<{
    __typename?: 'TasksContributor'
    id: string
    taskId: string
    userId: string
    isCompleted: boolean
    completedAt?: any | null
    createdAt: any
    user: {
      __typename?: 'User'
      id: string
      username: string
      firstName: string
      lastName: string
    }
  }>
}

export type InviteCollaboratorToTaskMutationVariables = Exact<{
  input: InviteCollaboratorToTaskInput
}>

export type InviteCollaboratorToTaskMutation = {
  __typename?: 'Mutation'
  inviteCollaboratorToTask: {
    __typename?: 'TasksContributor'
    id: string
    taskId: string
    userId: string
    isCompleted: boolean
    completedAt?: any | null
    createdAt: any
    user: {
      __typename?: 'User'
      id: string
      username: string
      firstName: string
      lastName: string
      bio?: string | null
    }
  }
}

export const VoteDetailFragmentDoc = gql`
  fragment VoteDetail on ArticleVote {
    id
    userId
    clusterId
    articleId
    justification
    user {
      id
      username
    }
  }
`
export const ArticleDetailFragmentDoc = gql`
  fragment ArticleDetail on Article {
    id
    title
    ownerId
    clusterId
    isAutoTitle
    version
    isOwner
    minCoRank
    cluster {
      id
      nodeId
      topic
    }
    owner {
      id
      username
    }
  }
`
export const ClusterMemberDetailFragmentDoc = gql`
  fragment ClusterMemberDetail on ClusterMember {
    id
    clusterId
    userId
    isModerator
    user {
      id
      username
      firstName
      lastName
    }
  }
`
export const ClusterDetailFragmentDoc = gql`
  fragment ClusterDetail on Cluster {
    id
    isPrivate
    showModerators
    showPerspectiveOwners
    nodeId
    topic
    contentUpdatedAt
    ownerId
    isOwner
    isModerator
  }
`
export const ContributionBumpDetailFragmentDoc = gql`
  fragment ContributionBumpDetail on ContributionBump {
    contributionId
    userId
    value
    reason
    updatedAt
    user {
      id
      username
    }
  }
`
export const ContributionDetailFragmentDoc = gql`
  fragment ContributionDetail on Contribution {
    id
    articleId
    status
    userId
    decisionAt
    contributionType
    createdAt
    input
    response
    motivation
    originalText
    user {
      id
      username
      firstName
      lastName
    }
  }
`
export const ContributionEditDetailFragmentDoc = gql`
  fragment ContributionEditDetail on Contribution {
    ...ContributionDetail
    input
    response
    motivation
    originalText
    intendedType
    reservedUntil
    begin
    end
  }
  ${ContributionDetailFragmentDoc}
`
export const FullContributionDetailFragmentDoc = gql`
  fragment FullContributionDetail on Contribution {
    ...ContributionDetail
    clusterId
    user {
      id
      username
      firstName
      lastName
    }
    article {
      id
      clusterId
      title
      isOwner
    }
  }
  ${ContributionDetailFragmentDoc}
`
export const ContributionDetailWithNodeFragmentDoc = gql`
  fragment ContributionDetailWithNode on Contribution {
    ...FullContributionDetail
    article {
      id
      cluster {
        id
        topic
        node {
          id
          name
        }
      }
    }
  }
  ${FullContributionDetailFragmentDoc}
`
export const ContributionResponseDetailFragmentDoc = gql`
  fragment ContributionResponseDetail on ContributionResponse {
    percentage
    contributions {
      ...FullContributionDetail
    }
  }
  ${FullContributionDetailFragmentDoc}
`
export const PerTypeResponseDetailFragmentDoc = gql`
  fragment PerTypeResponseDetail on PerTypeResponse {
    inquiry {
      ...ContributionResponseDetail
    }
    challenge {
      ...ContributionResponseDetail
    }
    edit {
      ...ContributionResponseDetail
    }
  }
  ${ContributionResponseDetailFragmentDoc}
`
export const NodeMemberDetailFragmentDoc = gql`
  fragment NodeMemberDetail on NodeMember {
    id
    nodeId
    userId
    isAdmin
    user {
      username
      firstName
      lastName
    }
  }
`
export const NodeDetailFragmentDoc = gql`
  fragment NodeDetail on Node {
    id
    name
    description
    isPrivate
    allowExtraSeats
    isAdmin
  }
`
export const SearchResultFieldsFragmentDoc = gql`
  fragment SearchResultFields on SearchResult {
    match_type
    article_id
    article_title
    article_content
    article_created_at
    article_updated_at
    cluster_id
    cluster_topic
    node_id
  }
`
export const TaskDetailFragmentDoc = gql`
  fragment TaskDetail on Tasks {
    id
    title
    type
    targetId
    targetType
    createdAt
    isArchived
    isCompleted
    assignedId
    owner {
      id
      username
    }
  }
`
export const TaskContributorFragmentDoc = gql`
  fragment TaskContributor on TasksContributor {
    id
    userId
    taskId
    isCompleted
    completedAt
    createdAt
    user {
      id
      username
    }
    task {
      id
      title
      targetId
      targetType
      type
    }
  }
`
export const TimelinePayloadFragmentDoc = gql`
  fragment TimelinePayload on TimelinePayloadBase {
    articleId
    clusterId
    contributionId
    motivation
    originalText
    targetId
    targetType
    taskId
    title
    type
    id
    reason
    content
    username
    description
    start
    end
    newOwnerId
    minCoRank
    isPrivate
  }
`
export const TimelineDetailFragmentDoc = gql`
  fragment TimelineDetail on TimeLine {
    id
    targetId
    targetType
    createdAt
    action
    userId
    payload {
      ...TimelinePayload
    }
    user {
      id
      username
    }
    title
    timestamp
    tree {
      id
      target
    }
  }
  ${TimelinePayloadFragmentDoc}
`
export const UserDetailFragmentDoc = gql`
  fragment UserDetail on User {
    id
    firstName
    lastName
    username
    mobileNumber
    mobileCountryCode
    googleSync
    wechatSync
    emailAddress
    notificationsDeviceInfo
    isMobileVerified
    isEmailVerified
    isPushNotificationsEnabled
    isSuperAdmin
  }
`
export const UserWithBioDetailFragmentDoc = gql`
  fragment UserWithBioDetail on User {
    ...UserDetail
    bio
  }
  ${UserDetailFragmentDoc}
`
export const AdminStatsForRangeDocument = gql`
  query adminStatsForRange($from: DateTime!, $to: DateTime!) {
    adminStatsForRange(from: $from, to: $to) {
      activeUsers
      newNodes
      billingTotal
    }
  }
`

/**
 * __useAdminStatsForRangeQuery__
 *
 * To run a query within a React component, call `useAdminStatsForRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminStatsForRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminStatsForRangeQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useAdminStatsForRangeQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdminStatsForRangeQuery,
    AdminStatsForRangeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminStatsForRangeQuery,
    AdminStatsForRangeQueryVariables
  >(AdminStatsForRangeDocument, options)
}
export function useAdminStatsForRangeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminStatsForRangeQuery,
    AdminStatsForRangeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminStatsForRangeQuery,
    AdminStatsForRangeQueryVariables
  >(AdminStatsForRangeDocument, options)
}
export function useAdminStatsForRangeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminStatsForRangeQuery,
    AdminStatsForRangeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AdminStatsForRangeQuery,
    AdminStatsForRangeQueryVariables
  >(AdminStatsForRangeDocument, options)
}
export type AdminStatsForRangeQueryHookResult = ReturnType<
  typeof useAdminStatsForRangeQuery
>
export type AdminStatsForRangeLazyQueryHookResult = ReturnType<
  typeof useAdminStatsForRangeLazyQuery
>
export type AdminStatsForRangeSuspenseQueryHookResult = ReturnType<
  typeof useAdminStatsForRangeSuspenseQuery
>
export type AdminStatsForRangeQueryResult = Apollo.QueryResult<
  AdminStatsForRangeQuery,
  AdminStatsForRangeQueryVariables
>
export const PlaceVoteDocument = gql`
  mutation placeVote($input: PlaceArticleVoteInput!) {
    placeArticleVote(input: $input) {
      ...VoteDetail
    }
  }
  ${VoteDetailFragmentDoc}
`
export type PlaceVoteMutationFn = Apollo.MutationFunction<
  PlaceVoteMutation,
  PlaceVoteMutationVariables
>

/**
 * __usePlaceVoteMutation__
 *
 * To run a mutation, you first call `usePlaceVoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaceVoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [placeVoteMutation, { data, loading, error }] = usePlaceVoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlaceVoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PlaceVoteMutation,
    PlaceVoteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<PlaceVoteMutation, PlaceVoteMutationVariables>(
    PlaceVoteDocument,
    options
  )
}
export type PlaceVoteMutationHookResult = ReturnType<
  typeof usePlaceVoteMutation
>
export type PlaceVoteMutationResult = Apollo.MutationResult<PlaceVoteMutation>
export type PlaceVoteMutationOptions = Apollo.BaseMutationOptions<
  PlaceVoteMutation,
  PlaceVoteMutationVariables
>
export const RemoveVoteDocument = gql`
  mutation removeVote($input: RemoveArticleVoteInput!) {
    removeArticleVote(input: $input) {
      ...VoteDetail
    }
  }
  ${VoteDetailFragmentDoc}
`
export type RemoveVoteMutationFn = Apollo.MutationFunction<
  RemoveVoteMutation,
  RemoveVoteMutationVariables
>

/**
 * __useRemoveVoteMutation__
 *
 * To run a mutation, you first call `useRemoveVoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveVoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeVoteMutation, { data, loading, error }] = useRemoveVoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveVoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveVoteMutation,
    RemoveVoteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<RemoveVoteMutation, RemoveVoteMutationVariables>(
    RemoveVoteDocument,
    options
  )
}
export type RemoveVoteMutationHookResult = ReturnType<
  typeof useRemoveVoteMutation
>
export type RemoveVoteMutationResult = Apollo.MutationResult<RemoveVoteMutation>
export type RemoveVoteMutationOptions = Apollo.BaseMutationOptions<
  RemoveVoteMutation,
  RemoveVoteMutationVariables
>
export const ArticleVotesByArticleIdDocument = gql`
  query articleVotesByArticleId($input: QueryArticleVoteInput!) {
    articleVotesByArticleId(input: $input) {
      total
      results {
        ...VoteDetail
      }
    }
  }
  ${VoteDetailFragmentDoc}
`

/**
 * __useArticleVotesByArticleIdQuery__
 *
 * To run a query within a React component, call `useArticleVotesByArticleIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleVotesByArticleIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleVotesByArticleIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArticleVotesByArticleIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    ArticleVotesByArticleIdQuery,
    ArticleVotesByArticleIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ArticleVotesByArticleIdQuery,
    ArticleVotesByArticleIdQueryVariables
  >(ArticleVotesByArticleIdDocument, options)
}
export function useArticleVotesByArticleIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ArticleVotesByArticleIdQuery,
    ArticleVotesByArticleIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ArticleVotesByArticleIdQuery,
    ArticleVotesByArticleIdQueryVariables
  >(ArticleVotesByArticleIdDocument, options)
}
export function useArticleVotesByArticleIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ArticleVotesByArticleIdQuery,
    ArticleVotesByArticleIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ArticleVotesByArticleIdQuery,
    ArticleVotesByArticleIdQueryVariables
  >(ArticleVotesByArticleIdDocument, options)
}
export type ArticleVotesByArticleIdQueryHookResult = ReturnType<
  typeof useArticleVotesByArticleIdQuery
>
export type ArticleVotesByArticleIdLazyQueryHookResult = ReturnType<
  typeof useArticleVotesByArticleIdLazyQuery
>
export type ArticleVotesByArticleIdSuspenseQueryHookResult = ReturnType<
  typeof useArticleVotesByArticleIdSuspenseQuery
>
export type ArticleVotesByArticleIdQueryResult = Apollo.QueryResult<
  ArticleVotesByArticleIdQuery,
  ArticleVotesByArticleIdQueryVariables
>
export const ArticlesForClusterDocument = gql`
  query articlesForCluster($input: ArticleListInput!) {
    articlesForCluster(input: $input) {
      results {
        ...ArticleDetail
        contributions {
          ...ContributionEditDetail
        }
        hasUserVote
        voteCount
        contributionCount
      }
      total
    }
  }
  ${ArticleDetailFragmentDoc}
  ${ContributionEditDetailFragmentDoc}
`

/**
 * __useArticlesForClusterQuery__
 *
 * To run a query within a React component, call `useArticlesForClusterQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticlesForClusterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticlesForClusterQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArticlesForClusterQuery(
  baseOptions: Apollo.QueryHookOptions<
    ArticlesForClusterQuery,
    ArticlesForClusterQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ArticlesForClusterQuery,
    ArticlesForClusterQueryVariables
  >(ArticlesForClusterDocument, options)
}
export function useArticlesForClusterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ArticlesForClusterQuery,
    ArticlesForClusterQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ArticlesForClusterQuery,
    ArticlesForClusterQueryVariables
  >(ArticlesForClusterDocument, options)
}
export function useArticlesForClusterSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ArticlesForClusterQuery,
    ArticlesForClusterQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ArticlesForClusterQuery,
    ArticlesForClusterQueryVariables
  >(ArticlesForClusterDocument, options)
}
export type ArticlesForClusterQueryHookResult = ReturnType<
  typeof useArticlesForClusterQuery
>
export type ArticlesForClusterLazyQueryHookResult = ReturnType<
  typeof useArticlesForClusterLazyQuery
>
export type ArticlesForClusterSuspenseQueryHookResult = ReturnType<
  typeof useArticlesForClusterSuspenseQuery
>
export type ArticlesForClusterQueryResult = Apollo.QueryResult<
  ArticlesForClusterQuery,
  ArticlesForClusterQueryVariables
>
export const ArticlesForUserDocument = gql`
  query articlesForUser($userId: ID!) {
    articlesForUser(userId: $userId) {
      ...ArticleDetail
      cluster {
        id
        nodeId
      }
      contributionCount
    }
  }
  ${ArticleDetailFragmentDoc}
`

/**
 * __useArticlesForUserQuery__
 *
 * To run a query within a React component, call `useArticlesForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticlesForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticlesForUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useArticlesForUserQuery(
  baseOptions: Apollo.QueryHookOptions<
    ArticlesForUserQuery,
    ArticlesForUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ArticlesForUserQuery, ArticlesForUserQueryVariables>(
    ArticlesForUserDocument,
    options
  )
}
export function useArticlesForUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ArticlesForUserQuery,
    ArticlesForUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ArticlesForUserQuery,
    ArticlesForUserQueryVariables
  >(ArticlesForUserDocument, options)
}
export function useArticlesForUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ArticlesForUserQuery,
    ArticlesForUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ArticlesForUserQuery,
    ArticlesForUserQueryVariables
  >(ArticlesForUserDocument, options)
}
export type ArticlesForUserQueryHookResult = ReturnType<
  typeof useArticlesForUserQuery
>
export type ArticlesForUserLazyQueryHookResult = ReturnType<
  typeof useArticlesForUserLazyQuery
>
export type ArticlesForUserSuspenseQueryHookResult = ReturnType<
  typeof useArticlesForUserSuspenseQuery
>
export type ArticlesForUserQueryResult = Apollo.QueryResult<
  ArticlesForUserQuery,
  ArticlesForUserQueryVariables
>
export const ArticleDocument = gql`
  query article($id: ID!) {
    article(id: $id) {
      ...ArticleDetail
      originalContent
      latestContent
      voteCount
      hasUserVote
      contributions {
        ...ContributionEditDetail
      }
    }
  }
  ${ArticleDetailFragmentDoc}
  ${ContributionEditDetailFragmentDoc}
`

/**
 * __useArticleQuery__
 *
 * To run a query within a React component, call `useArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArticleQuery(
  baseOptions: Apollo.QueryHookOptions<ArticleQuery, ArticleQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ArticleQuery, ArticleQueryVariables>(
    ArticleDocument,
    options
  )
}
export function useArticleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ArticleQuery, ArticleQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ArticleQuery, ArticleQueryVariables>(
    ArticleDocument,
    options
  )
}
export function useArticleSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ArticleQuery,
    ArticleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ArticleQuery, ArticleQueryVariables>(
    ArticleDocument,
    options
  )
}
export type ArticleQueryHookResult = ReturnType<typeof useArticleQuery>
export type ArticleLazyQueryHookResult = ReturnType<typeof useArticleLazyQuery>
export type ArticleSuspenseQueryHookResult = ReturnType<
  typeof useArticleSuspenseQuery
>
export type ArticleQueryResult = Apollo.QueryResult<
  ArticleQuery,
  ArticleQueryVariables
>
export const ArticlePathDocument = gql`
  query articlePath($id: ID!) {
    article(id: $id) {
      id
      cluster {
        id
        nodeId
      }
    }
  }
`

/**
 * __useArticlePathQuery__
 *
 * To run a query within a React component, call `useArticlePathQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticlePathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticlePathQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArticlePathQuery(
  baseOptions: Apollo.QueryHookOptions<
    ArticlePathQuery,
    ArticlePathQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ArticlePathQuery, ArticlePathQueryVariables>(
    ArticlePathDocument,
    options
  )
}
export function useArticlePathLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ArticlePathQuery,
    ArticlePathQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ArticlePathQuery, ArticlePathQueryVariables>(
    ArticlePathDocument,
    options
  )
}
export function useArticlePathSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ArticlePathQuery,
    ArticlePathQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ArticlePathQuery, ArticlePathQueryVariables>(
    ArticlePathDocument,
    options
  )
}
export type ArticlePathQueryHookResult = ReturnType<typeof useArticlePathQuery>
export type ArticlePathLazyQueryHookResult = ReturnType<
  typeof useArticlePathLazyQuery
>
export type ArticlePathSuspenseQueryHookResult = ReturnType<
  typeof useArticlePathSuspenseQuery
>
export type ArticlePathQueryResult = Apollo.QueryResult<
  ArticlePathQuery,
  ArticlePathQueryVariables
>
export const ArticleContributorsDocument = gql`
  query articleContributors($id: ID!) {
    article(id: $id) {
      id
      contributors {
        id
        username
      }
    }
  }
`

/**
 * __useArticleContributorsQuery__
 *
 * To run a query within a React component, call `useArticleContributorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleContributorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleContributorsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArticleContributorsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ArticleContributorsQuery,
    ArticleContributorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ArticleContributorsQuery,
    ArticleContributorsQueryVariables
  >(ArticleContributorsDocument, options)
}
export function useArticleContributorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ArticleContributorsQuery,
    ArticleContributorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ArticleContributorsQuery,
    ArticleContributorsQueryVariables
  >(ArticleContributorsDocument, options)
}
export function useArticleContributorsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ArticleContributorsQuery,
    ArticleContributorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ArticleContributorsQuery,
    ArticleContributorsQueryVariables
  >(ArticleContributorsDocument, options)
}
export type ArticleContributorsQueryHookResult = ReturnType<
  typeof useArticleContributorsQuery
>
export type ArticleContributorsLazyQueryHookResult = ReturnType<
  typeof useArticleContributorsLazyQuery
>
export type ArticleContributorsSuspenseQueryHookResult = ReturnType<
  typeof useArticleContributorsSuspenseQuery
>
export type ArticleContributorsQueryResult = Apollo.QueryResult<
  ArticleContributorsQuery,
  ArticleContributorsQueryVariables
>
export const CreateArticleDocument = gql`
  mutation createArticle($input: CreateArticleInput!) {
    createArticle(input: $input) {
      ...ArticleDetail
      latestContent
    }
  }
  ${ArticleDetailFragmentDoc}
`
export type CreateArticleMutationFn = Apollo.MutationFunction<
  CreateArticleMutation,
  CreateArticleMutationVariables
>

/**
 * __useCreateArticleMutation__
 *
 * To run a mutation, you first call `useCreateArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArticleMutation, { data, loading, error }] = useCreateArticleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateArticleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateArticleMutation,
    CreateArticleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateArticleMutation,
    CreateArticleMutationVariables
  >(CreateArticleDocument, options)
}
export type CreateArticleMutationHookResult = ReturnType<
  typeof useCreateArticleMutation
>
export type CreateArticleMutationResult =
  Apollo.MutationResult<CreateArticleMutation>
export type CreateArticleMutationOptions = Apollo.BaseMutationOptions<
  CreateArticleMutation,
  CreateArticleMutationVariables
>
export const UpdateArticleDocument = gql`
  mutation updateArticle($input: UpdateArticleInput!) {
    updateArticle(input: $input) {
      ...ArticleDetail
      latestContent
    }
  }
  ${ArticleDetailFragmentDoc}
`
export type UpdateArticleMutationFn = Apollo.MutationFunction<
  UpdateArticleMutation,
  UpdateArticleMutationVariables
>

/**
 * __useUpdateArticleMutation__
 *
 * To run a mutation, you first call `useUpdateArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArticleMutation, { data, loading, error }] = useUpdateArticleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateArticleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateArticleMutation,
    UpdateArticleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateArticleMutation,
    UpdateArticleMutationVariables
  >(UpdateArticleDocument, options)
}
export type UpdateArticleMutationHookResult = ReturnType<
  typeof useUpdateArticleMutation
>
export type UpdateArticleMutationResult =
  Apollo.MutationResult<UpdateArticleMutation>
export type UpdateArticleMutationOptions = Apollo.BaseMutationOptions<
  UpdateArticleMutation,
  UpdateArticleMutationVariables
>
export const DeleteArticleDocument = gql`
  mutation deleteArticle($id: ID!) {
    deleteArticle(id: $id)
  }
`
export type DeleteArticleMutationFn = Apollo.MutationFunction<
  DeleteArticleMutation,
  DeleteArticleMutationVariables
>

/**
 * __useDeleteArticleMutation__
 *
 * To run a mutation, you first call `useDeleteArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArticleMutation, { data, loading, error }] = useDeleteArticleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteArticleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteArticleMutation,
    DeleteArticleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteArticleMutation,
    DeleteArticleMutationVariables
  >(DeleteArticleDocument, options)
}
export type DeleteArticleMutationHookResult = ReturnType<
  typeof useDeleteArticleMutation
>
export type DeleteArticleMutationResult =
  Apollo.MutationResult<DeleteArticleMutation>
export type DeleteArticleMutationOptions = Apollo.BaseMutationOptions<
  DeleteArticleMutation,
  DeleteArticleMutationVariables
>
export const TransferArticleOwnershipDocument = gql`
  mutation transferArticleOwnership($input: TransferArticleOwnershipInput!) {
    transferArticleOwnership(input: $input) {
      ...ArticleDetail
      latestContent
    }
  }
  ${ArticleDetailFragmentDoc}
`
export type TransferArticleOwnershipMutationFn = Apollo.MutationFunction<
  TransferArticleOwnershipMutation,
  TransferArticleOwnershipMutationVariables
>

/**
 * __useTransferArticleOwnershipMutation__
 *
 * To run a mutation, you first call `useTransferArticleOwnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferArticleOwnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferArticleOwnershipMutation, { data, loading, error }] = useTransferArticleOwnershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransferArticleOwnershipMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TransferArticleOwnershipMutation,
    TransferArticleOwnershipMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    TransferArticleOwnershipMutation,
    TransferArticleOwnershipMutationVariables
  >(TransferArticleOwnershipDocument, options)
}
export type TransferArticleOwnershipMutationHookResult = ReturnType<
  typeof useTransferArticleOwnershipMutation
>
export type TransferArticleOwnershipMutationResult =
  Apollo.MutationResult<TransferArticleOwnershipMutation>
export type TransferArticleOwnershipMutationOptions =
  Apollo.BaseMutationOptions<
    TransferArticleOwnershipMutation,
    TransferArticleOwnershipMutationVariables
  >
export const ExportDocxDocument = gql`
  query exportDocx($id: ID!) {
    exportDocx(id: $id)
  }
`

/**
 * __useExportDocxQuery__
 *
 * To run a query within a React component, call `useExportDocxQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportDocxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportDocxQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExportDocxQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExportDocxQuery,
    ExportDocxQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ExportDocxQuery, ExportDocxQueryVariables>(
    ExportDocxDocument,
    options
  )
}
export function useExportDocxLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExportDocxQuery,
    ExportDocxQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ExportDocxQuery, ExportDocxQueryVariables>(
    ExportDocxDocument,
    options
  )
}
export function useExportDocxSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExportDocxQuery,
    ExportDocxQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ExportDocxQuery, ExportDocxQueryVariables>(
    ExportDocxDocument,
    options
  )
}
export type ExportDocxQueryHookResult = ReturnType<typeof useExportDocxQuery>
export type ExportDocxLazyQueryHookResult = ReturnType<
  typeof useExportDocxLazyQuery
>
export type ExportDocxSuspenseQueryHookResult = ReturnType<
  typeof useExportDocxSuspenseQuery
>
export type ExportDocxQueryResult = Apollo.QueryResult<
  ExportDocxQuery,
  ExportDocxQueryVariables
>
export const CheckUniqTitleDocument = gql`
  query checkUniqTitle($title: String!, $clusterId: ID!) {
    checkUniqTitle(title: $title, clusterId: $clusterId)
  }
`

/**
 * __useCheckUniqTitleQuery__
 *
 * To run a query within a React component, call `useCheckUniqTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckUniqTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckUniqTitleQuery({
 *   variables: {
 *      title: // value for 'title'
 *      clusterId: // value for 'clusterId'
 *   },
 * });
 */
export function useCheckUniqTitleQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckUniqTitleQuery,
    CheckUniqTitleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CheckUniqTitleQuery, CheckUniqTitleQueryVariables>(
    CheckUniqTitleDocument,
    options
  )
}
export function useCheckUniqTitleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckUniqTitleQuery,
    CheckUniqTitleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CheckUniqTitleQuery, CheckUniqTitleQueryVariables>(
    CheckUniqTitleDocument,
    options
  )
}
export function useCheckUniqTitleSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CheckUniqTitleQuery,
    CheckUniqTitleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CheckUniqTitleQuery,
    CheckUniqTitleQueryVariables
  >(CheckUniqTitleDocument, options)
}
export type CheckUniqTitleQueryHookResult = ReturnType<
  typeof useCheckUniqTitleQuery
>
export type CheckUniqTitleLazyQueryHookResult = ReturnType<
  typeof useCheckUniqTitleLazyQuery
>
export type CheckUniqTitleSuspenseQueryHookResult = ReturnType<
  typeof useCheckUniqTitleSuspenseQuery
>
export type CheckUniqTitleQueryResult = Apollo.QueryResult<
  CheckUniqTitleQuery,
  CheckUniqTitleQueryVariables
>
export const GetBillingsDocument = gql`
  query getBillings($pagination: PaginationInput, $filter: BillingFilterInput) {
    billings(pagination: $pagination, filter: $filter) {
      id
      billingId
      amount
      status
      type
      billingType
      description
      createdAt
      updatedAt
      paidAt
      paymentMethod
      transactionId
      userId
      renovatePayload {
        month
        year
        nodeTiers {
          currentTierId
          nodeId
          nodeName
          tierName
          seats
          isPrivate
          pricing
          basePrice
          activeUsers
          extraSeats
          extraSeatPrice
        }
      }
      newNodeTierPayload {
        tierName
        seats
        isPrivate
        nodeName
        nodeDescription
        basePrice
      }
      tierUpgradePayload {
        currentTierId
        nodeId
        tierName
        fromSeats
        toSeats
        seats
        isPrivate
        basePrice
      }
      tierDowngradePayload {
        currentTierId
        nodeId
        tierName
        fromSeats
        toSeats
        seats
        isPrivate
        basePrice
      }
    }
  }
`

/**
 * __useGetBillingsQuery__
 *
 * To run a query within a React component, call `useGetBillingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetBillingsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetBillingsQuery,
    GetBillingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetBillingsQuery, GetBillingsQueryVariables>(
    GetBillingsDocument,
    options
  )
}
export function useGetBillingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBillingsQuery,
    GetBillingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetBillingsQuery, GetBillingsQueryVariables>(
    GetBillingsDocument,
    options
  )
}
export function useGetBillingsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetBillingsQuery,
    GetBillingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetBillingsQuery, GetBillingsQueryVariables>(
    GetBillingsDocument,
    options
  )
}
export type GetBillingsQueryHookResult = ReturnType<typeof useGetBillingsQuery>
export type GetBillingsLazyQueryHookResult = ReturnType<
  typeof useGetBillingsLazyQuery
>
export type GetBillingsSuspenseQueryHookResult = ReturnType<
  typeof useGetBillingsSuspenseQuery
>
export type GetBillingsQueryResult = Apollo.QueryResult<
  GetBillingsQuery,
  GetBillingsQueryVariables
>
export const CreatePaypalOrderDocument = gql`
  mutation createPaypalOrder($input: CreatePaypalOrderInput!) {
    createPaypalOrder(input: $input) {
      id
    }
  }
`
export type CreatePaypalOrderMutationFn = Apollo.MutationFunction<
  CreatePaypalOrderMutation,
  CreatePaypalOrderMutationVariables
>

/**
 * __useCreatePaypalOrderMutation__
 *
 * To run a mutation, you first call `useCreatePaypalOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaypalOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaypalOrderMutation, { data, loading, error }] = useCreatePaypalOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePaypalOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePaypalOrderMutation,
    CreatePaypalOrderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreatePaypalOrderMutation,
    CreatePaypalOrderMutationVariables
  >(CreatePaypalOrderDocument, options)
}
export type CreatePaypalOrderMutationHookResult = ReturnType<
  typeof useCreatePaypalOrderMutation
>
export type CreatePaypalOrderMutationResult =
  Apollo.MutationResult<CreatePaypalOrderMutation>
export type CreatePaypalOrderMutationOptions = Apollo.BaseMutationOptions<
  CreatePaypalOrderMutation,
  CreatePaypalOrderMutationVariables
>
export const CreatePaypalVaultSetupOrderDocument = gql`
  mutation createPaypalVaultSetupOrder(
    $returnUrl: String!
    $cancelUrl: String!
  ) {
    createPaypalVaultSetupOrder(returnUrl: $returnUrl, cancelUrl: $cancelUrl) {
      id
    }
  }
`
export type CreatePaypalVaultSetupOrderMutationFn = Apollo.MutationFunction<
  CreatePaypalVaultSetupOrderMutation,
  CreatePaypalVaultSetupOrderMutationVariables
>

/**
 * __useCreatePaypalVaultSetupOrderMutation__
 *
 * To run a mutation, you first call `useCreatePaypalVaultSetupOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaypalVaultSetupOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaypalVaultSetupOrderMutation, { data, loading, error }] = useCreatePaypalVaultSetupOrderMutation({
 *   variables: {
 *      returnUrl: // value for 'returnUrl'
 *      cancelUrl: // value for 'cancelUrl'
 *   },
 * });
 */
export function useCreatePaypalVaultSetupOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePaypalVaultSetupOrderMutation,
    CreatePaypalVaultSetupOrderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreatePaypalVaultSetupOrderMutation,
    CreatePaypalVaultSetupOrderMutationVariables
  >(CreatePaypalVaultSetupOrderDocument, options)
}
export type CreatePaypalVaultSetupOrderMutationHookResult = ReturnType<
  typeof useCreatePaypalVaultSetupOrderMutation
>
export type CreatePaypalVaultSetupOrderMutationResult =
  Apollo.MutationResult<CreatePaypalVaultSetupOrderMutation>
export type CreatePaypalVaultSetupOrderMutationOptions =
  Apollo.BaseMutationOptions<
    CreatePaypalVaultSetupOrderMutation,
    CreatePaypalVaultSetupOrderMutationVariables
  >
export const ProcessCouponBillingDocument = gql`
  mutation processCouponBilling($billingId: ID!, $couponCode: String!) {
    processCouponBilling(billingId: $billingId, couponCode: $couponCode)
  }
`
export type ProcessCouponBillingMutationFn = Apollo.MutationFunction<
  ProcessCouponBillingMutation,
  ProcessCouponBillingMutationVariables
>

/**
 * __useProcessCouponBillingMutation__
 *
 * To run a mutation, you first call `useProcessCouponBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessCouponBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processCouponBillingMutation, { data, loading, error }] = useProcessCouponBillingMutation({
 *   variables: {
 *      billingId: // value for 'billingId'
 *      couponCode: // value for 'couponCode'
 *   },
 * });
 */
export function useProcessCouponBillingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ProcessCouponBillingMutation,
    ProcessCouponBillingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ProcessCouponBillingMutation,
    ProcessCouponBillingMutationVariables
  >(ProcessCouponBillingDocument, options)
}
export type ProcessCouponBillingMutationHookResult = ReturnType<
  typeof useProcessCouponBillingMutation
>
export type ProcessCouponBillingMutationResult =
  Apollo.MutationResult<ProcessCouponBillingMutation>
export type ProcessCouponBillingMutationOptions = Apollo.BaseMutationOptions<
  ProcessCouponBillingMutation,
  ProcessCouponBillingMutationVariables
>
export const CreateWechatPayOrderDocument = gql`
  mutation createWechatPayOrder($input: CreateWechatPayOrderInput!) {
    createWechatPayOrder(input: $input) {
      prepayId
      paymentMethod
      paymentParameters {
        appId
        timeStamp
        nonceStr
        package
        signType
        paySign
      }
      codeUrl
      h5Url
    }
  }
`
export type CreateWechatPayOrderMutationFn = Apollo.MutationFunction<
  CreateWechatPayOrderMutation,
  CreateWechatPayOrderMutationVariables
>

/**
 * __useCreateWechatPayOrderMutation__
 *
 * To run a mutation, you first call `useCreateWechatPayOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWechatPayOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWechatPayOrderMutation, { data, loading, error }] = useCreateWechatPayOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWechatPayOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateWechatPayOrderMutation,
    CreateWechatPayOrderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateWechatPayOrderMutation,
    CreateWechatPayOrderMutationVariables
  >(CreateWechatPayOrderDocument, options)
}
export type CreateWechatPayOrderMutationHookResult = ReturnType<
  typeof useCreateWechatPayOrderMutation
>
export type CreateWechatPayOrderMutationResult =
  Apollo.MutationResult<CreateWechatPayOrderMutation>
export type CreateWechatPayOrderMutationOptions = Apollo.BaseMutationOptions<
  CreateWechatPayOrderMutation,
  CreateWechatPayOrderMutationVariables
>
export const UpdateClusterMemberDocument = gql`
  mutation updateClusterMember($input: UpdateClusterMemberInput!) {
    updateClusterMember(input: $input) {
      ...ClusterMemberDetail
    }
  }
  ${ClusterMemberDetailFragmentDoc}
`
export type UpdateClusterMemberMutationFn = Apollo.MutationFunction<
  UpdateClusterMemberMutation,
  UpdateClusterMemberMutationVariables
>

/**
 * __useUpdateClusterMemberMutation__
 *
 * To run a mutation, you first call `useUpdateClusterMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClusterMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClusterMemberMutation, { data, loading, error }] = useUpdateClusterMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClusterMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateClusterMemberMutation,
    UpdateClusterMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateClusterMemberMutation,
    UpdateClusterMemberMutationVariables
  >(UpdateClusterMemberDocument, options)
}
export type UpdateClusterMemberMutationHookResult = ReturnType<
  typeof useUpdateClusterMemberMutation
>
export type UpdateClusterMemberMutationResult =
  Apollo.MutationResult<UpdateClusterMemberMutation>
export type UpdateClusterMemberMutationOptions = Apollo.BaseMutationOptions<
  UpdateClusterMemberMutation,
  UpdateClusterMemberMutationVariables
>
export const CreateClusterMemberDocument = gql`
  mutation createClusterMember($input: CreateClusterMemberInput!) {
    createClusterMember(input: $input) {
      ...ClusterMemberDetail
    }
  }
  ${ClusterMemberDetailFragmentDoc}
`
export type CreateClusterMemberMutationFn = Apollo.MutationFunction<
  CreateClusterMemberMutation,
  CreateClusterMemberMutationVariables
>

/**
 * __useCreateClusterMemberMutation__
 *
 * To run a mutation, you first call `useCreateClusterMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClusterMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClusterMemberMutation, { data, loading, error }] = useCreateClusterMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClusterMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateClusterMemberMutation,
    CreateClusterMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateClusterMemberMutation,
    CreateClusterMemberMutationVariables
  >(CreateClusterMemberDocument, options)
}
export type CreateClusterMemberMutationHookResult = ReturnType<
  typeof useCreateClusterMemberMutation
>
export type CreateClusterMemberMutationResult =
  Apollo.MutationResult<CreateClusterMemberMutation>
export type CreateClusterMemberMutationOptions = Apollo.BaseMutationOptions<
  CreateClusterMemberMutation,
  CreateClusterMemberMutationVariables
>
export const RemoveClusterMemberDocument = gql`
  mutation removeClusterMember($id: ID!) {
    removeClusterMember(id: $id)
  }
`
export type RemoveClusterMemberMutationFn = Apollo.MutationFunction<
  RemoveClusterMemberMutation,
  RemoveClusterMemberMutationVariables
>

/**
 * __useRemoveClusterMemberMutation__
 *
 * To run a mutation, you first call `useRemoveClusterMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveClusterMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeClusterMemberMutation, { data, loading, error }] = useRemoveClusterMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveClusterMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveClusterMemberMutation,
    RemoveClusterMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RemoveClusterMemberMutation,
    RemoveClusterMemberMutationVariables
  >(RemoveClusterMemberDocument, options)
}
export type RemoveClusterMemberMutationHookResult = ReturnType<
  typeof useRemoveClusterMemberMutation
>
export type RemoveClusterMemberMutationResult =
  Apollo.MutationResult<RemoveClusterMemberMutation>
export type RemoveClusterMemberMutationOptions = Apollo.BaseMutationOptions<
  RemoveClusterMemberMutation,
  RemoveClusterMemberMutationVariables
>
export const TransferClusterOwnershipDocument = gql`
  mutation transferClusterOwnership($input: TransferClusterOwnershipInput!) {
    transferClusterOwnership(input: $input) {
      ...ClusterDetail
      isOwner
      isModerator
    }
  }
  ${ClusterDetailFragmentDoc}
`
export type TransferClusterOwnershipMutationFn = Apollo.MutationFunction<
  TransferClusterOwnershipMutation,
  TransferClusterOwnershipMutationVariables
>

/**
 * __useTransferClusterOwnershipMutation__
 *
 * To run a mutation, you first call `useTransferClusterOwnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferClusterOwnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferClusterOwnershipMutation, { data, loading, error }] = useTransferClusterOwnershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransferClusterOwnershipMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TransferClusterOwnershipMutation,
    TransferClusterOwnershipMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    TransferClusterOwnershipMutation,
    TransferClusterOwnershipMutationVariables
  >(TransferClusterOwnershipDocument, options)
}
export type TransferClusterOwnershipMutationHookResult = ReturnType<
  typeof useTransferClusterOwnershipMutation
>
export type TransferClusterOwnershipMutationResult =
  Apollo.MutationResult<TransferClusterOwnershipMutation>
export type TransferClusterOwnershipMutationOptions =
  Apollo.BaseMutationOptions<
    TransferClusterOwnershipMutation,
    TransferClusterOwnershipMutationVariables
  >
export const RemoveSelfFromClusterDocument = gql`
  mutation removeSelfFromCluster($clusterId: ID!) {
    removeSelfFromCluster(clusterId: $clusterId)
  }
`
export type RemoveSelfFromClusterMutationFn = Apollo.MutationFunction<
  RemoveSelfFromClusterMutation,
  RemoveSelfFromClusterMutationVariables
>

/**
 * __useRemoveSelfFromClusterMutation__
 *
 * To run a mutation, you first call `useRemoveSelfFromClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSelfFromClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSelfFromClusterMutation, { data, loading, error }] = useRemoveSelfFromClusterMutation({
 *   variables: {
 *      clusterId: // value for 'clusterId'
 *   },
 * });
 */
export function useRemoveSelfFromClusterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveSelfFromClusterMutation,
    RemoveSelfFromClusterMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RemoveSelfFromClusterMutation,
    RemoveSelfFromClusterMutationVariables
  >(RemoveSelfFromClusterDocument, options)
}
export type RemoveSelfFromClusterMutationHookResult = ReturnType<
  typeof useRemoveSelfFromClusterMutation
>
export type RemoveSelfFromClusterMutationResult =
  Apollo.MutationResult<RemoveSelfFromClusterMutation>
export type RemoveSelfFromClusterMutationOptions = Apollo.BaseMutationOptions<
  RemoveSelfFromClusterMutation,
  RemoveSelfFromClusterMutationVariables
>
export const GetMembersByClusterIdDocument = gql`
  query getMembersByClusterId($clusterId: ID!) {
    clusterMembersByClusterId(clusterId: $clusterId) {
      ...ClusterMemberDetail
    }
  }
  ${ClusterMemberDetailFragmentDoc}
`

/**
 * __useGetMembersByClusterIdQuery__
 *
 * To run a query within a React component, call `useGetMembersByClusterIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembersByClusterIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembersByClusterIdQuery({
 *   variables: {
 *      clusterId: // value for 'clusterId'
 *   },
 * });
 */
export function useGetMembersByClusterIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMembersByClusterIdQuery,
    GetMembersByClusterIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetMembersByClusterIdQuery,
    GetMembersByClusterIdQueryVariables
  >(GetMembersByClusterIdDocument, options)
}
export function useGetMembersByClusterIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMembersByClusterIdQuery,
    GetMembersByClusterIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetMembersByClusterIdQuery,
    GetMembersByClusterIdQueryVariables
  >(GetMembersByClusterIdDocument, options)
}
export function useGetMembersByClusterIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetMembersByClusterIdQuery,
    GetMembersByClusterIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GetMembersByClusterIdQuery,
    GetMembersByClusterIdQueryVariables
  >(GetMembersByClusterIdDocument, options)
}
export type GetMembersByClusterIdQueryHookResult = ReturnType<
  typeof useGetMembersByClusterIdQuery
>
export type GetMembersByClusterIdLazyQueryHookResult = ReturnType<
  typeof useGetMembersByClusterIdLazyQuery
>
export type GetMembersByClusterIdSuspenseQueryHookResult = ReturnType<
  typeof useGetMembersByClusterIdSuspenseQuery
>
export type GetMembersByClusterIdQueryResult = Apollo.QueryResult<
  GetMembersByClusterIdQuery,
  GetMembersByClusterIdQueryVariables
>
export const CreateClusterDocument = gql`
  mutation createCluster($input: CreateClusterInput!) {
    createCluster(input: $input) {
      ...ClusterDetail
      moderators {
        ...ClusterMemberDetail
      }
    }
  }
  ${ClusterDetailFragmentDoc}
  ${ClusterMemberDetailFragmentDoc}
`
export type CreateClusterMutationFn = Apollo.MutationFunction<
  CreateClusterMutation,
  CreateClusterMutationVariables
>

/**
 * __useCreateClusterMutation__
 *
 * To run a mutation, you first call `useCreateClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClusterMutation, { data, loading, error }] = useCreateClusterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClusterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateClusterMutation,
    CreateClusterMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateClusterMutation,
    CreateClusterMutationVariables
  >(CreateClusterDocument, options)
}
export type CreateClusterMutationHookResult = ReturnType<
  typeof useCreateClusterMutation
>
export type CreateClusterMutationResult =
  Apollo.MutationResult<CreateClusterMutation>
export type CreateClusterMutationOptions = Apollo.BaseMutationOptions<
  CreateClusterMutation,
  CreateClusterMutationVariables
>
export const UpdateClusterDocument = gql`
  mutation updateCluster($input: UpdateClusterInput!) {
    updateCluster(input: $input) {
      ...ClusterDetail
      moderators {
        ...ClusterMemberDetail
      }
    }
  }
  ${ClusterDetailFragmentDoc}
  ${ClusterMemberDetailFragmentDoc}
`
export type UpdateClusterMutationFn = Apollo.MutationFunction<
  UpdateClusterMutation,
  UpdateClusterMutationVariables
>

/**
 * __useUpdateClusterMutation__
 *
 * To run a mutation, you first call `useUpdateClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClusterMutation, { data, loading, error }] = useUpdateClusterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClusterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateClusterMutation,
    UpdateClusterMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateClusterMutation,
    UpdateClusterMutationVariables
  >(UpdateClusterDocument, options)
}
export type UpdateClusterMutationHookResult = ReturnType<
  typeof useUpdateClusterMutation
>
export type UpdateClusterMutationResult =
  Apollo.MutationResult<UpdateClusterMutation>
export type UpdateClusterMutationOptions = Apollo.BaseMutationOptions<
  UpdateClusterMutation,
  UpdateClusterMutationVariables
>
export const DeleteClusterDocument = gql`
  mutation deleteCluster($id: ID!) {
    deleteCluster(id: $id)
  }
`
export type DeleteClusterMutationFn = Apollo.MutationFunction<
  DeleteClusterMutation,
  DeleteClusterMutationVariables
>

/**
 * __useDeleteClusterMutation__
 *
 * To run a mutation, you first call `useDeleteClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClusterMutation, { data, loading, error }] = useDeleteClusterMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClusterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteClusterMutation,
    DeleteClusterMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteClusterMutation,
    DeleteClusterMutationVariables
  >(DeleteClusterDocument, options)
}
export type DeleteClusterMutationHookResult = ReturnType<
  typeof useDeleteClusterMutation
>
export type DeleteClusterMutationResult =
  Apollo.MutationResult<DeleteClusterMutation>
export type DeleteClusterMutationOptions = Apollo.BaseMutationOptions<
  DeleteClusterMutation,
  DeleteClusterMutationVariables
>
export const AvailableClustersDocument = gql`
  query availableClusters($input: ClusterListInput!) {
    availableClusters(input: $input) {
      ...ClusterDetail
      moderators {
        ...ClusterMemberDetail
      }
      articlesCount
      votesCount
    }
  }
  ${ClusterDetailFragmentDoc}
  ${ClusterMemberDetailFragmentDoc}
`

/**
 * __useAvailableClustersQuery__
 *
 * To run a query within a React component, call `useAvailableClustersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableClustersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableClustersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAvailableClustersQuery(
  baseOptions: Apollo.QueryHookOptions<
    AvailableClustersQuery,
    AvailableClustersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AvailableClustersQuery,
    AvailableClustersQueryVariables
  >(AvailableClustersDocument, options)
}
export function useAvailableClustersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AvailableClustersQuery,
    AvailableClustersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AvailableClustersQuery,
    AvailableClustersQueryVariables
  >(AvailableClustersDocument, options)
}
export function useAvailableClustersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AvailableClustersQuery,
    AvailableClustersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AvailableClustersQuery,
    AvailableClustersQueryVariables
  >(AvailableClustersDocument, options)
}
export type AvailableClustersQueryHookResult = ReturnType<
  typeof useAvailableClustersQuery
>
export type AvailableClustersLazyQueryHookResult = ReturnType<
  typeof useAvailableClustersLazyQuery
>
export type AvailableClustersSuspenseQueryHookResult = ReturnType<
  typeof useAvailableClustersSuspenseQuery
>
export type AvailableClustersQueryResult = Apollo.QueryResult<
  AvailableClustersQuery,
  AvailableClustersQueryVariables
>
export const ClusterListDocument = gql`
  query clusterList($input: ClusterListInput!) {
    availableClusters(input: $input) {
      ...ClusterDetail
      articlesCount
      contributionsCount
      votesCount
    }
  }
  ${ClusterDetailFragmentDoc}
`

/**
 * __useClusterListQuery__
 *
 * To run a query within a React component, call `useClusterListQuery` and pass it any options that fit your needs.
 * When your component renders, `useClusterListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClusterListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClusterListQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClusterListQuery,
    ClusterListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ClusterListQuery, ClusterListQueryVariables>(
    ClusterListDocument,
    options
  )
}
export function useClusterListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClusterListQuery,
    ClusterListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ClusterListQuery, ClusterListQueryVariables>(
    ClusterListDocument,
    options
  )
}
export function useClusterListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ClusterListQuery,
    ClusterListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ClusterListQuery, ClusterListQueryVariables>(
    ClusterListDocument,
    options
  )
}
export type ClusterListQueryHookResult = ReturnType<typeof useClusterListQuery>
export type ClusterListLazyQueryHookResult = ReturnType<
  typeof useClusterListLazyQuery
>
export type ClusterListSuspenseQueryHookResult = ReturnType<
  typeof useClusterListSuspenseQuery
>
export type ClusterListQueryResult = Apollo.QueryResult<
  ClusterListQuery,
  ClusterListQueryVariables
>
export const ClusterForPerspectiveDocument = gql`
  query clusterForPerspective($id: ID!) {
    cluster(id: $id) {
      ...ClusterDetail
      articleVotes {
        articleId
        userId
        justification
        user {
          id
          username
        }
      }
      articles {
        ...ArticleDetail
        title
        latestContent
        originalContent
        contributions {
          ...ContributionDetail
        }
      }
    }
  }
  ${ClusterDetailFragmentDoc}
  ${ArticleDetailFragmentDoc}
  ${ContributionDetailFragmentDoc}
`

/**
 * __useClusterForPerspectiveQuery__
 *
 * To run a query within a React component, call `useClusterForPerspectiveQuery` and pass it any options that fit your needs.
 * When your component renders, `useClusterForPerspectiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClusterForPerspectiveQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClusterForPerspectiveQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClusterForPerspectiveQuery,
    ClusterForPerspectiveQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ClusterForPerspectiveQuery,
    ClusterForPerspectiveQueryVariables
  >(ClusterForPerspectiveDocument, options)
}
export function useClusterForPerspectiveLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClusterForPerspectiveQuery,
    ClusterForPerspectiveQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ClusterForPerspectiveQuery,
    ClusterForPerspectiveQueryVariables
  >(ClusterForPerspectiveDocument, options)
}
export function useClusterForPerspectiveSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ClusterForPerspectiveQuery,
    ClusterForPerspectiveQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ClusterForPerspectiveQuery,
    ClusterForPerspectiveQueryVariables
  >(ClusterForPerspectiveDocument, options)
}
export type ClusterForPerspectiveQueryHookResult = ReturnType<
  typeof useClusterForPerspectiveQuery
>
export type ClusterForPerspectiveLazyQueryHookResult = ReturnType<
  typeof useClusterForPerspectiveLazyQuery
>
export type ClusterForPerspectiveSuspenseQueryHookResult = ReturnType<
  typeof useClusterForPerspectiveSuspenseQuery
>
export type ClusterForPerspectiveQueryResult = Apollo.QueryResult<
  ClusterForPerspectiveQuery,
  ClusterForPerspectiveQueryVariables
>
export const ClusterByIdDocument = gql`
  query clusterById($id: ID!) {
    clusterById(id: $id) {
      ...ClusterDetail
    }
  }
  ${ClusterDetailFragmentDoc}
`

/**
 * __useClusterByIdQuery__
 *
 * To run a query within a React component, call `useClusterByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useClusterByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClusterByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClusterByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClusterByIdQuery,
    ClusterByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ClusterByIdQuery, ClusterByIdQueryVariables>(
    ClusterByIdDocument,
    options
  )
}
export function useClusterByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClusterByIdQuery,
    ClusterByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ClusterByIdQuery, ClusterByIdQueryVariables>(
    ClusterByIdDocument,
    options
  )
}
export function useClusterByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ClusterByIdQuery,
    ClusterByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ClusterByIdQuery, ClusterByIdQueryVariables>(
    ClusterByIdDocument,
    options
  )
}
export type ClusterByIdQueryHookResult = ReturnType<typeof useClusterByIdQuery>
export type ClusterByIdLazyQueryHookResult = ReturnType<
  typeof useClusterByIdLazyQuery
>
export type ClusterByIdSuspenseQueryHookResult = ReturnType<
  typeof useClusterByIdSuspenseQuery
>
export type ClusterByIdQueryResult = Apollo.QueryResult<
  ClusterByIdQuery,
  ClusterByIdQueryVariables
>
export const TransferClusterToNodeDocument = gql`
  mutation transferClusterToNode($input: TransferClusterToNodeInput!) {
    transferClusterToNode(input: $input) {
      ...ClusterDetail
      nodeId
    }
  }
  ${ClusterDetailFragmentDoc}
`
export type TransferClusterToNodeMutationFn = Apollo.MutationFunction<
  TransferClusterToNodeMutation,
  TransferClusterToNodeMutationVariables
>

/**
 * __useTransferClusterToNodeMutation__
 *
 * To run a mutation, you first call `useTransferClusterToNodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferClusterToNodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferClusterToNodeMutation, { data, loading, error }] = useTransferClusterToNodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransferClusterToNodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TransferClusterToNodeMutation,
    TransferClusterToNodeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    TransferClusterToNodeMutation,
    TransferClusterToNodeMutationVariables
  >(TransferClusterToNodeDocument, options)
}
export type TransferClusterToNodeMutationHookResult = ReturnType<
  typeof useTransferClusterToNodeMutation
>
export type TransferClusterToNodeMutationResult =
  Apollo.MutationResult<TransferClusterToNodeMutation>
export type TransferClusterToNodeMutationOptions = Apollo.BaseMutationOptions<
  TransferClusterToNodeMutation,
  TransferClusterToNodeMutationVariables
>
export const BumpsForContributionDocument = gql`
  query bumpsForContribution($contributionId: ID!) {
    contributionBumpsByContribution(contributionId: $contributionId) {
      ...ContributionBumpDetail
    }
  }
  ${ContributionBumpDetailFragmentDoc}
`

/**
 * __useBumpsForContributionQuery__
 *
 * To run a query within a React component, call `useBumpsForContributionQuery` and pass it any options that fit your needs.
 * When your component renders, `useBumpsForContributionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBumpsForContributionQuery({
 *   variables: {
 *      contributionId: // value for 'contributionId'
 *   },
 * });
 */
export function useBumpsForContributionQuery(
  baseOptions: Apollo.QueryHookOptions<
    BumpsForContributionQuery,
    BumpsForContributionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    BumpsForContributionQuery,
    BumpsForContributionQueryVariables
  >(BumpsForContributionDocument, options)
}
export function useBumpsForContributionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BumpsForContributionQuery,
    BumpsForContributionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BumpsForContributionQuery,
    BumpsForContributionQueryVariables
  >(BumpsForContributionDocument, options)
}
export function useBumpsForContributionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    BumpsForContributionQuery,
    BumpsForContributionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    BumpsForContributionQuery,
    BumpsForContributionQueryVariables
  >(BumpsForContributionDocument, options)
}
export type BumpsForContributionQueryHookResult = ReturnType<
  typeof useBumpsForContributionQuery
>
export type BumpsForContributionLazyQueryHookResult = ReturnType<
  typeof useBumpsForContributionLazyQuery
>
export type BumpsForContributionSuspenseQueryHookResult = ReturnType<
  typeof useBumpsForContributionSuspenseQuery
>
export type BumpsForContributionQueryResult = Apollo.QueryResult<
  BumpsForContributionQuery,
  BumpsForContributionQueryVariables
>
export const BumpContributionDocument = gql`
  mutation bumpContribution($input: BumpContributionInput!) {
    bumpContribution(input: $input) {
      ...ContributionBumpDetail
    }
  }
  ${ContributionBumpDetailFragmentDoc}
`
export type BumpContributionMutationFn = Apollo.MutationFunction<
  BumpContributionMutation,
  BumpContributionMutationVariables
>

/**
 * __useBumpContributionMutation__
 *
 * To run a mutation, you first call `useBumpContributionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBumpContributionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bumpContributionMutation, { data, loading, error }] = useBumpContributionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBumpContributionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BumpContributionMutation,
    BumpContributionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    BumpContributionMutation,
    BumpContributionMutationVariables
  >(BumpContributionDocument, options)
}
export type BumpContributionMutationHookResult = ReturnType<
  typeof useBumpContributionMutation
>
export type BumpContributionMutationResult =
  Apollo.MutationResult<BumpContributionMutation>
export type BumpContributionMutationOptions = Apollo.BaseMutationOptions<
  BumpContributionMutation,
  BumpContributionMutationVariables
>
export const InboundOutboundContributionsDocument = gql`
  query inboundOutboundContributions($userId: ID!) {
    inboundOutboundContributions(userId: $userId) {
      corank
      inbound {
        ...PerTypeResponseDetail
      }
      outbound {
        ...PerTypeResponseDetail
      }
    }
  }
  ${PerTypeResponseDetailFragmentDoc}
`

/**
 * __useInboundOutboundContributionsQuery__
 *
 * To run a query within a React component, call `useInboundOutboundContributionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboundOutboundContributionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboundOutboundContributionsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useInboundOutboundContributionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    InboundOutboundContributionsQuery,
    InboundOutboundContributionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    InboundOutboundContributionsQuery,
    InboundOutboundContributionsQueryVariables
  >(InboundOutboundContributionsDocument, options)
}
export function useInboundOutboundContributionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InboundOutboundContributionsQuery,
    InboundOutboundContributionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    InboundOutboundContributionsQuery,
    InboundOutboundContributionsQueryVariables
  >(InboundOutboundContributionsDocument, options)
}
export function useInboundOutboundContributionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    InboundOutboundContributionsQuery,
    InboundOutboundContributionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    InboundOutboundContributionsQuery,
    InboundOutboundContributionsQueryVariables
  >(InboundOutboundContributionsDocument, options)
}
export type InboundOutboundContributionsQueryHookResult = ReturnType<
  typeof useInboundOutboundContributionsQuery
>
export type InboundOutboundContributionsLazyQueryHookResult = ReturnType<
  typeof useInboundOutboundContributionsLazyQuery
>
export type InboundOutboundContributionsSuspenseQueryHookResult = ReturnType<
  typeof useInboundOutboundContributionsSuspenseQuery
>
export type InboundOutboundContributionsQueryResult = Apollo.QueryResult<
  InboundOutboundContributionsQuery,
  InboundOutboundContributionsQueryVariables
>
export const UserTotalContributionsDocument = gql`
  query userTotalContributions($userId: ID!) {
    userTotalContributions(userId: $userId)
  }
`

/**
 * __useUserTotalContributionsQuery__
 *
 * To run a query within a React component, call `useUserTotalContributionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTotalContributionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTotalContributionsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserTotalContributionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserTotalContributionsQuery,
    UserTotalContributionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    UserTotalContributionsQuery,
    UserTotalContributionsQueryVariables
  >(UserTotalContributionsDocument, options)
}
export function useUserTotalContributionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserTotalContributionsQuery,
    UserTotalContributionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UserTotalContributionsQuery,
    UserTotalContributionsQueryVariables
  >(UserTotalContributionsDocument, options)
}
export function useUserTotalContributionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UserTotalContributionsQuery,
    UserTotalContributionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UserTotalContributionsQuery,
    UserTotalContributionsQueryVariables
  >(UserTotalContributionsDocument, options)
}
export type UserTotalContributionsQueryHookResult = ReturnType<
  typeof useUserTotalContributionsQuery
>
export type UserTotalContributionsLazyQueryHookResult = ReturnType<
  typeof useUserTotalContributionsLazyQuery
>
export type UserTotalContributionsSuspenseQueryHookResult = ReturnType<
  typeof useUserTotalContributionsSuspenseQuery
>
export type UserTotalContributionsQueryResult = Apollo.QueryResult<
  UserTotalContributionsQuery,
  UserTotalContributionsQueryVariables
>
export const UserTotalPerspectivesDocument = gql`
  query userTotalPerspectives($userId: ID!) {
    userTotalPerspectives(userId: $userId)
  }
`

/**
 * __useUserTotalPerspectivesQuery__
 *
 * To run a query within a React component, call `useUserTotalPerspectivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTotalPerspectivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTotalPerspectivesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserTotalPerspectivesQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserTotalPerspectivesQuery,
    UserTotalPerspectivesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    UserTotalPerspectivesQuery,
    UserTotalPerspectivesQueryVariables
  >(UserTotalPerspectivesDocument, options)
}
export function useUserTotalPerspectivesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserTotalPerspectivesQuery,
    UserTotalPerspectivesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UserTotalPerspectivesQuery,
    UserTotalPerspectivesQueryVariables
  >(UserTotalPerspectivesDocument, options)
}
export function useUserTotalPerspectivesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UserTotalPerspectivesQuery,
    UserTotalPerspectivesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UserTotalPerspectivesQuery,
    UserTotalPerspectivesQueryVariables
  >(UserTotalPerspectivesDocument, options)
}
export type UserTotalPerspectivesQueryHookResult = ReturnType<
  typeof useUserTotalPerspectivesQuery
>
export type UserTotalPerspectivesLazyQueryHookResult = ReturnType<
  typeof useUserTotalPerspectivesLazyQuery
>
export type UserTotalPerspectivesSuspenseQueryHookResult = ReturnType<
  typeof useUserTotalPerspectivesSuspenseQuery
>
export type UserTotalPerspectivesQueryResult = Apollo.QueryResult<
  UserTotalPerspectivesQuery,
  UserTotalPerspectivesQueryVariables
>
export const ContributionsForArticleDocument = gql`
  query contributionsForArticle(
    $articleId: ID!
    $status: [ContributionStatus!]!
  ) {
    contributionsByArticle(articleId: $articleId, status: $status) {
      ...ContributionEditDetail
    }
  }
  ${ContributionEditDetailFragmentDoc}
`

/**
 * __useContributionsForArticleQuery__
 *
 * To run a query within a React component, call `useContributionsForArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useContributionsForArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContributionsForArticleQuery({
 *   variables: {
 *      articleId: // value for 'articleId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useContributionsForArticleQuery(
  baseOptions: Apollo.QueryHookOptions<
    ContributionsForArticleQuery,
    ContributionsForArticleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ContributionsForArticleQuery,
    ContributionsForArticleQueryVariables
  >(ContributionsForArticleDocument, options)
}
export function useContributionsForArticleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContributionsForArticleQuery,
    ContributionsForArticleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContributionsForArticleQuery,
    ContributionsForArticleQueryVariables
  >(ContributionsForArticleDocument, options)
}
export function useContributionsForArticleSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ContributionsForArticleQuery,
    ContributionsForArticleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ContributionsForArticleQuery,
    ContributionsForArticleQueryVariables
  >(ContributionsForArticleDocument, options)
}
export type ContributionsForArticleQueryHookResult = ReturnType<
  typeof useContributionsForArticleQuery
>
export type ContributionsForArticleLazyQueryHookResult = ReturnType<
  typeof useContributionsForArticleLazyQuery
>
export type ContributionsForArticleSuspenseQueryHookResult = ReturnType<
  typeof useContributionsForArticleSuspenseQuery
>
export type ContributionsForArticleQueryResult = Apollo.QueryResult<
  ContributionsForArticleQuery,
  ContributionsForArticleQueryVariables
>
export const ContributionsForPerspectiveDocument = gql`
  query contributionsForPerspective(
    $articleId: ID!
    $status: String
    $type: String
  ) {
    contributionsByPerspective(
      articleId: $articleId
      status: $status
      type: $type
    ) {
      ...FullContributionDetail
    }
  }
  ${FullContributionDetailFragmentDoc}
`

/**
 * __useContributionsForPerspectiveQuery__
 *
 * To run a query within a React component, call `useContributionsForPerspectiveQuery` and pass it any options that fit your needs.
 * When your component renders, `useContributionsForPerspectiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContributionsForPerspectiveQuery({
 *   variables: {
 *      articleId: // value for 'articleId'
 *      status: // value for 'status'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useContributionsForPerspectiveQuery(
  baseOptions: Apollo.QueryHookOptions<
    ContributionsForPerspectiveQuery,
    ContributionsForPerspectiveQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ContributionsForPerspectiveQuery,
    ContributionsForPerspectiveQueryVariables
  >(ContributionsForPerspectiveDocument, options)
}
export function useContributionsForPerspectiveLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContributionsForPerspectiveQuery,
    ContributionsForPerspectiveQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContributionsForPerspectiveQuery,
    ContributionsForPerspectiveQueryVariables
  >(ContributionsForPerspectiveDocument, options)
}
export function useContributionsForPerspectiveSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ContributionsForPerspectiveQuery,
    ContributionsForPerspectiveQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ContributionsForPerspectiveQuery,
    ContributionsForPerspectiveQueryVariables
  >(ContributionsForPerspectiveDocument, options)
}
export type ContributionsForPerspectiveQueryHookResult = ReturnType<
  typeof useContributionsForPerspectiveQuery
>
export type ContributionsForPerspectiveLazyQueryHookResult = ReturnType<
  typeof useContributionsForPerspectiveLazyQuery
>
export type ContributionsForPerspectiveSuspenseQueryHookResult = ReturnType<
  typeof useContributionsForPerspectiveSuspenseQuery
>
export type ContributionsForPerspectiveQueryResult = Apollo.QueryResult<
  ContributionsForPerspectiveQuery,
  ContributionsForPerspectiveQueryVariables
>
export const ContributionsForClusterDocument = gql`
  query contributionsForCluster(
    $clusterId: ID!
    $status: String
    $type: String
  ) {
    contributionsByCluster(
      clusterId: $clusterId
      status: $status
      type: $type
    ) {
      ...FullContributionDetail
    }
  }
  ${FullContributionDetailFragmentDoc}
`

/**
 * __useContributionsForClusterQuery__
 *
 * To run a query within a React component, call `useContributionsForClusterQuery` and pass it any options that fit your needs.
 * When your component renders, `useContributionsForClusterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContributionsForClusterQuery({
 *   variables: {
 *      clusterId: // value for 'clusterId'
 *      status: // value for 'status'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useContributionsForClusterQuery(
  baseOptions: Apollo.QueryHookOptions<
    ContributionsForClusterQuery,
    ContributionsForClusterQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ContributionsForClusterQuery,
    ContributionsForClusterQueryVariables
  >(ContributionsForClusterDocument, options)
}
export function useContributionsForClusterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContributionsForClusterQuery,
    ContributionsForClusterQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContributionsForClusterQuery,
    ContributionsForClusterQueryVariables
  >(ContributionsForClusterDocument, options)
}
export function useContributionsForClusterSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ContributionsForClusterQuery,
    ContributionsForClusterQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ContributionsForClusterQuery,
    ContributionsForClusterQueryVariables
  >(ContributionsForClusterDocument, options)
}
export type ContributionsForClusterQueryHookResult = ReturnType<
  typeof useContributionsForClusterQuery
>
export type ContributionsForClusterLazyQueryHookResult = ReturnType<
  typeof useContributionsForClusterLazyQuery
>
export type ContributionsForClusterSuspenseQueryHookResult = ReturnType<
  typeof useContributionsForClusterSuspenseQuery
>
export type ContributionsForClusterQueryResult = Apollo.QueryResult<
  ContributionsForClusterQuery,
  ContributionsForClusterQueryVariables
>
export const ContributionsForUserDocument = gql`
  query contributionsForUser($userId: ID!, $status: [ContributionStatus!]!) {
    contributionsByUser(userId: $userId, status: $status) {
      ...FullContributionDetail
    }
  }
  ${FullContributionDetailFragmentDoc}
`

/**
 * __useContributionsForUserQuery__
 *
 * To run a query within a React component, call `useContributionsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useContributionsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContributionsForUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useContributionsForUserQuery(
  baseOptions: Apollo.QueryHookOptions<
    ContributionsForUserQuery,
    ContributionsForUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ContributionsForUserQuery,
    ContributionsForUserQueryVariables
  >(ContributionsForUserDocument, options)
}
export function useContributionsForUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContributionsForUserQuery,
    ContributionsForUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContributionsForUserQuery,
    ContributionsForUserQueryVariables
  >(ContributionsForUserDocument, options)
}
export function useContributionsForUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ContributionsForUserQuery,
    ContributionsForUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ContributionsForUserQuery,
    ContributionsForUserQueryVariables
  >(ContributionsForUserDocument, options)
}
export type ContributionsForUserQueryHookResult = ReturnType<
  typeof useContributionsForUserQuery
>
export type ContributionsForUserLazyQueryHookResult = ReturnType<
  typeof useContributionsForUserLazyQuery
>
export type ContributionsForUserSuspenseQueryHookResult = ReturnType<
  typeof useContributionsForUserSuspenseQuery
>
export type ContributionsForUserQueryResult = Apollo.QueryResult<
  ContributionsForUserQuery,
  ContributionsForUserQueryVariables
>
export const ContributionsForMyArticlesDocument = gql`
  query contributionsForMyArticles($status: [ContributionStatus!]!) {
    contributionsForMyArticles(status: $status) {
      ...ContributionDetailWithNode
    }
  }
  ${ContributionDetailWithNodeFragmentDoc}
`

/**
 * __useContributionsForMyArticlesQuery__
 *
 * To run a query within a React component, call `useContributionsForMyArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContributionsForMyArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContributionsForMyArticlesQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useContributionsForMyArticlesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ContributionsForMyArticlesQuery,
    ContributionsForMyArticlesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ContributionsForMyArticlesQuery,
    ContributionsForMyArticlesQueryVariables
  >(ContributionsForMyArticlesDocument, options)
}
export function useContributionsForMyArticlesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContributionsForMyArticlesQuery,
    ContributionsForMyArticlesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContributionsForMyArticlesQuery,
    ContributionsForMyArticlesQueryVariables
  >(ContributionsForMyArticlesDocument, options)
}
export function useContributionsForMyArticlesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ContributionsForMyArticlesQuery,
    ContributionsForMyArticlesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ContributionsForMyArticlesQuery,
    ContributionsForMyArticlesQueryVariables
  >(ContributionsForMyArticlesDocument, options)
}
export type ContributionsForMyArticlesQueryHookResult = ReturnType<
  typeof useContributionsForMyArticlesQuery
>
export type ContributionsForMyArticlesLazyQueryHookResult = ReturnType<
  typeof useContributionsForMyArticlesLazyQuery
>
export type ContributionsForMyArticlesSuspenseQueryHookResult = ReturnType<
  typeof useContributionsForMyArticlesSuspenseQuery
>
export type ContributionsForMyArticlesQueryResult = Apollo.QueryResult<
  ContributionsForMyArticlesQuery,
  ContributionsForMyArticlesQueryVariables
>
export const UpdateContributionStatusDocument = gql`
  mutation updateContributionStatus($input: UpdateContributionInput!) {
    updateContributionStatus(input: $input) {
      ...FullContributionDetail
    }
  }
  ${FullContributionDetailFragmentDoc}
`
export type UpdateContributionStatusMutationFn = Apollo.MutationFunction<
  UpdateContributionStatusMutation,
  UpdateContributionStatusMutationVariables
>

/**
 * __useUpdateContributionStatusMutation__
 *
 * To run a mutation, you first call `useUpdateContributionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContributionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContributionStatusMutation, { data, loading, error }] = useUpdateContributionStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContributionStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateContributionStatusMutation,
    UpdateContributionStatusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateContributionStatusMutation,
    UpdateContributionStatusMutationVariables
  >(UpdateContributionStatusDocument, options)
}
export type UpdateContributionStatusMutationHookResult = ReturnType<
  typeof useUpdateContributionStatusMutation
>
export type UpdateContributionStatusMutationResult =
  Apollo.MutationResult<UpdateContributionStatusMutation>
export type UpdateContributionStatusMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateContributionStatusMutation,
    UpdateContributionStatusMutationVariables
  >
export const ReserveContributionDocument = gql`
  mutation reserveContribution($input: ReserveContributionInput!) {
    reserveContribution(input: $input) {
      ...ContributionEditDetail
    }
  }
  ${ContributionEditDetailFragmentDoc}
`
export type ReserveContributionMutationFn = Apollo.MutationFunction<
  ReserveContributionMutation,
  ReserveContributionMutationVariables
>

/**
 * __useReserveContributionMutation__
 *
 * To run a mutation, you first call `useReserveContributionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReserveContributionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reserveContributionMutation, { data, loading, error }] = useReserveContributionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReserveContributionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReserveContributionMutation,
    ReserveContributionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ReserveContributionMutation,
    ReserveContributionMutationVariables
  >(ReserveContributionDocument, options)
}
export type ReserveContributionMutationHookResult = ReturnType<
  typeof useReserveContributionMutation
>
export type ReserveContributionMutationResult =
  Apollo.MutationResult<ReserveContributionMutation>
export type ReserveContributionMutationOptions = Apollo.BaseMutationOptions<
  ReserveContributionMutation,
  ReserveContributionMutationVariables
>
export const SubmitContributionDocument = gql`
  mutation submitContribution($input: SubmitContributionInput!) {
    submitContribution(input: $input) {
      ...ContributionEditDetail
    }
  }
  ${ContributionEditDetailFragmentDoc}
`
export type SubmitContributionMutationFn = Apollo.MutationFunction<
  SubmitContributionMutation,
  SubmitContributionMutationVariables
>

/**
 * __useSubmitContributionMutation__
 *
 * To run a mutation, you first call `useSubmitContributionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitContributionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitContributionMutation, { data, loading, error }] = useSubmitContributionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitContributionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitContributionMutation,
    SubmitContributionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SubmitContributionMutation,
    SubmitContributionMutationVariables
  >(SubmitContributionDocument, options)
}
export type SubmitContributionMutationHookResult = ReturnType<
  typeof useSubmitContributionMutation
>
export type SubmitContributionMutationResult =
  Apollo.MutationResult<SubmitContributionMutation>
export type SubmitContributionMutationOptions = Apollo.BaseMutationOptions<
  SubmitContributionMutation,
  SubmitContributionMutationVariables
>
export const ReservedContributionDocument = gql`
  query reservedContribution($articleId: ID!) {
    reservedContribution(articleId: $articleId) {
      ...ContributionEditDetail
    }
  }
  ${ContributionEditDetailFragmentDoc}
`

/**
 * __useReservedContributionQuery__
 *
 * To run a query within a React component, call `useReservedContributionQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservedContributionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservedContributionQuery({
 *   variables: {
 *      articleId: // value for 'articleId'
 *   },
 * });
 */
export function useReservedContributionQuery(
  baseOptions: Apollo.QueryHookOptions<
    ReservedContributionQuery,
    ReservedContributionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ReservedContributionQuery,
    ReservedContributionQueryVariables
  >(ReservedContributionDocument, options)
}
export function useReservedContributionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReservedContributionQuery,
    ReservedContributionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ReservedContributionQuery,
    ReservedContributionQueryVariables
  >(ReservedContributionDocument, options)
}
export function useReservedContributionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ReservedContributionQuery,
    ReservedContributionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ReservedContributionQuery,
    ReservedContributionQueryVariables
  >(ReservedContributionDocument, options)
}
export type ReservedContributionQueryHookResult = ReturnType<
  typeof useReservedContributionQuery
>
export type ReservedContributionLazyQueryHookResult = ReturnType<
  typeof useReservedContributionLazyQuery
>
export type ReservedContributionSuspenseQueryHookResult = ReturnType<
  typeof useReservedContributionSuspenseQuery
>
export type ReservedContributionQueryResult = Apollo.QueryResult<
  ReservedContributionQuery,
  ReservedContributionQueryVariables
>
export const ContributionByIdDocument = gql`
  query contributionById($contributionId: ID!) {
    contributionById(contributionId: $contributionId) {
      ...ContributionDetail
      bumpCount
      article {
        ...ArticleDetail
      }
    }
  }
  ${ContributionDetailFragmentDoc}
  ${ArticleDetailFragmentDoc}
`

/**
 * __useContributionByIdQuery__
 *
 * To run a query within a React component, call `useContributionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useContributionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContributionByIdQuery({
 *   variables: {
 *      contributionId: // value for 'contributionId'
 *   },
 * });
 */
export function useContributionByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    ContributionByIdQuery,
    ContributionByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ContributionByIdQuery, ContributionByIdQueryVariables>(
    ContributionByIdDocument,
    options
  )
}
export function useContributionByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContributionByIdQuery,
    ContributionByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContributionByIdQuery,
    ContributionByIdQueryVariables
  >(ContributionByIdDocument, options)
}
export function useContributionByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ContributionByIdQuery,
    ContributionByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ContributionByIdQuery,
    ContributionByIdQueryVariables
  >(ContributionByIdDocument, options)
}
export type ContributionByIdQueryHookResult = ReturnType<
  typeof useContributionByIdQuery
>
export type ContributionByIdLazyQueryHookResult = ReturnType<
  typeof useContributionByIdLazyQuery
>
export type ContributionByIdSuspenseQueryHookResult = ReturnType<
  typeof useContributionByIdSuspenseQuery
>
export type ContributionByIdQueryResult = Apollo.QueryResult<
  ContributionByIdQuery,
  ContributionByIdQueryVariables
>
export const CouponRedemptionsDocument = gql`
  query couponRedemptions($couponId: String!) {
    couponRedemptions(couponId: $couponId) {
      billingId
      redeemedAt
      billingType
      description
      status
      nodeLabel
      nodeId
      user {
        id
        username
      }
    }
  }
`

/**
 * __useCouponRedemptionsQuery__
 *
 * To run a query within a React component, call `useCouponRedemptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCouponRedemptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCouponRedemptionsQuery({
 *   variables: {
 *      couponId: // value for 'couponId'
 *   },
 * });
 */
export function useCouponRedemptionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CouponRedemptionsQuery,
    CouponRedemptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CouponRedemptionsQuery,
    CouponRedemptionsQueryVariables
  >(CouponRedemptionsDocument, options)
}
export function useCouponRedemptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CouponRedemptionsQuery,
    CouponRedemptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CouponRedemptionsQuery,
    CouponRedemptionsQueryVariables
  >(CouponRedemptionsDocument, options)
}
export function useCouponRedemptionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CouponRedemptionsQuery,
    CouponRedemptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CouponRedemptionsQuery,
    CouponRedemptionsQueryVariables
  >(CouponRedemptionsDocument, options)
}
export type CouponRedemptionsQueryHookResult = ReturnType<
  typeof useCouponRedemptionsQuery
>
export type CouponRedemptionsLazyQueryHookResult = ReturnType<
  typeof useCouponRedemptionsLazyQuery
>
export type CouponRedemptionsSuspenseQueryHookResult = ReturnType<
  typeof useCouponRedemptionsSuspenseQuery
>
export type CouponRedemptionsQueryResult = Apollo.QueryResult<
  CouponRedemptionsQuery,
  CouponRedemptionsQueryVariables
>
export const CouponsDocument = gql`
  query coupons(
    $filter: CouponFilterInput
    $sortBy: CouponSortField
    $sortDirection: OrderDirection
  ) {
    coupons(filter: $filter, sortBy: $sortBy, sortDirection: $sortDirection) {
      id
      code
      adminLabel
      appliedMonths
      discountPercentage
      enabled
      validTo
      maxRedeems
      redeemCount
      redeemedByUsers {
        id
      }
    }
  }
`

/**
 * __useCouponsQuery__
 *
 * To run a query within a React component, call `useCouponsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCouponsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCouponsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useCouponsQuery(
  baseOptions?: Apollo.QueryHookOptions<CouponsQuery, CouponsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CouponsQuery, CouponsQueryVariables>(
    CouponsDocument,
    options
  )
}
export function useCouponsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CouponsQuery, CouponsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CouponsQuery, CouponsQueryVariables>(
    CouponsDocument,
    options
  )
}
export function useCouponsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CouponsQuery,
    CouponsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<CouponsQuery, CouponsQueryVariables>(
    CouponsDocument,
    options
  )
}
export type CouponsQueryHookResult = ReturnType<typeof useCouponsQuery>
export type CouponsLazyQueryHookResult = ReturnType<typeof useCouponsLazyQuery>
export type CouponsSuspenseQueryHookResult = ReturnType<
  typeof useCouponsSuspenseQuery
>
export type CouponsQueryResult = Apollo.QueryResult<
  CouponsQuery,
  CouponsQueryVariables
>
export const CreateCouponDocument = gql`
  mutation createCoupon($input: CreateCouponInput!) {
    createCoupon(input: $input) {
      id
      code
      adminLabel
      appliedMonths
      discountPercentage
      enabled
      validTo
      maxRedeems
      redeemCount
      redeemedByUsers {
        id
      }
    }
  }
`
export type CreateCouponMutationFn = Apollo.MutationFunction<
  CreateCouponMutation,
  CreateCouponMutationVariables
>

/**
 * __useCreateCouponMutation__
 *
 * To run a mutation, you first call `useCreateCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCouponMutation, { data, loading, error }] = useCreateCouponMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCouponMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCouponMutation,
    CreateCouponMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateCouponMutation,
    CreateCouponMutationVariables
  >(CreateCouponDocument, options)
}
export type CreateCouponMutationHookResult = ReturnType<
  typeof useCreateCouponMutation
>
export type CreateCouponMutationResult =
  Apollo.MutationResult<CreateCouponMutation>
export type CreateCouponMutationOptions = Apollo.BaseMutationOptions<
  CreateCouponMutation,
  CreateCouponMutationVariables
>
export const UpdateCouponDocument = gql`
  mutation updateCoupon($input: UpdateCouponInput!) {
    updateCoupon(input: $input) {
      id
      code
      adminLabel
      appliedMonths
      discountPercentage
      enabled
      validTo
      maxRedeems
      redeemCount
      redeemedByUsers {
        id
      }
    }
  }
`
export type UpdateCouponMutationFn = Apollo.MutationFunction<
  UpdateCouponMutation,
  UpdateCouponMutationVariables
>

/**
 * __useUpdateCouponMutation__
 *
 * To run a mutation, you first call `useUpdateCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCouponMutation, { data, loading, error }] = useUpdateCouponMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCouponMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCouponMutation,
    UpdateCouponMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateCouponMutation,
    UpdateCouponMutationVariables
  >(UpdateCouponDocument, options)
}
export type UpdateCouponMutationHookResult = ReturnType<
  typeof useUpdateCouponMutation
>
export type UpdateCouponMutationResult =
  Apollo.MutationResult<UpdateCouponMutation>
export type UpdateCouponMutationOptions = Apollo.BaseMutationOptions<
  UpdateCouponMutation,
  UpdateCouponMutationVariables
>
export const DeleteCouponDocument = gql`
  mutation deleteCoupon($id: String!) {
    deleteCoupon(id: $id)
  }
`
export type DeleteCouponMutationFn = Apollo.MutationFunction<
  DeleteCouponMutation,
  DeleteCouponMutationVariables
>

/**
 * __useDeleteCouponMutation__
 *
 * To run a mutation, you first call `useDeleteCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCouponMutation, { data, loading, error }] = useDeleteCouponMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCouponMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCouponMutation,
    DeleteCouponMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteCouponMutation,
    DeleteCouponMutationVariables
  >(DeleteCouponDocument, options)
}
export type DeleteCouponMutationHookResult = ReturnType<
  typeof useDeleteCouponMutation
>
export type DeleteCouponMutationResult =
  Apollo.MutationResult<DeleteCouponMutation>
export type DeleteCouponMutationOptions = Apollo.BaseMutationOptions<
  DeleteCouponMutation,
  DeleteCouponMutationVariables
>
export const ApplyCouponToBillingDocument = gql`
  mutation applyCouponToBilling($billingId: ID!, $couponCode: String!) {
    applyCouponToBilling(billingId: $billingId, couponCode: $couponCode) {
      billingId
      amount
      basePrice
      couponCode
      discountPercentage
      appliedMonths
      isForever
      isFree
    }
  }
`
export type ApplyCouponToBillingMutationFn = Apollo.MutationFunction<
  ApplyCouponToBillingMutation,
  ApplyCouponToBillingMutationVariables
>

/**
 * __useApplyCouponToBillingMutation__
 *
 * To run a mutation, you first call `useApplyCouponToBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyCouponToBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyCouponToBillingMutation, { data, loading, error }] = useApplyCouponToBillingMutation({
 *   variables: {
 *      billingId: // value for 'billingId'
 *      couponCode: // value for 'couponCode'
 *   },
 * });
 */
export function useApplyCouponToBillingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApplyCouponToBillingMutation,
    ApplyCouponToBillingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ApplyCouponToBillingMutation,
    ApplyCouponToBillingMutationVariables
  >(ApplyCouponToBillingDocument, options)
}
export type ApplyCouponToBillingMutationHookResult = ReturnType<
  typeof useApplyCouponToBillingMutation
>
export type ApplyCouponToBillingMutationResult =
  Apollo.MutationResult<ApplyCouponToBillingMutation>
export type ApplyCouponToBillingMutationOptions = Apollo.BaseMutationOptions<
  ApplyCouponToBillingMutation,
  ApplyCouponToBillingMutationVariables
>
export const RemoveCouponFromBillingDocument = gql`
  mutation removeCouponFromBilling($billingId: ID!) {
    removeCouponFromBilling(billingId: $billingId) {
      billingId
      amount
      basePrice
      couponCode
      discountPercentage
      appliedMonths
      isForever
      isFree
    }
  }
`
export type RemoveCouponFromBillingMutationFn = Apollo.MutationFunction<
  RemoveCouponFromBillingMutation,
  RemoveCouponFromBillingMutationVariables
>

/**
 * __useRemoveCouponFromBillingMutation__
 *
 * To run a mutation, you first call `useRemoveCouponFromBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCouponFromBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCouponFromBillingMutation, { data, loading, error }] = useRemoveCouponFromBillingMutation({
 *   variables: {
 *      billingId: // value for 'billingId'
 *   },
 * });
 */
export function useRemoveCouponFromBillingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveCouponFromBillingMutation,
    RemoveCouponFromBillingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RemoveCouponFromBillingMutation,
    RemoveCouponFromBillingMutationVariables
  >(RemoveCouponFromBillingDocument, options)
}
export type RemoveCouponFromBillingMutationHookResult = ReturnType<
  typeof useRemoveCouponFromBillingMutation
>
export type RemoveCouponFromBillingMutationResult =
  Apollo.MutationResult<RemoveCouponFromBillingMutation>
export type RemoveCouponFromBillingMutationOptions = Apollo.BaseMutationOptions<
  RemoveCouponFromBillingMutation,
  RemoveCouponFromBillingMutationVariables
>
export const SubscribeWebPushDocument = gql`
  mutation subscribeWebPush($input: SubscribeWebPushInput!) {
    subscribeWebPush(input: $input) {
      ...UserDetail
    }
  }
  ${UserDetailFragmentDoc}
`
export type SubscribeWebPushMutationFn = Apollo.MutationFunction<
  SubscribeWebPushMutation,
  SubscribeWebPushMutationVariables
>

/**
 * __useSubscribeWebPushMutation__
 *
 * To run a mutation, you first call `useSubscribeWebPushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeWebPushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeWebPushMutation, { data, loading, error }] = useSubscribeWebPushMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribeWebPushMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubscribeWebPushMutation,
    SubscribeWebPushMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SubscribeWebPushMutation,
    SubscribeWebPushMutationVariables
  >(SubscribeWebPushDocument, options)
}
export type SubscribeWebPushMutationHookResult = ReturnType<
  typeof useSubscribeWebPushMutation
>
export type SubscribeWebPushMutationResult =
  Apollo.MutationResult<SubscribeWebPushMutation>
export type SubscribeWebPushMutationOptions = Apollo.BaseMutationOptions<
  SubscribeWebPushMutation,
  SubscribeWebPushMutationVariables
>
export const UnsubscribeWebPushDocument = gql`
  mutation unsubscribeWebPush {
    unsubscribeWebPush {
      ...UserDetail
    }
  }
  ${UserDetailFragmentDoc}
`
export type UnsubscribeWebPushMutationFn = Apollo.MutationFunction<
  UnsubscribeWebPushMutation,
  UnsubscribeWebPushMutationVariables
>

/**
 * __useUnsubscribeWebPushMutation__
 *
 * To run a mutation, you first call `useUnsubscribeWebPushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeWebPushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeWebPushMutation, { data, loading, error }] = useUnsubscribeWebPushMutation({
 *   variables: {
 *   },
 * });
 */
export function useUnsubscribeWebPushMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnsubscribeWebPushMutation,
    UnsubscribeWebPushMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UnsubscribeWebPushMutation,
    UnsubscribeWebPushMutationVariables
  >(UnsubscribeWebPushDocument, options)
}
export type UnsubscribeWebPushMutationHookResult = ReturnType<
  typeof useUnsubscribeWebPushMutation
>
export type UnsubscribeWebPushMutationResult =
  Apollo.MutationResult<UnsubscribeWebPushMutation>
export type UnsubscribeWebPushMutationOptions = Apollo.BaseMutationOptions<
  UnsubscribeWebPushMutation,
  UnsubscribeWebPushMutationVariables
>
export const CheckInvitationDocument = gql`
  query checkInvitation($codeOrId: String!) {
    validInvitation(codeOrId: $codeOrId) {
      isMember
      invitation {
        id
        code
        nodeId
        node {
          id
          name
        }
        message
        maxUsage
        usageCount
        validBefore
        validAfter
      }
    }
  }
`

/**
 * __useCheckInvitationQuery__
 *
 * To run a query within a React component, call `useCheckInvitationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckInvitationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckInvitationQuery({
 *   variables: {
 *      codeOrId: // value for 'codeOrId'
 *   },
 * });
 */
export function useCheckInvitationQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckInvitationQuery,
    CheckInvitationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CheckInvitationQuery, CheckInvitationQueryVariables>(
    CheckInvitationDocument,
    options
  )
}
export function useCheckInvitationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckInvitationQuery,
    CheckInvitationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CheckInvitationQuery,
    CheckInvitationQueryVariables
  >(CheckInvitationDocument, options)
}
export function useCheckInvitationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CheckInvitationQuery,
    CheckInvitationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CheckInvitationQuery,
    CheckInvitationQueryVariables
  >(CheckInvitationDocument, options)
}
export type CheckInvitationQueryHookResult = ReturnType<
  typeof useCheckInvitationQuery
>
export type CheckInvitationLazyQueryHookResult = ReturnType<
  typeof useCheckInvitationLazyQuery
>
export type CheckInvitationSuspenseQueryHookResult = ReturnType<
  typeof useCheckInvitationSuspenseQuery
>
export type CheckInvitationQueryResult = Apollo.QueryResult<
  CheckInvitationQuery,
  CheckInvitationQueryVariables
>
export const AcceptInvitationDocument = gql`
  mutation acceptInvitation($codeOrId: String!) {
    acceptInvitation(codeOrId: $codeOrId) {
      ... on Invitation {
        nodeId
      }
    }
  }
`
export type AcceptInvitationMutationFn = Apollo.MutationFunction<
  AcceptInvitationMutation,
  AcceptInvitationMutationVariables
>

/**
 * __useAcceptInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInvitationMutation, { data, loading, error }] = useAcceptInvitationMutation({
 *   variables: {
 *      codeOrId: // value for 'codeOrId'
 *   },
 * });
 */
export function useAcceptInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcceptInvitationMutation,
    AcceptInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AcceptInvitationMutation,
    AcceptInvitationMutationVariables
  >(AcceptInvitationDocument, options)
}
export type AcceptInvitationMutationHookResult = ReturnType<
  typeof useAcceptInvitationMutation
>
export type AcceptInvitationMutationResult =
  Apollo.MutationResult<AcceptInvitationMutation>
export type AcceptInvitationMutationOptions = Apollo.BaseMutationOptions<
  AcceptInvitationMutation,
  AcceptInvitationMutationVariables
>
export const CreateInvitationDocument = gql`
  mutation CreateInvitation($input: CreateInvitationInput!) {
    createInvitation(input: $input) {
      ... on Invitation {
        id
        code
        nodeId
        message
        maxUsage
        usageCount
        validBefore
        validAfter
        createdAt
        updatedAt
      }
    }
  }
`
export type CreateInvitationMutationFn = Apollo.MutationFunction<
  CreateInvitationMutation,
  CreateInvitationMutationVariables
>

/**
 * __useCreateInvitationMutation__
 *
 * To run a mutation, you first call `useCreateInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvitationMutation, { data, loading, error }] = useCreateInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateInvitationMutation,
    CreateInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateInvitationMutation,
    CreateInvitationMutationVariables
  >(CreateInvitationDocument, options)
}
export type CreateInvitationMutationHookResult = ReturnType<
  typeof useCreateInvitationMutation
>
export type CreateInvitationMutationResult =
  Apollo.MutationResult<CreateInvitationMutation>
export type CreateInvitationMutationOptions = Apollo.BaseMutationOptions<
  CreateInvitationMutation,
  CreateInvitationMutationVariables
>
export const ListInvitationsDocument = gql`
  query ListInvitations($input: ListInvitationsInput!) {
    listInvitations(input: $input) {
      invitations {
        id
        code
        nodeId
        message
        maxUsage
        usageCount
        validBefore
        validAfter
        createdAt
        updatedAt
      }
      total
      limit
      offset
    }
  }
`

/**
 * __useListInvitationsQuery__
 *
 * To run a query within a React component, call `useListInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListInvitationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListInvitationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListInvitationsQuery,
    ListInvitationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListInvitationsQuery, ListInvitationsQueryVariables>(
    ListInvitationsDocument,
    options
  )
}
export function useListInvitationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListInvitationsQuery,
    ListInvitationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ListInvitationsQuery,
    ListInvitationsQueryVariables
  >(ListInvitationsDocument, options)
}
export function useListInvitationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListInvitationsQuery,
    ListInvitationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ListInvitationsQuery,
    ListInvitationsQueryVariables
  >(ListInvitationsDocument, options)
}
export type ListInvitationsQueryHookResult = ReturnType<
  typeof useListInvitationsQuery
>
export type ListInvitationsLazyQueryHookResult = ReturnType<
  typeof useListInvitationsLazyQuery
>
export type ListInvitationsSuspenseQueryHookResult = ReturnType<
  typeof useListInvitationsSuspenseQuery
>
export type ListInvitationsQueryResult = Apollo.QueryResult<
  ListInvitationsQuery,
  ListInvitationsQueryVariables
>
export const DeleteInvitationDocument = gql`
  mutation DeleteInvitation($id: ID!) {
    deleteInvitation(id: $id) {
      ... on Invitation {
        id
        code
      }
    }
  }
`
export type DeleteInvitationMutationFn = Apollo.MutationFunction<
  DeleteInvitationMutation,
  DeleteInvitationMutationVariables
>

/**
 * __useDeleteInvitationMutation__
 *
 * To run a mutation, you first call `useDeleteInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvitationMutation, { data, loading, error }] = useDeleteInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteInvitationMutation,
    DeleteInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteInvitationMutation,
    DeleteInvitationMutationVariables
  >(DeleteInvitationDocument, options)
}
export type DeleteInvitationMutationHookResult = ReturnType<
  typeof useDeleteInvitationMutation
>
export type DeleteInvitationMutationResult =
  Apollo.MutationResult<DeleteInvitationMutation>
export type DeleteInvitationMutationOptions = Apollo.BaseMutationOptions<
  DeleteInvitationMutation,
  DeleteInvitationMutationVariables
>
export const GenerateOpinionDocument = gql`
  mutation GenerateOpinion(
    $prompt: String!
    $model: String!
    $clusterId: String!
  ) {
    generateOpinion(prompt: $prompt, model: $model, clusterId: $clusterId)
  }
`
export type GenerateOpinionMutationFn = Apollo.MutationFunction<
  GenerateOpinionMutation,
  GenerateOpinionMutationVariables
>

/**
 * __useGenerateOpinionMutation__
 *
 * To run a mutation, you first call `useGenerateOpinionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateOpinionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateOpinionMutation, { data, loading, error }] = useGenerateOpinionMutation({
 *   variables: {
 *      prompt: // value for 'prompt'
 *      model: // value for 'model'
 *      clusterId: // value for 'clusterId'
 *   },
 * });
 */
export function useGenerateOpinionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateOpinionMutation,
    GenerateOpinionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GenerateOpinionMutation,
    GenerateOpinionMutationVariables
  >(GenerateOpinionDocument, options)
}
export type GenerateOpinionMutationHookResult = ReturnType<
  typeof useGenerateOpinionMutation
>
export type GenerateOpinionMutationResult =
  Apollo.MutationResult<GenerateOpinionMutation>
export type GenerateOpinionMutationOptions = Apollo.BaseMutationOptions<
  GenerateOpinionMutation,
  GenerateOpinionMutationVariables
>
export const CreateNodeMemberDocument = gql`
  mutation createNodeMember($input: CreateNodeMemberInput!) {
    createNodeMember(input: $input) {
      ...NodeMemberDetail
    }
  }
  ${NodeMemberDetailFragmentDoc}
`
export type CreateNodeMemberMutationFn = Apollo.MutationFunction<
  CreateNodeMemberMutation,
  CreateNodeMemberMutationVariables
>

/**
 * __useCreateNodeMemberMutation__
 *
 * To run a mutation, you first call `useCreateNodeMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNodeMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNodeMemberMutation, { data, loading, error }] = useCreateNodeMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNodeMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateNodeMemberMutation,
    CreateNodeMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateNodeMemberMutation,
    CreateNodeMemberMutationVariables
  >(CreateNodeMemberDocument, options)
}
export type CreateNodeMemberMutationHookResult = ReturnType<
  typeof useCreateNodeMemberMutation
>
export type CreateNodeMemberMutationResult =
  Apollo.MutationResult<CreateNodeMemberMutation>
export type CreateNodeMemberMutationOptions = Apollo.BaseMutationOptions<
  CreateNodeMemberMutation,
  CreateNodeMemberMutationVariables
>
export const UpdateNodeMemberDocument = gql`
  mutation updateNodeMember($input: UpdateNodeMemberInput!) {
    updateNodeMember(input: $input) {
      ...NodeMemberDetail
    }
  }
  ${NodeMemberDetailFragmentDoc}
`
export type UpdateNodeMemberMutationFn = Apollo.MutationFunction<
  UpdateNodeMemberMutation,
  UpdateNodeMemberMutationVariables
>

/**
 * __useUpdateNodeMemberMutation__
 *
 * To run a mutation, you first call `useUpdateNodeMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNodeMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNodeMemberMutation, { data, loading, error }] = useUpdateNodeMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNodeMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateNodeMemberMutation,
    UpdateNodeMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateNodeMemberMutation,
    UpdateNodeMemberMutationVariables
  >(UpdateNodeMemberDocument, options)
}
export type UpdateNodeMemberMutationHookResult = ReturnType<
  typeof useUpdateNodeMemberMutation
>
export type UpdateNodeMemberMutationResult =
  Apollo.MutationResult<UpdateNodeMemberMutation>
export type UpdateNodeMemberMutationOptions = Apollo.BaseMutationOptions<
  UpdateNodeMemberMutation,
  UpdateNodeMemberMutationVariables
>
export const RemoveNodeMemberDocument = gql`
  mutation removeNodeMember($id: ID!) {
    removeNodeMember(id: $id)
  }
`
export type RemoveNodeMemberMutationFn = Apollo.MutationFunction<
  RemoveNodeMemberMutation,
  RemoveNodeMemberMutationVariables
>

/**
 * __useRemoveNodeMemberMutation__
 *
 * To run a mutation, you first call `useRemoveNodeMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveNodeMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeNodeMemberMutation, { data, loading, error }] = useRemoveNodeMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveNodeMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveNodeMemberMutation,
    RemoveNodeMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RemoveNodeMemberMutation,
    RemoveNodeMemberMutationVariables
  >(RemoveNodeMemberDocument, options)
}
export type RemoveNodeMemberMutationHookResult = ReturnType<
  typeof useRemoveNodeMemberMutation
>
export type RemoveNodeMemberMutationResult =
  Apollo.MutationResult<RemoveNodeMemberMutation>
export type RemoveNodeMemberMutationOptions = Apollo.BaseMutationOptions<
  RemoveNodeMemberMutation,
  RemoveNodeMemberMutationVariables
>
export const NodeMembersByNodeIdDocument = gql`
  query nodeMembersByNodeId($input: QueryNodeMemberInput!) {
    nodeMembersByNodeId(input: $input) {
      total
      results {
        ...NodeMemberDetail
      }
    }
  }
  ${NodeMemberDetailFragmentDoc}
`

/**
 * __useNodeMembersByNodeIdQuery__
 *
 * To run a query within a React component, call `useNodeMembersByNodeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useNodeMembersByNodeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNodeMembersByNodeIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNodeMembersByNodeIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    NodeMembersByNodeIdQuery,
    NodeMembersByNodeIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    NodeMembersByNodeIdQuery,
    NodeMembersByNodeIdQueryVariables
  >(NodeMembersByNodeIdDocument, options)
}
export function useNodeMembersByNodeIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NodeMembersByNodeIdQuery,
    NodeMembersByNodeIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    NodeMembersByNodeIdQuery,
    NodeMembersByNodeIdQueryVariables
  >(NodeMembersByNodeIdDocument, options)
}
export function useNodeMembersByNodeIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    NodeMembersByNodeIdQuery,
    NodeMembersByNodeIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    NodeMembersByNodeIdQuery,
    NodeMembersByNodeIdQueryVariables
  >(NodeMembersByNodeIdDocument, options)
}
export type NodeMembersByNodeIdQueryHookResult = ReturnType<
  typeof useNodeMembersByNodeIdQuery
>
export type NodeMembersByNodeIdLazyQueryHookResult = ReturnType<
  typeof useNodeMembersByNodeIdLazyQuery
>
export type NodeMembersByNodeIdSuspenseQueryHookResult = ReturnType<
  typeof useNodeMembersByNodeIdSuspenseQuery
>
export type NodeMembersByNodeIdQueryResult = Apollo.QueryResult<
  NodeMembersByNodeIdQuery,
  NodeMembersByNodeIdQueryVariables
>
export const ExpireNodeTierForTestingDocument = gql`
  mutation expireNodeTierForTesting($tierId: ID!) {
    expireNodeTierForTesting(tierId: $tierId)
  }
`
export type ExpireNodeTierForTestingMutationFn = Apollo.MutationFunction<
  ExpireNodeTierForTestingMutation,
  ExpireNodeTierForTestingMutationVariables
>

/**
 * __useExpireNodeTierForTestingMutation__
 *
 * To run a mutation, you first call `useExpireNodeTierForTestingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExpireNodeTierForTestingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [expireNodeTierForTestingMutation, { data, loading, error }] = useExpireNodeTierForTestingMutation({
 *   variables: {
 *      tierId: // value for 'tierId'
 *   },
 * });
 */
export function useExpireNodeTierForTestingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExpireNodeTierForTestingMutation,
    ExpireNodeTierForTestingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ExpireNodeTierForTestingMutation,
    ExpireNodeTierForTestingMutationVariables
  >(ExpireNodeTierForTestingDocument, options)
}
export type ExpireNodeTierForTestingMutationHookResult = ReturnType<
  typeof useExpireNodeTierForTestingMutation
>
export type ExpireNodeTierForTestingMutationResult =
  Apollo.MutationResult<ExpireNodeTierForTestingMutation>
export type ExpireNodeTierForTestingMutationOptions =
  Apollo.BaseMutationOptions<
    ExpireNodeTierForTestingMutation,
    ExpireNodeTierForTestingMutationVariables
  >
export const GetNodeTierConfigDocument = gql`
  query getNodeTierConfig {
    nodeTierConfig {
      tiers {
        name
        visibility
        layout
        seat_price
      }
      extra {
        extra_seat_public
        extra_seat_private
      }
    }
  }
`

/**
 * __useGetNodeTierConfigQuery__
 *
 * To run a query within a React component, call `useGetNodeTierConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNodeTierConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNodeTierConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNodeTierConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetNodeTierConfigQuery,
    GetNodeTierConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetNodeTierConfigQuery,
    GetNodeTierConfigQueryVariables
  >(GetNodeTierConfigDocument, options)
}
export function useGetNodeTierConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNodeTierConfigQuery,
    GetNodeTierConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetNodeTierConfigQuery,
    GetNodeTierConfigQueryVariables
  >(GetNodeTierConfigDocument, options)
}
export function useGetNodeTierConfigSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetNodeTierConfigQuery,
    GetNodeTierConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GetNodeTierConfigQuery,
    GetNodeTierConfigQueryVariables
  >(GetNodeTierConfigDocument, options)
}
export type GetNodeTierConfigQueryHookResult = ReturnType<
  typeof useGetNodeTierConfigQuery
>
export type GetNodeTierConfigLazyQueryHookResult = ReturnType<
  typeof useGetNodeTierConfigLazyQuery
>
export type GetNodeTierConfigSuspenseQueryHookResult = ReturnType<
  typeof useGetNodeTierConfigSuspenseQuery
>
export type GetNodeTierConfigQueryResult = Apollo.QueryResult<
  GetNodeTierConfigQuery,
  GetNodeTierConfigQueryVariables
>
export const CreateNodeRequestDocument = gql`
  mutation createNodeRequest($input: CreateNodeRequestInput!) {
    createNodeRequest(input: $input) {
      billingId
      amount
      basePrice
    }
  }
`
export type CreateNodeRequestMutationFn = Apollo.MutationFunction<
  CreateNodeRequestMutation,
  CreateNodeRequestMutationVariables
>

/**
 * __useCreateNodeRequestMutation__
 *
 * To run a mutation, you first call `useCreateNodeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNodeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNodeRequestMutation, { data, loading, error }] = useCreateNodeRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNodeRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateNodeRequestMutation,
    CreateNodeRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateNodeRequestMutation,
    CreateNodeRequestMutationVariables
  >(CreateNodeRequestDocument, options)
}
export type CreateNodeRequestMutationHookResult = ReturnType<
  typeof useCreateNodeRequestMutation
>
export type CreateNodeRequestMutationResult =
  Apollo.MutationResult<CreateNodeRequestMutation>
export type CreateNodeRequestMutationOptions = Apollo.BaseMutationOptions<
  CreateNodeRequestMutation,
  CreateNodeRequestMutationVariables
>
export const GetBillingStatusDocument = gql`
  query getBillingStatus($id: ID!) {
    billingStatus(id: $id) {
      status
      message
      paidAt
      processedAt
    }
  }
`

/**
 * __useGetBillingStatusQuery__
 *
 * To run a query within a React component, call `useGetBillingStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBillingStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetBillingStatusQuery,
    GetBillingStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetBillingStatusQuery, GetBillingStatusQueryVariables>(
    GetBillingStatusDocument,
    options
  )
}
export function useGetBillingStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBillingStatusQuery,
    GetBillingStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetBillingStatusQuery,
    GetBillingStatusQueryVariables
  >(GetBillingStatusDocument, options)
}
export function useGetBillingStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetBillingStatusQuery,
    GetBillingStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GetBillingStatusQuery,
    GetBillingStatusQueryVariables
  >(GetBillingStatusDocument, options)
}
export type GetBillingStatusQueryHookResult = ReturnType<
  typeof useGetBillingStatusQuery
>
export type GetBillingStatusLazyQueryHookResult = ReturnType<
  typeof useGetBillingStatusLazyQuery
>
export type GetBillingStatusSuspenseQueryHookResult = ReturnType<
  typeof useGetBillingStatusSuspenseQuery
>
export type GetBillingStatusQueryResult = Apollo.QueryResult<
  GetBillingStatusQuery,
  GetBillingStatusQueryVariables
>
export const CancelNodeTierDocument = gql`
  mutation cancelNodeTier($id: ID!) {
    cancelNodeTier(id: $id)
  }
`
export type CancelNodeTierMutationFn = Apollo.MutationFunction<
  CancelNodeTierMutation,
  CancelNodeTierMutationVariables
>

/**
 * __useCancelNodeTierMutation__
 *
 * To run a mutation, you first call `useCancelNodeTierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelNodeTierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelNodeTierMutation, { data, loading, error }] = useCancelNodeTierMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelNodeTierMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelNodeTierMutation,
    CancelNodeTierMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CancelNodeTierMutation,
    CancelNodeTierMutationVariables
  >(CancelNodeTierDocument, options)
}
export type CancelNodeTierMutationHookResult = ReturnType<
  typeof useCancelNodeTierMutation
>
export type CancelNodeTierMutationResult =
  Apollo.MutationResult<CancelNodeTierMutation>
export type CancelNodeTierMutationOptions = Apollo.BaseMutationOptions<
  CancelNodeTierMutation,
  CancelNodeTierMutationVariables
>
export const ReactivateNodeTierDocument = gql`
  mutation reactivateNodeTier($id: ID!) {
    reactivateNodeTier(id: $id)
  }
`
export type ReactivateNodeTierMutationFn = Apollo.MutationFunction<
  ReactivateNodeTierMutation,
  ReactivateNodeTierMutationVariables
>

/**
 * __useReactivateNodeTierMutation__
 *
 * To run a mutation, you first call `useReactivateNodeTierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateNodeTierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateNodeTierMutation, { data, loading, error }] = useReactivateNodeTierMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReactivateNodeTierMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReactivateNodeTierMutation,
    ReactivateNodeTierMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ReactivateNodeTierMutation,
    ReactivateNodeTierMutationVariables
  >(ReactivateNodeTierDocument, options)
}
export type ReactivateNodeTierMutationHookResult = ReturnType<
  typeof useReactivateNodeTierMutation
>
export type ReactivateNodeTierMutationResult =
  Apollo.MutationResult<ReactivateNodeTierMutation>
export type ReactivateNodeTierMutationOptions = Apollo.BaseMutationOptions<
  ReactivateNodeTierMutation,
  ReactivateNodeTierMutationVariables
>
export const GetNextMonthCostEstimateDocument = gql`
  query getNextMonthCostEstimate {
    nextMonthCostEstimate {
      totalAmount
      baseAmount
      extraAmount
      tierDetails {
        nodeId
        nodeName
        tierName
        basePrice
        seats
        activeUsers
        extraSeatPrice
        extraSeats
        totalTierCost
      }
    }
  }
`

/**
 * __useGetNextMonthCostEstimateQuery__
 *
 * To run a query within a React component, call `useGetNextMonthCostEstimateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextMonthCostEstimateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNextMonthCostEstimateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNextMonthCostEstimateQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetNextMonthCostEstimateQuery,
    GetNextMonthCostEstimateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetNextMonthCostEstimateQuery,
    GetNextMonthCostEstimateQueryVariables
  >(GetNextMonthCostEstimateDocument, options)
}
export function useGetNextMonthCostEstimateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNextMonthCostEstimateQuery,
    GetNextMonthCostEstimateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetNextMonthCostEstimateQuery,
    GetNextMonthCostEstimateQueryVariables
  >(GetNextMonthCostEstimateDocument, options)
}
export function useGetNextMonthCostEstimateSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetNextMonthCostEstimateQuery,
    GetNextMonthCostEstimateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GetNextMonthCostEstimateQuery,
    GetNextMonthCostEstimateQueryVariables
  >(GetNextMonthCostEstimateDocument, options)
}
export type GetNextMonthCostEstimateQueryHookResult = ReturnType<
  typeof useGetNextMonthCostEstimateQuery
>
export type GetNextMonthCostEstimateLazyQueryHookResult = ReturnType<
  typeof useGetNextMonthCostEstimateLazyQuery
>
export type GetNextMonthCostEstimateSuspenseQueryHookResult = ReturnType<
  typeof useGetNextMonthCostEstimateSuspenseQuery
>
export type GetNextMonthCostEstimateQueryResult = Apollo.QueryResult<
  GetNextMonthCostEstimateQuery,
  GetNextMonthCostEstimateQueryVariables
>
export const UpgradeNodeTierDocument = gql`
  mutation upgradeNodeTier($input: UpgradeNodeTierInput!) {
    upgradeNodeTier(input: $input) {
      billingId
      amount
      basePrice
    }
  }
`
export type UpgradeNodeTierMutationFn = Apollo.MutationFunction<
  UpgradeNodeTierMutation,
  UpgradeNodeTierMutationVariables
>

/**
 * __useUpgradeNodeTierMutation__
 *
 * To run a mutation, you first call `useUpgradeNodeTierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeNodeTierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeNodeTierMutation, { data, loading, error }] = useUpgradeNodeTierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpgradeNodeTierMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpgradeNodeTierMutation,
    UpgradeNodeTierMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpgradeNodeTierMutation,
    UpgradeNodeTierMutationVariables
  >(UpgradeNodeTierDocument, options)
}
export type UpgradeNodeTierMutationHookResult = ReturnType<
  typeof useUpgradeNodeTierMutation
>
export type UpgradeNodeTierMutationResult =
  Apollo.MutationResult<UpgradeNodeTierMutation>
export type UpgradeNodeTierMutationOptions = Apollo.BaseMutationOptions<
  UpgradeNodeTierMutation,
  UpgradeNodeTierMutationVariables
>
export const DowngradeNodeTierDocument = gql`
  mutation downgradeNodeTier($input: DowngradeNodeTierInput!) {
    downgradeNodeTier(input: $input) {
      id
      name
      seats
      status
      startDate
      endDate
    }
  }
`
export type DowngradeNodeTierMutationFn = Apollo.MutationFunction<
  DowngradeNodeTierMutation,
  DowngradeNodeTierMutationVariables
>

/**
 * __useDowngradeNodeTierMutation__
 *
 * To run a mutation, you first call `useDowngradeNodeTierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDowngradeNodeTierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downgradeNodeTierMutation, { data, loading, error }] = useDowngradeNodeTierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDowngradeNodeTierMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DowngradeNodeTierMutation,
    DowngradeNodeTierMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DowngradeNodeTierMutation,
    DowngradeNodeTierMutationVariables
  >(DowngradeNodeTierDocument, options)
}
export type DowngradeNodeTierMutationHookResult = ReturnType<
  typeof useDowngradeNodeTierMutation
>
export type DowngradeNodeTierMutationResult =
  Apollo.MutationResult<DowngradeNodeTierMutation>
export type DowngradeNodeTierMutationOptions = Apollo.BaseMutationOptions<
  DowngradeNodeTierMutation,
  DowngradeNodeTierMutationVariables
>
export const CancelDowngradeDocument = gql`
  mutation cancelDowngrade($id: ID!) {
    cancelDowngrade(id: $id)
  }
`
export type CancelDowngradeMutationFn = Apollo.MutationFunction<
  CancelDowngradeMutation,
  CancelDowngradeMutationVariables
>

/**
 * __useCancelDowngradeMutation__
 *
 * To run a mutation, you first call `useCancelDowngradeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelDowngradeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelDowngradeMutation, { data, loading, error }] = useCancelDowngradeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelDowngradeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelDowngradeMutation,
    CancelDowngradeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CancelDowngradeMutation,
    CancelDowngradeMutationVariables
  >(CancelDowngradeDocument, options)
}
export type CancelDowngradeMutationHookResult = ReturnType<
  typeof useCancelDowngradeMutation
>
export type CancelDowngradeMutationResult =
  Apollo.MutationResult<CancelDowngradeMutation>
export type CancelDowngradeMutationOptions = Apollo.BaseMutationOptions<
  CancelDowngradeMutation,
  CancelDowngradeMutationVariables
>
export const GetNodeTiersDocument = gql`
  query getNodeTiers(
    $pagination: PaginationInput
    $filter: NodeTierFilterInput
  ) {
    nodeTiers(pagination: $pagination, filter: $filter) {
      nodeTiers {
        id
        nodeId
        name
        seats
        status
        startDate
        endDate
        createdAt
        updatedAt
        currentActiveUsers
      }
      total
    }
  }
`

/**
 * __useGetNodeTiersQuery__
 *
 * To run a query within a React component, call `useGetNodeTiersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNodeTiersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNodeTiersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetNodeTiersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetNodeTiersQuery,
    GetNodeTiersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetNodeTiersQuery, GetNodeTiersQueryVariables>(
    GetNodeTiersDocument,
    options
  )
}
export function useGetNodeTiersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNodeTiersQuery,
    GetNodeTiersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetNodeTiersQuery, GetNodeTiersQueryVariables>(
    GetNodeTiersDocument,
    options
  )
}
export function useGetNodeTiersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetNodeTiersQuery,
    GetNodeTiersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetNodeTiersQuery, GetNodeTiersQueryVariables>(
    GetNodeTiersDocument,
    options
  )
}
export type GetNodeTiersQueryHookResult = ReturnType<
  typeof useGetNodeTiersQuery
>
export type GetNodeTiersLazyQueryHookResult = ReturnType<
  typeof useGetNodeTiersLazyQuery
>
export type GetNodeTiersSuspenseQueryHookResult = ReturnType<
  typeof useGetNodeTiersSuspenseQuery
>
export type GetNodeTiersQueryResult = Apollo.QueryResult<
  GetNodeTiersQuery,
  GetNodeTiersQueryVariables
>
export const SimulateRenovationForTestingDocument = gql`
  mutation simulateRenovationForTesting {
    simulateRenovationForTesting
  }
`
export type SimulateRenovationForTestingMutationFn = Apollo.MutationFunction<
  SimulateRenovationForTestingMutation,
  SimulateRenovationForTestingMutationVariables
>

/**
 * __useSimulateRenovationForTestingMutation__
 *
 * To run a mutation, you first call `useSimulateRenovationForTestingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSimulateRenovationForTestingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [simulateRenovationForTestingMutation, { data, loading, error }] = useSimulateRenovationForTestingMutation({
 *   variables: {
 *   },
 * });
 */
export function useSimulateRenovationForTestingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SimulateRenovationForTestingMutation,
    SimulateRenovationForTestingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SimulateRenovationForTestingMutation,
    SimulateRenovationForTestingMutationVariables
  >(SimulateRenovationForTestingDocument, options)
}
export type SimulateRenovationForTestingMutationHookResult = ReturnType<
  typeof useSimulateRenovationForTestingMutation
>
export type SimulateRenovationForTestingMutationResult =
  Apollo.MutationResult<SimulateRenovationForTestingMutation>
export type SimulateRenovationForTestingMutationOptions =
  Apollo.BaseMutationOptions<
    SimulateRenovationForTestingMutation,
    SimulateRenovationForTestingMutationVariables
  >
export const TriggerNodeTierRenovationDocument = gql`
  mutation triggerNodeTierRenovation {
    triggerNodeTierRenovation
  }
`
export type TriggerNodeTierRenovationMutationFn = Apollo.MutationFunction<
  TriggerNodeTierRenovationMutation,
  TriggerNodeTierRenovationMutationVariables
>

/**
 * __useTriggerNodeTierRenovationMutation__
 *
 * To run a mutation, you first call `useTriggerNodeTierRenovationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerNodeTierRenovationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerNodeTierRenovationMutation, { data, loading, error }] = useTriggerNodeTierRenovationMutation({
 *   variables: {
 *   },
 * });
 */
export function useTriggerNodeTierRenovationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TriggerNodeTierRenovationMutation,
    TriggerNodeTierRenovationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    TriggerNodeTierRenovationMutation,
    TriggerNodeTierRenovationMutationVariables
  >(TriggerNodeTierRenovationDocument, options)
}
export type TriggerNodeTierRenovationMutationHookResult = ReturnType<
  typeof useTriggerNodeTierRenovationMutation
>
export type TriggerNodeTierRenovationMutationResult =
  Apollo.MutationResult<TriggerNodeTierRenovationMutation>
export type TriggerNodeTierRenovationMutationOptions =
  Apollo.BaseMutationOptions<
    TriggerNodeTierRenovationMutation,
    TriggerNodeTierRenovationMutationVariables
  >
export const AvailableNodesDocument = gql`
  query availableNodes {
    availableNodes {
      ...NodeDetail
    }
  }
  ${NodeDetailFragmentDoc}
`

/**
 * __useAvailableNodesQuery__
 *
 * To run a query within a React component, call `useAvailableNodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableNodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableNodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableNodesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AvailableNodesQuery,
    AvailableNodesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AvailableNodesQuery, AvailableNodesQueryVariables>(
    AvailableNodesDocument,
    options
  )
}
export function useAvailableNodesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AvailableNodesQuery,
    AvailableNodesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AvailableNodesQuery, AvailableNodesQueryVariables>(
    AvailableNodesDocument,
    options
  )
}
export function useAvailableNodesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AvailableNodesQuery,
    AvailableNodesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AvailableNodesQuery,
    AvailableNodesQueryVariables
  >(AvailableNodesDocument, options)
}
export type AvailableNodesQueryHookResult = ReturnType<
  typeof useAvailableNodesQuery
>
export type AvailableNodesLazyQueryHookResult = ReturnType<
  typeof useAvailableNodesLazyQuery
>
export type AvailableNodesSuspenseQueryHookResult = ReturnType<
  typeof useAvailableNodesSuspenseQuery
>
export type AvailableNodesQueryResult = Apollo.QueryResult<
  AvailableNodesQuery,
  AvailableNodesQueryVariables
>
export const NodeStatsDocument = gql`
  query nodeStats($input: NodeStatsInput!) {
    nodeStats(input: $input) {
      nodeId
      node {
        ...NodeDetail
      }
      perspectives {
        id
        title
        voteCount
        cluster {
          id
          topic
        }
      }
      contributions {
        ...FullContributionDetail
        bumpScore
      }
      users {
        id
        username
      }
    }
  }
  ${NodeDetailFragmentDoc}
  ${FullContributionDetailFragmentDoc}
`

/**
 * __useNodeStatsQuery__
 *
 * To run a query within a React component, call `useNodeStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNodeStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNodeStatsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNodeStatsQuery(
  baseOptions: Apollo.QueryHookOptions<NodeStatsQuery, NodeStatsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<NodeStatsQuery, NodeStatsQueryVariables>(
    NodeStatsDocument,
    options
  )
}
export function useNodeStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NodeStatsQuery,
    NodeStatsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<NodeStatsQuery, NodeStatsQueryVariables>(
    NodeStatsDocument,
    options
  )
}
export function useNodeStatsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    NodeStatsQuery,
    NodeStatsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<NodeStatsQuery, NodeStatsQueryVariables>(
    NodeStatsDocument,
    options
  )
}
export type NodeStatsQueryHookResult = ReturnType<typeof useNodeStatsQuery>
export type NodeStatsLazyQueryHookResult = ReturnType<
  typeof useNodeStatsLazyQuery
>
export type NodeStatsSuspenseQueryHookResult = ReturnType<
  typeof useNodeStatsSuspenseQuery
>
export type NodeStatsQueryResult = Apollo.QueryResult<
  NodeStatsQuery,
  NodeStatsQueryVariables
>
export const NodeTopPerspectivesDocument = gql`
  query nodeTopPerspectives($input: NodeTopPerspectivesInput!) {
    nodeTopPerspectives(input: $input) {
      perspectives {
        id
        title
        voteCount
        dbPosition
        createdAt
        cluster {
          id
          topic
        }
      }
      total
    }
  }
`

/**
 * __useNodeTopPerspectivesQuery__
 *
 * To run a query within a React component, call `useNodeTopPerspectivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNodeTopPerspectivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNodeTopPerspectivesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNodeTopPerspectivesQuery(
  baseOptions: Apollo.QueryHookOptions<
    NodeTopPerspectivesQuery,
    NodeTopPerspectivesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    NodeTopPerspectivesQuery,
    NodeTopPerspectivesQueryVariables
  >(NodeTopPerspectivesDocument, options)
}
export function useNodeTopPerspectivesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NodeTopPerspectivesQuery,
    NodeTopPerspectivesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    NodeTopPerspectivesQuery,
    NodeTopPerspectivesQueryVariables
  >(NodeTopPerspectivesDocument, options)
}
export function useNodeTopPerspectivesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    NodeTopPerspectivesQuery,
    NodeTopPerspectivesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    NodeTopPerspectivesQuery,
    NodeTopPerspectivesQueryVariables
  >(NodeTopPerspectivesDocument, options)
}
export type NodeTopPerspectivesQueryHookResult = ReturnType<
  typeof useNodeTopPerspectivesQuery
>
export type NodeTopPerspectivesLazyQueryHookResult = ReturnType<
  typeof useNodeTopPerspectivesLazyQuery
>
export type NodeTopPerspectivesSuspenseQueryHookResult = ReturnType<
  typeof useNodeTopPerspectivesSuspenseQuery
>
export type NodeTopPerspectivesQueryResult = Apollo.QueryResult<
  NodeTopPerspectivesQuery,
  NodeTopPerspectivesQueryVariables
>
export const NodeTopContributionsDocument = gql`
  query nodeTopContributions($input: NodeTopContributionsInput!) {
    nodeTopContributions(input: $input) {
      contributions {
        ...FullContributionDetail
        bumpScore
      }
      total
    }
  }
  ${FullContributionDetailFragmentDoc}
`

/**
 * __useNodeTopContributionsQuery__
 *
 * To run a query within a React component, call `useNodeTopContributionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNodeTopContributionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNodeTopContributionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNodeTopContributionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    NodeTopContributionsQuery,
    NodeTopContributionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    NodeTopContributionsQuery,
    NodeTopContributionsQueryVariables
  >(NodeTopContributionsDocument, options)
}
export function useNodeTopContributionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NodeTopContributionsQuery,
    NodeTopContributionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    NodeTopContributionsQuery,
    NodeTopContributionsQueryVariables
  >(NodeTopContributionsDocument, options)
}
export function useNodeTopContributionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    NodeTopContributionsQuery,
    NodeTopContributionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    NodeTopContributionsQuery,
    NodeTopContributionsQueryVariables
  >(NodeTopContributionsDocument, options)
}
export type NodeTopContributionsQueryHookResult = ReturnType<
  typeof useNodeTopContributionsQuery
>
export type NodeTopContributionsLazyQueryHookResult = ReturnType<
  typeof useNodeTopContributionsLazyQuery
>
export type NodeTopContributionsSuspenseQueryHookResult = ReturnType<
  typeof useNodeTopContributionsSuspenseQuery
>
export type NodeTopContributionsQueryResult = Apollo.QueryResult<
  NodeTopContributionsQuery,
  NodeTopContributionsQueryVariables
>
export const NodeTopUsersDocument = gql`
  query nodeTopUsers($input: NodeTopUsersInput!) {
    nodeTopUsers(input: $input) {
      users {
        user {
          id
          username
        }
        coRank
        dbPosition
      }
      total
    }
  }
`

/**
 * __useNodeTopUsersQuery__
 *
 * To run a query within a React component, call `useNodeTopUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useNodeTopUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNodeTopUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNodeTopUsersQuery(
  baseOptions: Apollo.QueryHookOptions<
    NodeTopUsersQuery,
    NodeTopUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<NodeTopUsersQuery, NodeTopUsersQueryVariables>(
    NodeTopUsersDocument,
    options
  )
}
export function useNodeTopUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NodeTopUsersQuery,
    NodeTopUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<NodeTopUsersQuery, NodeTopUsersQueryVariables>(
    NodeTopUsersDocument,
    options
  )
}
export function useNodeTopUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    NodeTopUsersQuery,
    NodeTopUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<NodeTopUsersQuery, NodeTopUsersQueryVariables>(
    NodeTopUsersDocument,
    options
  )
}
export type NodeTopUsersQueryHookResult = ReturnType<
  typeof useNodeTopUsersQuery
>
export type NodeTopUsersLazyQueryHookResult = ReturnType<
  typeof useNodeTopUsersLazyQuery
>
export type NodeTopUsersSuspenseQueryHookResult = ReturnType<
  typeof useNodeTopUsersSuspenseQuery
>
export type NodeTopUsersQueryResult = Apollo.QueryResult<
  NodeTopUsersQuery,
  NodeTopUsersQueryVariables
>
export const NodeTopUsersExportDocument = gql`
  query nodeTopUsersExport($input: NodeTopUsersInput!) {
    nodeTopUsers(input: $input) {
      users {
        user {
          id
          username
        }
        coRank
        dbPosition
      }
      total
    }
  }
`

/**
 * __useNodeTopUsersExportQuery__
 *
 * To run a query within a React component, call `useNodeTopUsersExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useNodeTopUsersExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNodeTopUsersExportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNodeTopUsersExportQuery(
  baseOptions: Apollo.QueryHookOptions<
    NodeTopUsersExportQuery,
    NodeTopUsersExportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    NodeTopUsersExportQuery,
    NodeTopUsersExportQueryVariables
  >(NodeTopUsersExportDocument, options)
}
export function useNodeTopUsersExportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NodeTopUsersExportQuery,
    NodeTopUsersExportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    NodeTopUsersExportQuery,
    NodeTopUsersExportQueryVariables
  >(NodeTopUsersExportDocument, options)
}
export function useNodeTopUsersExportSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    NodeTopUsersExportQuery,
    NodeTopUsersExportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    NodeTopUsersExportQuery,
    NodeTopUsersExportQueryVariables
  >(NodeTopUsersExportDocument, options)
}
export type NodeTopUsersExportQueryHookResult = ReturnType<
  typeof useNodeTopUsersExportQuery
>
export type NodeTopUsersExportLazyQueryHookResult = ReturnType<
  typeof useNodeTopUsersExportLazyQuery
>
export type NodeTopUsersExportSuspenseQueryHookResult = ReturnType<
  typeof useNodeTopUsersExportSuspenseQuery
>
export type NodeTopUsersExportQueryResult = Apollo.QueryResult<
  NodeTopUsersExportQuery,
  NodeTopUsersExportQueryVariables
>
export const NodeByIdDocument = gql`
  query nodeById($id: ID!) {
    nodeById(id: $id) {
      id
      name
      description
      isPrivate
      isAdmin
      isOwner
    }
  }
`

/**
 * __useNodeByIdQuery__
 *
 * To run a query within a React component, call `useNodeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useNodeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNodeByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNodeByIdQuery(
  baseOptions: Apollo.QueryHookOptions<NodeByIdQuery, NodeByIdQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<NodeByIdQuery, NodeByIdQueryVariables>(
    NodeByIdDocument,
    options
  )
}
export function useNodeByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NodeByIdQuery,
    NodeByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<NodeByIdQuery, NodeByIdQueryVariables>(
    NodeByIdDocument,
    options
  )
}
export function useNodeByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    NodeByIdQuery,
    NodeByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<NodeByIdQuery, NodeByIdQueryVariables>(
    NodeByIdDocument,
    options
  )
}
export type NodeByIdQueryHookResult = ReturnType<typeof useNodeByIdQuery>
export type NodeByIdLazyQueryHookResult = ReturnType<
  typeof useNodeByIdLazyQuery
>
export type NodeByIdSuspenseQueryHookResult = ReturnType<
  typeof useNodeByIdSuspenseQuery
>
export type NodeByIdQueryResult = Apollo.QueryResult<
  NodeByIdQuery,
  NodeByIdQueryVariables
>
export const MyNodeByIdDocument = gql`
  query myNodeById($id: ID!) {
    nodeById(id: $id) {
      id
      name
      description
      isPrivate
      allowExtraSeats
      isAdmin
      isOwner
      activeTier {
        id
        name
        seats
        startDate
        createdAt
        updatedAt
        endDate
        status
        currentActiveUsers
      }
    }
  }
`

/**
 * __useMyNodeByIdQuery__
 *
 * To run a query within a React component, call `useMyNodeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyNodeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyNodeByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMyNodeByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    MyNodeByIdQuery,
    MyNodeByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<MyNodeByIdQuery, MyNodeByIdQueryVariables>(
    MyNodeByIdDocument,
    options
  )
}
export function useMyNodeByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyNodeByIdQuery,
    MyNodeByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<MyNodeByIdQuery, MyNodeByIdQueryVariables>(
    MyNodeByIdDocument,
    options
  )
}
export function useMyNodeByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MyNodeByIdQuery,
    MyNodeByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<MyNodeByIdQuery, MyNodeByIdQueryVariables>(
    MyNodeByIdDocument,
    options
  )
}
export type MyNodeByIdQueryHookResult = ReturnType<typeof useMyNodeByIdQuery>
export type MyNodeByIdLazyQueryHookResult = ReturnType<
  typeof useMyNodeByIdLazyQuery
>
export type MyNodeByIdSuspenseQueryHookResult = ReturnType<
  typeof useMyNodeByIdSuspenseQuery
>
export type MyNodeByIdQueryResult = Apollo.QueryResult<
  MyNodeByIdQuery,
  MyNodeByIdQueryVariables
>
export const MyNodesDocument = gql`
  query myNodes($input: MyNodesInput!) {
    myNodes(input: $input) {
      results {
        ...NodeDetail
        memberCount
        activeTier {
          id
          status
        }
      }
      total
    }
  }
  ${NodeDetailFragmentDoc}
`

/**
 * __useMyNodesQuery__
 *
 * To run a query within a React component, call `useMyNodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyNodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyNodesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMyNodesQuery(
  baseOptions: Apollo.QueryHookOptions<MyNodesQuery, MyNodesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<MyNodesQuery, MyNodesQueryVariables>(
    MyNodesDocument,
    options
  )
}
export function useMyNodesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MyNodesQuery, MyNodesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<MyNodesQuery, MyNodesQueryVariables>(
    MyNodesDocument,
    options
  )
}
export function useMyNodesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MyNodesQuery,
    MyNodesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<MyNodesQuery, MyNodesQueryVariables>(
    MyNodesDocument,
    options
  )
}
export type MyNodesQueryHookResult = ReturnType<typeof useMyNodesQuery>
export type MyNodesLazyQueryHookResult = ReturnType<typeof useMyNodesLazyQuery>
export type MyNodesSuspenseQueryHookResult = ReturnType<
  typeof useMyNodesSuspenseQuery
>
export type MyNodesQueryResult = Apollo.QueryResult<
  MyNodesQuery,
  MyNodesQueryVariables
>
export const UpdateNodeDocument = gql`
  mutation updateNode($input: UpdateNodeInput!) {
    updateNode(input: $input) {
      ...NodeDetail
    }
  }
  ${NodeDetailFragmentDoc}
`
export type UpdateNodeMutationFn = Apollo.MutationFunction<
  UpdateNodeMutation,
  UpdateNodeMutationVariables
>

/**
 * __useUpdateNodeMutation__
 *
 * To run a mutation, you first call `useUpdateNodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNodeMutation, { data, loading, error }] = useUpdateNodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateNodeMutation,
    UpdateNodeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateNodeMutation, UpdateNodeMutationVariables>(
    UpdateNodeDocument,
    options
  )
}
export type UpdateNodeMutationHookResult = ReturnType<
  typeof useUpdateNodeMutation
>
export type UpdateNodeMutationResult = Apollo.MutationResult<UpdateNodeMutation>
export type UpdateNodeMutationOptions = Apollo.BaseMutationOptions<
  UpdateNodeMutation,
  UpdateNodeMutationVariables
>
export const CreateNodeDocument = gql`
  mutation createNode($input: CreateNodeInput!) {
    createNode(input: $input) {
      ...NodeDetail
    }
  }
  ${NodeDetailFragmentDoc}
`
export type CreateNodeMutationFn = Apollo.MutationFunction<
  CreateNodeMutation,
  CreateNodeMutationVariables
>

/**
 * __useCreateNodeMutation__
 *
 * To run a mutation, you first call `useCreateNodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNodeMutation, { data, loading, error }] = useCreateNodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateNodeMutation,
    CreateNodeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateNodeMutation, CreateNodeMutationVariables>(
    CreateNodeDocument,
    options
  )
}
export type CreateNodeMutationHookResult = ReturnType<
  typeof useCreateNodeMutation
>
export type CreateNodeMutationResult = Apollo.MutationResult<CreateNodeMutation>
export type CreateNodeMutationOptions = Apollo.BaseMutationOptions<
  CreateNodeMutation,
  CreateNodeMutationVariables
>
export const TransferNodeOwnershipDocument = gql`
  mutation transferNodeOwnership($input: TransferOwnershipInput!) {
    transferNodeOwnership(input: $input) {
      ...NodeDetail
    }
  }
  ${NodeDetailFragmentDoc}
`
export type TransferNodeOwnershipMutationFn = Apollo.MutationFunction<
  TransferNodeOwnershipMutation,
  TransferNodeOwnershipMutationVariables
>

/**
 * __useTransferNodeOwnershipMutation__
 *
 * To run a mutation, you first call `useTransferNodeOwnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferNodeOwnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferNodeOwnershipMutation, { data, loading, error }] = useTransferNodeOwnershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransferNodeOwnershipMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TransferNodeOwnershipMutation,
    TransferNodeOwnershipMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    TransferNodeOwnershipMutation,
    TransferNodeOwnershipMutationVariables
  >(TransferNodeOwnershipDocument, options)
}
export type TransferNodeOwnershipMutationHookResult = ReturnType<
  typeof useTransferNodeOwnershipMutation
>
export type TransferNodeOwnershipMutationResult =
  Apollo.MutationResult<TransferNodeOwnershipMutation>
export type TransferNodeOwnershipMutationOptions = Apollo.BaseMutationOptions<
  TransferNodeOwnershipMutation,
  TransferNodeOwnershipMutationVariables
>
export const DeleteNodeDocument = gql`
  mutation deleteNode($id: String!) {
    deleteNode(id: $id)
  }
`
export type DeleteNodeMutationFn = Apollo.MutationFunction<
  DeleteNodeMutation,
  DeleteNodeMutationVariables
>

/**
 * __useDeleteNodeMutation__
 *
 * To run a mutation, you first call `useDeleteNodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNodeMutation, { data, loading, error }] = useDeleteNodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteNodeMutation,
    DeleteNodeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteNodeMutation, DeleteNodeMutationVariables>(
    DeleteNodeDocument,
    options
  )
}
export type DeleteNodeMutationHookResult = ReturnType<
  typeof useDeleteNodeMutation
>
export type DeleteNodeMutationResult = Apollo.MutationResult<DeleteNodeMutation>
export type DeleteNodeMutationOptions = Apollo.BaseMutationOptions<
  DeleteNodeMutation,
  DeleteNodeMutationVariables
>
export const SearchDocument = gql`
  query Search($input: SearchInput!) {
    search(input: $input) {
      ...SearchResultFields
    }
  }
  ${SearchResultFieldsFragmentDoc}
`

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchQuery(
  baseOptions: Apollo.QueryHookOptions<SearchQuery, SearchQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SearchQuery, SearchQueryVariables>(
    SearchDocument,
    options
  )
}
export function useSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SearchQuery, SearchQueryVariables>(
    SearchDocument,
    options
  )
}
export function useSearchSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchQuery,
    SearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<SearchQuery, SearchQueryVariables>(
    SearchDocument,
    options
  )
}
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>
export type SearchSuspenseQueryHookResult = ReturnType<
  typeof useSearchSuspenseQuery
>
export type SearchQueryResult = Apollo.QueryResult<
  SearchQuery,
  SearchQueryVariables
>
export const CreateTaskDocument = gql`
  mutation createTask($input: CreateMelddTaskInput!) {
    createTask(input: $input) {
      id
      title
      type
      targetId
      targetType
    }
  }
`
export type CreateTaskMutationFn = Apollo.MutationFunction<
  CreateTaskMutation,
  CreateTaskMutationVariables
>

/**
 * __useCreateTaskMutation__
 *
 * To run a mutation, you first call `useCreateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskMutation, { data, loading, error }] = useCreateTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTaskMutation,
    CreateTaskMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateTaskMutation, CreateTaskMutationVariables>(
    CreateTaskDocument,
    options
  )
}
export type CreateTaskMutationHookResult = ReturnType<
  typeof useCreateTaskMutation
>
export type CreateTaskMutationResult = Apollo.MutationResult<CreateTaskMutation>
export type CreateTaskMutationOptions = Apollo.BaseMutationOptions<
  CreateTaskMutation,
  CreateTaskMutationVariables
>
export const AssignTaskDocument = gql`
  mutation assignTask($input: AssignTaskInput!) {
    assignTask(input: $input)
  }
`
export type AssignTaskMutationFn = Apollo.MutationFunction<
  AssignTaskMutation,
  AssignTaskMutationVariables
>

/**
 * __useAssignTaskMutation__
 *
 * To run a mutation, you first call `useAssignTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignTaskMutation, { data, loading, error }] = useAssignTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignTaskMutation,
    AssignTaskMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AssignTaskMutation, AssignTaskMutationVariables>(
    AssignTaskDocument,
    options
  )
}
export type AssignTaskMutationHookResult = ReturnType<
  typeof useAssignTaskMutation
>
export type AssignTaskMutationResult = Apollo.MutationResult<AssignTaskMutation>
export type AssignTaskMutationOptions = Apollo.BaseMutationOptions<
  AssignTaskMutation,
  AssignTaskMutationVariables
>
export const ArchiveTaskDocument = gql`
  mutation archiveTask($input: TaskIdInput!) {
    archiveTask(input: $input)
  }
`
export type ArchiveTaskMutationFn = Apollo.MutationFunction<
  ArchiveTaskMutation,
  ArchiveTaskMutationVariables
>

/**
 * __useArchiveTaskMutation__
 *
 * To run a mutation, you first call `useArchiveTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveTaskMutation, { data, loading, error }] = useArchiveTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveTaskMutation,
    ArchiveTaskMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ArchiveTaskMutation, ArchiveTaskMutationVariables>(
    ArchiveTaskDocument,
    options
  )
}
export type ArchiveTaskMutationHookResult = ReturnType<
  typeof useArchiveTaskMutation
>
export type ArchiveTaskMutationResult =
  Apollo.MutationResult<ArchiveTaskMutation>
export type ArchiveTaskMutationOptions = Apollo.BaseMutationOptions<
  ArchiveTaskMutation,
  ArchiveTaskMutationVariables
>
export const GetTaskDocument = gql`
  query getTask($taskId: String!) {
    getTask(taskId: $taskId) {
      ...TaskDetail
    }
  }
  ${TaskDetailFragmentDoc}
`

/**
 * __useGetTaskQuery__
 *
 * To run a query within a React component, call `useGetTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetTaskQuery(
  baseOptions: Apollo.QueryHookOptions<GetTaskQuery, GetTaskQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTaskQuery, GetTaskQueryVariables>(
    GetTaskDocument,
    options
  )
}
export function useGetTaskLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTaskQuery, GetTaskQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTaskQuery, GetTaskQueryVariables>(
    GetTaskDocument,
    options
  )
}
export function useGetTaskSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTaskQuery,
    GetTaskQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetTaskQuery, GetTaskQueryVariables>(
    GetTaskDocument,
    options
  )
}
export type GetTaskQueryHookResult = ReturnType<typeof useGetTaskQuery>
export type GetTaskLazyQueryHookResult = ReturnType<typeof useGetTaskLazyQuery>
export type GetTaskSuspenseQueryHookResult = ReturnType<
  typeof useGetTaskSuspenseQuery
>
export type GetTaskQueryResult = Apollo.QueryResult<
  GetTaskQuery,
  GetTaskQueryVariables
>
export const GetTaskContributionsDocument = gql`
  query getTaskContributions(
    $input: GetContributionsInput!
    $offset: Float!
    $size: Float!
  ) {
    getTaskContributions(input: $input, offset: $offset, size: $size) {
      results {
        ...TaskContributor
      }
      count
    }
  }
  ${TaskContributorFragmentDoc}
`

/**
 * __useGetTaskContributionsQuery__
 *
 * To run a query within a React component, call `useGetTaskContributionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskContributionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskContributionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      offset: // value for 'offset'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useGetTaskContributionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTaskContributionsQuery,
    GetTaskContributionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetTaskContributionsQuery,
    GetTaskContributionsQueryVariables
  >(GetTaskContributionsDocument, options)
}
export function useGetTaskContributionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTaskContributionsQuery,
    GetTaskContributionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetTaskContributionsQuery,
    GetTaskContributionsQueryVariables
  >(GetTaskContributionsDocument, options)
}
export function useGetTaskContributionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTaskContributionsQuery,
    GetTaskContributionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GetTaskContributionsQuery,
    GetTaskContributionsQueryVariables
  >(GetTaskContributionsDocument, options)
}
export type GetTaskContributionsQueryHookResult = ReturnType<
  typeof useGetTaskContributionsQuery
>
export type GetTaskContributionsLazyQueryHookResult = ReturnType<
  typeof useGetTaskContributionsLazyQuery
>
export type GetTaskContributionsSuspenseQueryHookResult = ReturnType<
  typeof useGetTaskContributionsSuspenseQuery
>
export type GetTaskContributionsQueryResult = Apollo.QueryResult<
  GetTaskContributionsQuery,
  GetTaskContributionsQueryVariables
>
export const GetTasksDocument = gql`
  query getTasks($input: GetTasksInput!, $offset: Float!, $size: Float!) {
    getTasks(input: $input, offset: $offset, size: $size) {
      results {
        ...TaskDetail
      }
      count
    }
  }
  ${TaskDetailFragmentDoc}
`

/**
 * __useGetTasksQuery__
 *
 * To run a query within a React component, call `useGetTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksQuery({
 *   variables: {
 *      input: // value for 'input'
 *      offset: // value for 'offset'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useGetTasksQuery(
  baseOptions: Apollo.QueryHookOptions<GetTasksQuery, GetTasksQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTasksQuery, GetTasksQueryVariables>(
    GetTasksDocument,
    options
  )
}
export function useGetTasksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTasksQuery,
    GetTasksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTasksQuery, GetTasksQueryVariables>(
    GetTasksDocument,
    options
  )
}
export function useGetTasksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTasksQuery,
    GetTasksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetTasksQuery, GetTasksQueryVariables>(
    GetTasksDocument,
    options
  )
}
export type GetTasksQueryHookResult = ReturnType<typeof useGetTasksQuery>
export type GetTasksLazyQueryHookResult = ReturnType<
  typeof useGetTasksLazyQuery
>
export type GetTasksSuspenseQueryHookResult = ReturnType<
  typeof useGetTasksSuspenseQuery
>
export type GetTasksQueryResult = Apollo.QueryResult<
  GetTasksQuery,
  GetTasksQueryVariables
>
export const GetTargetContributionsDocument = gql`
  query getTargetContributions(
    $input: GetContributionsByTargetInput!
    $offset: Float!
    $size: Float!
  ) {
    getTargetContributions(input: $input, offset: $offset, size: $size) {
      results {
        ...TaskContributor
      }
      count
    }
  }
  ${TaskContributorFragmentDoc}
`

/**
 * __useGetTargetContributionsQuery__
 *
 * To run a query within a React component, call `useGetTargetContributionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTargetContributionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTargetContributionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      offset: // value for 'offset'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useGetTargetContributionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTargetContributionsQuery,
    GetTargetContributionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetTargetContributionsQuery,
    GetTargetContributionsQueryVariables
  >(GetTargetContributionsDocument, options)
}
export function useGetTargetContributionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTargetContributionsQuery,
    GetTargetContributionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetTargetContributionsQuery,
    GetTargetContributionsQueryVariables
  >(GetTargetContributionsDocument, options)
}
export function useGetTargetContributionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTargetContributionsQuery,
    GetTargetContributionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GetTargetContributionsQuery,
    GetTargetContributionsQueryVariables
  >(GetTargetContributionsDocument, options)
}
export type GetTargetContributionsQueryHookResult = ReturnType<
  typeof useGetTargetContributionsQuery
>
export type GetTargetContributionsLazyQueryHookResult = ReturnType<
  typeof useGetTargetContributionsLazyQuery
>
export type GetTargetContributionsSuspenseQueryHookResult = ReturnType<
  typeof useGetTargetContributionsSuspenseQuery
>
export type GetTargetContributionsQueryResult = Apollo.QueryResult<
  GetTargetContributionsQuery,
  GetTargetContributionsQueryVariables
>
export const GetMyContributionByTaskIdDocument = gql`
  query getMyContributionByTaskId($taskId: String!) {
    getMyContributionByTaskId(taskId: $taskId) {
      ...TaskContributor
    }
  }
  ${TaskContributorFragmentDoc}
`

/**
 * __useGetMyContributionByTaskIdQuery__
 *
 * To run a query within a React component, call `useGetMyContributionByTaskIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyContributionByTaskIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyContributionByTaskIdQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetMyContributionByTaskIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMyContributionByTaskIdQuery,
    GetMyContributionByTaskIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetMyContributionByTaskIdQuery,
    GetMyContributionByTaskIdQueryVariables
  >(GetMyContributionByTaskIdDocument, options)
}
export function useGetMyContributionByTaskIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMyContributionByTaskIdQuery,
    GetMyContributionByTaskIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetMyContributionByTaskIdQuery,
    GetMyContributionByTaskIdQueryVariables
  >(GetMyContributionByTaskIdDocument, options)
}
export function useGetMyContributionByTaskIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetMyContributionByTaskIdQuery,
    GetMyContributionByTaskIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GetMyContributionByTaskIdQuery,
    GetMyContributionByTaskIdQueryVariables
  >(GetMyContributionByTaskIdDocument, options)
}
export type GetMyContributionByTaskIdQueryHookResult = ReturnType<
  typeof useGetMyContributionByTaskIdQuery
>
export type GetMyContributionByTaskIdLazyQueryHookResult = ReturnType<
  typeof useGetMyContributionByTaskIdLazyQuery
>
export type GetMyContributionByTaskIdSuspenseQueryHookResult = ReturnType<
  typeof useGetMyContributionByTaskIdSuspenseQuery
>
export type GetMyContributionByTaskIdQueryResult = Apollo.QueryResult<
  GetMyContributionByTaskIdQuery,
  GetMyContributionByTaskIdQueryVariables
>
export const GetMyContributionsDocument = gql`
  query getMyContributions(
    $input: GetContributionsFilter!
    $offset: Float!
    $size: Float!
  ) {
    getMyContributions(input: $input, offset: $offset, size: $size) {
      results {
        ...TaskContributor
      }
      count
    }
  }
  ${TaskContributorFragmentDoc}
`

/**
 * __useGetMyContributionsQuery__
 *
 * To run a query within a React component, call `useGetMyContributionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyContributionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyContributionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      offset: // value for 'offset'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useGetMyContributionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMyContributionsQuery,
    GetMyContributionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetMyContributionsQuery,
    GetMyContributionsQueryVariables
  >(GetMyContributionsDocument, options)
}
export function useGetMyContributionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMyContributionsQuery,
    GetMyContributionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetMyContributionsQuery,
    GetMyContributionsQueryVariables
  >(GetMyContributionsDocument, options)
}
export function useGetMyContributionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetMyContributionsQuery,
    GetMyContributionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GetMyContributionsQuery,
    GetMyContributionsQueryVariables
  >(GetMyContributionsDocument, options)
}
export type GetMyContributionsQueryHookResult = ReturnType<
  typeof useGetMyContributionsQuery
>
export type GetMyContributionsLazyQueryHookResult = ReturnType<
  typeof useGetMyContributionsLazyQuery
>
export type GetMyContributionsSuspenseQueryHookResult = ReturnType<
  typeof useGetMyContributionsSuspenseQuery
>
export type GetMyContributionsQueryResult = Apollo.QueryResult<
  GetMyContributionsQuery,
  GetMyContributionsQueryVariables
>
export const ContributeOnTaskDocument = gql`
  mutation contributeOnTask($input: TaskIdInput!) {
    contributeOnTask(input: $input) {
      ...TaskContributor
    }
  }
  ${TaskContributorFragmentDoc}
`
export type ContributeOnTaskMutationFn = Apollo.MutationFunction<
  ContributeOnTaskMutation,
  ContributeOnTaskMutationVariables
>

/**
 * __useContributeOnTaskMutation__
 *
 * To run a mutation, you first call `useContributeOnTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContributeOnTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contributeOnTaskMutation, { data, loading, error }] = useContributeOnTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContributeOnTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContributeOnTaskMutation,
    ContributeOnTaskMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContributeOnTaskMutation,
    ContributeOnTaskMutationVariables
  >(ContributeOnTaskDocument, options)
}
export type ContributeOnTaskMutationHookResult = ReturnType<
  typeof useContributeOnTaskMutation
>
export type ContributeOnTaskMutationResult =
  Apollo.MutationResult<ContributeOnTaskMutation>
export type ContributeOnTaskMutationOptions = Apollo.BaseMutationOptions<
  ContributeOnTaskMutation,
  ContributeOnTaskMutationVariables
>
export const DeleteTaskContributionDocument = gql`
  mutation deleteTaskContribution($taskContributionId: String!) {
    deleteTaskContribution(taskContributionId: $taskContributionId)
  }
`
export type DeleteTaskContributionMutationFn = Apollo.MutationFunction<
  DeleteTaskContributionMutation,
  DeleteTaskContributionMutationVariables
>

/**
 * __useDeleteTaskContributionMutation__
 *
 * To run a mutation, you first call `useDeleteTaskContributionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskContributionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskContributionMutation, { data, loading, error }] = useDeleteTaskContributionMutation({
 *   variables: {
 *      taskContributionId: // value for 'taskContributionId'
 *   },
 * });
 */
export function useDeleteTaskContributionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTaskContributionMutation,
    DeleteTaskContributionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteTaskContributionMutation,
    DeleteTaskContributionMutationVariables
  >(DeleteTaskContributionDocument, options)
}
export type DeleteTaskContributionMutationHookResult = ReturnType<
  typeof useDeleteTaskContributionMutation
>
export type DeleteTaskContributionMutationResult =
  Apollo.MutationResult<DeleteTaskContributionMutation>
export type DeleteTaskContributionMutationOptions = Apollo.BaseMutationOptions<
  DeleteTaskContributionMutation,
  DeleteTaskContributionMutationVariables
>
export const PendingTasksDocument = gql`
  query pendingTasks($targetId: String) {
    pendingTasks(targetId: $targetId) {
      pendingTasks
      pendingContributions
    }
  }
`

/**
 * __usePendingTasksQuery__
 *
 * To run a query within a React component, call `usePendingTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingTasksQuery({
 *   variables: {
 *      targetId: // value for 'targetId'
 *   },
 * });
 */
export function usePendingTasksQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PendingTasksQuery,
    PendingTasksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PendingTasksQuery, PendingTasksQueryVariables>(
    PendingTasksDocument,
    options
  )
}
export function usePendingTasksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PendingTasksQuery,
    PendingTasksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PendingTasksQuery, PendingTasksQueryVariables>(
    PendingTasksDocument,
    options
  )
}
export function usePendingTasksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PendingTasksQuery,
    PendingTasksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<PendingTasksQuery, PendingTasksQueryVariables>(
    PendingTasksDocument,
    options
  )
}
export type PendingTasksQueryHookResult = ReturnType<
  typeof usePendingTasksQuery
>
export type PendingTasksLazyQueryHookResult = ReturnType<
  typeof usePendingTasksLazyQuery
>
export type PendingTasksSuspenseQueryHookResult = ReturnType<
  typeof usePendingTasksSuspenseQuery
>
export type PendingTasksQueryResult = Apollo.QueryResult<
  PendingTasksQuery,
  PendingTasksQueryVariables
>
export const IsTargetAllowedDocument = gql`
  query isTargetAllowed($input: TimelineTargetInput!) {
    isTargetAllowed(input: $input)
  }
`

/**
 * __useIsTargetAllowedQuery__
 *
 * To run a query within a React component, call `useIsTargetAllowedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsTargetAllowedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsTargetAllowedQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIsTargetAllowedQuery(
  baseOptions: Apollo.QueryHookOptions<
    IsTargetAllowedQuery,
    IsTargetAllowedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IsTargetAllowedQuery, IsTargetAllowedQueryVariables>(
    IsTargetAllowedDocument,
    options
  )
}
export function useIsTargetAllowedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IsTargetAllowedQuery,
    IsTargetAllowedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IsTargetAllowedQuery,
    IsTargetAllowedQueryVariables
  >(IsTargetAllowedDocument, options)
}
export function useIsTargetAllowedSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IsTargetAllowedQuery,
    IsTargetAllowedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IsTargetAllowedQuery,
    IsTargetAllowedQueryVariables
  >(IsTargetAllowedDocument, options)
}
export type IsTargetAllowedQueryHookResult = ReturnType<
  typeof useIsTargetAllowedQuery
>
export type IsTargetAllowedLazyQueryHookResult = ReturnType<
  typeof useIsTargetAllowedLazyQuery
>
export type IsTargetAllowedSuspenseQueryHookResult = ReturnType<
  typeof useIsTargetAllowedSuspenseQuery
>
export type IsTargetAllowedQueryResult = Apollo.QueryResult<
  IsTargetAllowedQuery,
  IsTargetAllowedQueryVariables
>
export const GetHistoryDocument = gql`
  query getHistory($input: TimelineListInput!) {
    getHistory(input: $input) {
      results {
        ...TimelineDetail
      }
      total
    }
  }
  ${TimelineDetailFragmentDoc}
`

/**
 * __useGetHistoryQuery__
 *
 * To run a query within a React component, call `useGetHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHistoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetHistoryQuery,
    GetHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetHistoryQuery, GetHistoryQueryVariables>(
    GetHistoryDocument,
    options
  )
}
export function useGetHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetHistoryQuery,
    GetHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetHistoryQuery, GetHistoryQueryVariables>(
    GetHistoryDocument,
    options
  )
}
export function useGetHistorySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetHistoryQuery,
    GetHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetHistoryQuery, GetHistoryQueryVariables>(
    GetHistoryDocument,
    options
  )
}
export type GetHistoryQueryHookResult = ReturnType<typeof useGetHistoryQuery>
export type GetHistoryLazyQueryHookResult = ReturnType<
  typeof useGetHistoryLazyQuery
>
export type GetHistorySuspenseQueryHookResult = ReturnType<
  typeof useGetHistorySuspenseQuery
>
export type GetHistoryQueryResult = Apollo.QueryResult<
  GetHistoryQuery,
  GetHistoryQueryVariables
>
export const GetTimelinePositionDocument = gql`
  query getTimelinePosition($id: String!) {
    getTimelinePosition(id: $id) {
      position
      total
    }
  }
`

/**
 * __useGetTimelinePositionQuery__
 *
 * To run a query within a React component, call `useGetTimelinePositionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimelinePositionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimelinePositionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTimelinePositionQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTimelinePositionQuery,
    GetTimelinePositionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetTimelinePositionQuery,
    GetTimelinePositionQueryVariables
  >(GetTimelinePositionDocument, options)
}
export function useGetTimelinePositionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTimelinePositionQuery,
    GetTimelinePositionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetTimelinePositionQuery,
    GetTimelinePositionQueryVariables
  >(GetTimelinePositionDocument, options)
}
export function useGetTimelinePositionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTimelinePositionQuery,
    GetTimelinePositionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GetTimelinePositionQuery,
    GetTimelinePositionQueryVariables
  >(GetTimelinePositionDocument, options)
}
export type GetTimelinePositionQueryHookResult = ReturnType<
  typeof useGetTimelinePositionQuery
>
export type GetTimelinePositionLazyQueryHookResult = ReturnType<
  typeof useGetTimelinePositionLazyQuery
>
export type GetTimelinePositionSuspenseQueryHookResult = ReturnType<
  typeof useGetTimelinePositionSuspenseQuery
>
export type GetTimelinePositionQueryResult = Apollo.QueryResult<
  GetTimelinePositionQuery,
  GetTimelinePositionQueryVariables
>
export const GetUserTokensDocument = gql`
  query getUserTokens($type: String) {
    userTokens(type: $type) {
      id
      userId
      type
      source
      isDefault
      errorMessage
      createdAt
      updatedAt
    }
  }
`

/**
 * __useGetUserTokensQuery__
 *
 * To run a query within a React component, call `useGetUserTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTokensQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetUserTokensQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUserTokensQuery,
    GetUserTokensQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetUserTokensQuery, GetUserTokensQueryVariables>(
    GetUserTokensDocument,
    options
  )
}
export function useGetUserTokensLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserTokensQuery,
    GetUserTokensQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetUserTokensQuery, GetUserTokensQueryVariables>(
    GetUserTokensDocument,
    options
  )
}
export function useGetUserTokensSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetUserTokensQuery,
    GetUserTokensQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GetUserTokensQuery,
    GetUserTokensQueryVariables
  >(GetUserTokensDocument, options)
}
export type GetUserTokensQueryHookResult = ReturnType<
  typeof useGetUserTokensQuery
>
export type GetUserTokensLazyQueryHookResult = ReturnType<
  typeof useGetUserTokensLazyQuery
>
export type GetUserTokensSuspenseQueryHookResult = ReturnType<
  typeof useGetUserTokensSuspenseQuery
>
export type GetUserTokensQueryResult = Apollo.QueryResult<
  GetUserTokensQuery,
  GetUserTokensQueryVariables
>
export const DisableUserTokenDocument = gql`
  mutation disableUserToken($id: ID!) {
    disableUserToken(id: $id)
  }
`
export type DisableUserTokenMutationFn = Apollo.MutationFunction<
  DisableUserTokenMutation,
  DisableUserTokenMutationVariables
>

/**
 * __useDisableUserTokenMutation__
 *
 * To run a mutation, you first call `useDisableUserTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableUserTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableUserTokenMutation, { data, loading, error }] = useDisableUserTokenMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisableUserTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DisableUserTokenMutation,
    DisableUserTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DisableUserTokenMutation,
    DisableUserTokenMutationVariables
  >(DisableUserTokenDocument, options)
}
export type DisableUserTokenMutationHookResult = ReturnType<
  typeof useDisableUserTokenMutation
>
export type DisableUserTokenMutationResult =
  Apollo.MutationResult<DisableUserTokenMutation>
export type DisableUserTokenMutationOptions = Apollo.BaseMutationOptions<
  DisableUserTokenMutation,
  DisableUserTokenMutationVariables
>
export const SetDefaultPaymentTokenDocument = gql`
  mutation setDefaultPaymentToken($id: ID!) {
    setDefaultPaymentToken(id: $id)
  }
`
export type SetDefaultPaymentTokenMutationFn = Apollo.MutationFunction<
  SetDefaultPaymentTokenMutation,
  SetDefaultPaymentTokenMutationVariables
>

/**
 * __useSetDefaultPaymentTokenMutation__
 *
 * To run a mutation, you first call `useSetDefaultPaymentTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultPaymentTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultPaymentTokenMutation, { data, loading, error }] = useSetDefaultPaymentTokenMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetDefaultPaymentTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetDefaultPaymentTokenMutation,
    SetDefaultPaymentTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SetDefaultPaymentTokenMutation,
    SetDefaultPaymentTokenMutationVariables
  >(SetDefaultPaymentTokenDocument, options)
}
export type SetDefaultPaymentTokenMutationHookResult = ReturnType<
  typeof useSetDefaultPaymentTokenMutation
>
export type SetDefaultPaymentTokenMutationResult =
  Apollo.MutationResult<SetDefaultPaymentTokenMutation>
export type SetDefaultPaymentTokenMutationOptions = Apollo.BaseMutationOptions<
  SetDefaultPaymentTokenMutation,
  SetDefaultPaymentTokenMutationVariables
>
export const UserDocument = gql`
  query user($userId: ID!) {
    user(id: $userId) {
      ...UserWithBioDetail
    }
  }
  ${UserWithBioDetailFragmentDoc}
`

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserQuery(
  baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options)
}
export function useUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(
    UserDocument,
    options
  )
}
export function useUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<UserQuery, UserQueryVariables>(
    UserDocument,
    options
  )
}
export type UserQueryHookResult = ReturnType<typeof useUserQuery>
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>
export type UserSuspenseQueryHookResult = ReturnType<
  typeof useUserSuspenseQuery
>
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>
export const SearchUserDocument = gql`
  query searchUser(
    $input: SearchUserNameInput!
    $nodeId: String
    $clusterId: String
  ) {
    usersBySearchUsername(input: $input) {
      id
      username
      isNodeMember(nodeId: $nodeId)
      isClusterMember(clusterId: $clusterId)
    }
  }
`

/**
 * __useSearchUserQuery__
 *
 * To run a query within a React component, call `useSearchUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *      nodeId: // value for 'nodeId'
 *      clusterId: // value for 'clusterId'
 *   },
 * });
 */
export function useSearchUserQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchUserQuery,
    SearchUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SearchUserQuery, SearchUserQueryVariables>(
    SearchUserDocument,
    options
  )
}
export function useSearchUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchUserQuery,
    SearchUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SearchUserQuery, SearchUserQueryVariables>(
    SearchUserDocument,
    options
  )
}
export function useSearchUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchUserQuery,
    SearchUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<SearchUserQuery, SearchUserQueryVariables>(
    SearchUserDocument,
    options
  )
}
export type SearchUserQueryHookResult = ReturnType<typeof useSearchUserQuery>
export type SearchUserLazyQueryHookResult = ReturnType<
  typeof useSearchUserLazyQuery
>
export type SearchUserSuspenseQueryHookResult = ReturnType<
  typeof useSearchUserSuspenseQuery
>
export type SearchUserQueryResult = Apollo.QueryResult<
  SearchUserQuery,
  SearchUserQueryVariables
>
export const SignUpDocument = gql`
  mutation signUp($input: SignUpInput!) {
    signUp(input: $input) {
      accessToken
      user {
        ...UserDetail
      }
    }
  }
  ${UserDetailFragmentDoc}
`
export type SignUpMutationFn = Apollo.MutationFunction<
  SignUpMutation,
  SignUpMutationVariables
>

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignUpMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SignUpMutation,
    SignUpMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(
    SignUpDocument,
    options
  )
}
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>
export type SignUpMutationOptions = Apollo.BaseMutationOptions<
  SignUpMutation,
  SignUpMutationVariables
>
export const LoginDocument = gql`
  mutation login($input: LoginUserInput!) {
    login(loginUserInput: $input) {
      accessToken
      user {
        ...UserDetail
      }
    }
  }
  ${UserDetailFragmentDoc}
`
export type LoginMutationFn = Apollo.MutationFunction<
  LoginMutation,
  LoginMutationVariables
>

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LoginMutation,
    LoginMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<LoginMutation, LoginMutationVariables>(
    LoginDocument,
    options
  )
}
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>
export type LoginMutationOptions = Apollo.BaseMutationOptions<
  LoginMutation,
  LoginMutationVariables
>
export const LoginOtpDocument = gql`
  mutation loginOTP($input: LoginUserOtpInput!) {
    loginOTP(input: $input) {
      accessToken
      user {
        ...UserDetail
      }
    }
  }
  ${UserDetailFragmentDoc}
`
export type LoginOtpMutationFn = Apollo.MutationFunction<
  LoginOtpMutation,
  LoginOtpMutationVariables
>

/**
 * __useLoginOtpMutation__
 *
 * To run a mutation, you first call `useLoginOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginOtpMutation, { data, loading, error }] = useLoginOtpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginOtpMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LoginOtpMutation,
    LoginOtpMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<LoginOtpMutation, LoginOtpMutationVariables>(
    LoginOtpDocument,
    options
  )
}
export type LoginOtpMutationHookResult = ReturnType<typeof useLoginOtpMutation>
export type LoginOtpMutationResult = Apollo.MutationResult<LoginOtpMutation>
export type LoginOtpMutationOptions = Apollo.BaseMutationOptions<
  LoginOtpMutation,
  LoginOtpMutationVariables
>
export const LoginMobileOtpDocument = gql`
  mutation loginMobileOTP($input: LoginUserMobileOtpInput!) {
    loginMobileOTP(input: $input) {
      accessToken
      user {
        ...UserDetail
      }
    }
  }
  ${UserDetailFragmentDoc}
`
export type LoginMobileOtpMutationFn = Apollo.MutationFunction<
  LoginMobileOtpMutation,
  LoginMobileOtpMutationVariables
>

/**
 * __useLoginMobileOtpMutation__
 *
 * To run a mutation, you first call `useLoginMobileOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMobileOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMobileOtpMutation, { data, loading, error }] = useLoginMobileOtpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMobileOtpMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LoginMobileOtpMutation,
    LoginMobileOtpMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    LoginMobileOtpMutation,
    LoginMobileOtpMutationVariables
  >(LoginMobileOtpDocument, options)
}
export type LoginMobileOtpMutationHookResult = ReturnType<
  typeof useLoginMobileOtpMutation
>
export type LoginMobileOtpMutationResult =
  Apollo.MutationResult<LoginMobileOtpMutation>
export type LoginMobileOtpMutationOptions = Apollo.BaseMutationOptions<
  LoginMobileOtpMutation,
  LoginMobileOtpMutationVariables
>
export const RequestMobileVerificationCodeDocument = gql`
  mutation requestMobileVerificationCode(
    $input: RequestMobileVerificationInput!
  ) {
    requestMobileVerificationCode(input: $input) {
      isSent
    }
  }
`
export type RequestMobileVerificationCodeMutationFn = Apollo.MutationFunction<
  RequestMobileVerificationCodeMutation,
  RequestMobileVerificationCodeMutationVariables
>

/**
 * __useRequestMobileVerificationCodeMutation__
 *
 * To run a mutation, you first call `useRequestMobileVerificationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestMobileVerificationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestMobileVerificationCodeMutation, { data, loading, error }] = useRequestMobileVerificationCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestMobileVerificationCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestMobileVerificationCodeMutation,
    RequestMobileVerificationCodeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RequestMobileVerificationCodeMutation,
    RequestMobileVerificationCodeMutationVariables
  >(RequestMobileVerificationCodeDocument, options)
}
export type RequestMobileVerificationCodeMutationHookResult = ReturnType<
  typeof useRequestMobileVerificationCodeMutation
>
export type RequestMobileVerificationCodeMutationResult =
  Apollo.MutationResult<RequestMobileVerificationCodeMutation>
export type RequestMobileVerificationCodeMutationOptions =
  Apollo.BaseMutationOptions<
    RequestMobileVerificationCodeMutation,
    RequestMobileVerificationCodeMutationVariables
  >
export const RequestOtpDocument = gql`
  mutation requestOTP($input: RequestOtpInput!) {
    requestOTP(input: $input) {
      isSent
    }
  }
`
export type RequestOtpMutationFn = Apollo.MutationFunction<
  RequestOtpMutation,
  RequestOtpMutationVariables
>

/**
 * __useRequestOtpMutation__
 *
 * To run a mutation, you first call `useRequestOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestOtpMutation, { data, loading, error }] = useRequestOtpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestOtpMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestOtpMutation,
    RequestOtpMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<RequestOtpMutation, RequestOtpMutationVariables>(
    RequestOtpDocument,
    options
  )
}
export type RequestOtpMutationHookResult = ReturnType<
  typeof useRequestOtpMutation
>
export type RequestOtpMutationResult = Apollo.MutationResult<RequestOtpMutation>
export type RequestOtpMutationOptions = Apollo.BaseMutationOptions<
  RequestOtpMutation,
  RequestOtpMutationVariables
>
export const GoogleLoginDocument = gql`
  mutation googleLogin($input: GoogleLoginInput!) {
    googleLogin(input: $input) {
      accessToken
      user {
        ...UserDetail
      }
    }
  }
  ${UserDetailFragmentDoc}
`
export type GoogleLoginMutationFn = Apollo.MutationFunction<
  GoogleLoginMutation,
  GoogleLoginMutationVariables
>

/**
 * __useGoogleLoginMutation__
 *
 * To run a mutation, you first call `useGoogleLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGoogleLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [googleLoginMutation, { data, loading, error }] = useGoogleLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGoogleLoginMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GoogleLoginMutation,
    GoogleLoginMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<GoogleLoginMutation, GoogleLoginMutationVariables>(
    GoogleLoginDocument,
    options
  )
}
export type GoogleLoginMutationHookResult = ReturnType<
  typeof useGoogleLoginMutation
>
export type GoogleLoginMutationResult =
  Apollo.MutationResult<GoogleLoginMutation>
export type GoogleLoginMutationOptions = Apollo.BaseMutationOptions<
  GoogleLoginMutation,
  GoogleLoginMutationVariables
>
export const UpdateUserDocument = gql`
  mutation updateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      ...UserWithBioDetail
    }
  }
  ${UserWithBioDetailFragmentDoc}
`
export type UpdateUserMutationFn = Apollo.MutationFunction<
  UpdateUserMutation,
  UpdateUserMutationVariables
>

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserMutation,
    UpdateUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(
    UpdateUserDocument,
    options
  )
}
export type UpdateUserMutationHookResult = ReturnType<
  typeof useUpdateUserMutation
>
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserMutation,
  UpdateUserMutationVariables
>
export const GoogleCheckDocument = gql`
  mutation googleCheck($input: GoogleLoginInput!) {
    googleCheck(input: $input) {
      accountExists
      ssoName
    }
  }
`
export type GoogleCheckMutationFn = Apollo.MutationFunction<
  GoogleCheckMutation,
  GoogleCheckMutationVariables
>

/**
 * __useGoogleCheckMutation__
 *
 * To run a mutation, you first call `useGoogleCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGoogleCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [googleCheckMutation, { data, loading, error }] = useGoogleCheckMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGoogleCheckMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GoogleCheckMutation,
    GoogleCheckMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<GoogleCheckMutation, GoogleCheckMutationVariables>(
    GoogleCheckDocument,
    options
  )
}
export type GoogleCheckMutationHookResult = ReturnType<
  typeof useGoogleCheckMutation
>
export type GoogleCheckMutationResult =
  Apollo.MutationResult<GoogleCheckMutation>
export type GoogleCheckMutationOptions = Apollo.BaseMutationOptions<
  GoogleCheckMutation,
  GoogleCheckMutationVariables
>
export const LogoutDocument = gql`
  mutation logout($input: LogoutInput) {
    logout(input: $input) {
      isSuccess
    }
  }
`
export type LogoutMutationFn = Apollo.MutationFunction<
  LogoutMutation,
  LogoutMutationVariables
>

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogoutMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LogoutMutation,
    LogoutMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(
    LogoutDocument,
    options
  )
}
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>
export type LogoutMutationOptions = Apollo.BaseMutationOptions<
  LogoutMutation,
  LogoutMutationVariables
>
export const ValidAppAccessKeyDocument = gql`
  query validAppAccessKey($code: String!) {
    validAppAccessKey(code: $code) {
      isValid
    }
  }
`

/**
 * __useValidAppAccessKeyQuery__
 *
 * To run a query within a React component, call `useValidAppAccessKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidAppAccessKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidAppAccessKeyQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useValidAppAccessKeyQuery(
  baseOptions: Apollo.QueryHookOptions<
    ValidAppAccessKeyQuery,
    ValidAppAccessKeyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ValidAppAccessKeyQuery,
    ValidAppAccessKeyQueryVariables
  >(ValidAppAccessKeyDocument, options)
}
export function useValidAppAccessKeyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ValidAppAccessKeyQuery,
    ValidAppAccessKeyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ValidAppAccessKeyQuery,
    ValidAppAccessKeyQueryVariables
  >(ValidAppAccessKeyDocument, options)
}
export function useValidAppAccessKeySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ValidAppAccessKeyQuery,
    ValidAppAccessKeyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ValidAppAccessKeyQuery,
    ValidAppAccessKeyQueryVariables
  >(ValidAppAccessKeyDocument, options)
}
export type ValidAppAccessKeyQueryHookResult = ReturnType<
  typeof useValidAppAccessKeyQuery
>
export type ValidAppAccessKeyLazyQueryHookResult = ReturnType<
  typeof useValidAppAccessKeyLazyQuery
>
export type ValidAppAccessKeySuspenseQueryHookResult = ReturnType<
  typeof useValidAppAccessKeySuspenseQuery
>
export type ValidAppAccessKeyQueryResult = Apollo.QueryResult<
  ValidAppAccessKeyQuery,
  ValidAppAccessKeyQueryVariables
>
export const SuggestUsernameDocument = gql`
  query suggestUsername($input: SuggestUsernameInput!) {
    suggestUsername(input: $input) {
      username
    }
  }
`

/**
 * __useSuggestUsernameQuery__
 *
 * To run a query within a React component, call `useSuggestUsernameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestUsernameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestUsernameQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuggestUsernameQuery(
  baseOptions: Apollo.QueryHookOptions<
    SuggestUsernameQuery,
    SuggestUsernameQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SuggestUsernameQuery, SuggestUsernameQueryVariables>(
    SuggestUsernameDocument,
    options
  )
}
export function useSuggestUsernameLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SuggestUsernameQuery,
    SuggestUsernameQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SuggestUsernameQuery,
    SuggestUsernameQueryVariables
  >(SuggestUsernameDocument, options)
}
export function useSuggestUsernameSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SuggestUsernameQuery,
    SuggestUsernameQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SuggestUsernameQuery,
    SuggestUsernameQueryVariables
  >(SuggestUsernameDocument, options)
}
export type SuggestUsernameQueryHookResult = ReturnType<
  typeof useSuggestUsernameQuery
>
export type SuggestUsernameLazyQueryHookResult = ReturnType<
  typeof useSuggestUsernameLazyQuery
>
export type SuggestUsernameSuspenseQueryHookResult = ReturnType<
  typeof useSuggestUsernameSuspenseQuery
>
export type SuggestUsernameQueryResult = Apollo.QueryResult<
  SuggestUsernameQuery,
  SuggestUsernameQueryVariables
>
export const ValidUsernameDocument = gql`
  query validUsername($username: String!) {
    usernameAvailable(username: $username) {
      isAvailable
      message
    }
  }
`

/**
 * __useValidUsernameQuery__
 *
 * To run a query within a React component, call `useValidUsernameQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidUsernameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidUsernameQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useValidUsernameQuery(
  baseOptions: Apollo.QueryHookOptions<
    ValidUsernameQuery,
    ValidUsernameQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ValidUsernameQuery, ValidUsernameQueryVariables>(
    ValidUsernameDocument,
    options
  )
}
export function useValidUsernameLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ValidUsernameQuery,
    ValidUsernameQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ValidUsernameQuery, ValidUsernameQueryVariables>(
    ValidUsernameDocument,
    options
  )
}
export function useValidUsernameSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ValidUsernameQuery,
    ValidUsernameQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ValidUsernameQuery,
    ValidUsernameQueryVariables
  >(ValidUsernameDocument, options)
}
export type ValidUsernameQueryHookResult = ReturnType<
  typeof useValidUsernameQuery
>
export type ValidUsernameLazyQueryHookResult = ReturnType<
  typeof useValidUsernameLazyQuery
>
export type ValidUsernameSuspenseQueryHookResult = ReturnType<
  typeof useValidUsernameSuspenseQuery
>
export type ValidUsernameQueryResult = Apollo.QueryResult<
  ValidUsernameQuery,
  ValidUsernameQueryVariables
>
export const DeleteAccountDocument = gql`
  mutation deleteAccount {
    deleteAccount
  }
`
export type DeleteAccountMutationFn = Apollo.MutationFunction<
  DeleteAccountMutation,
  DeleteAccountMutationVariables
>

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAccountMutation,
    DeleteAccountMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteAccountMutation,
    DeleteAccountMutationVariables
  >(DeleteAccountDocument, options)
}
export type DeleteAccountMutationHookResult = ReturnType<
  typeof useDeleteAccountMutation
>
export type DeleteAccountMutationResult =
  Apollo.MutationResult<DeleteAccountMutation>
export type DeleteAccountMutationOptions = Apollo.BaseMutationOptions<
  DeleteAccountMutation,
  DeleteAccountMutationVariables
>
export const RegisterPushTokenDocument = gql`
  mutation registerPushToken($input: RegisterPushTokenInput!) {
    registerPushToken(input: $input) {
      success
    }
  }
`
export type RegisterPushTokenMutationFn = Apollo.MutationFunction<
  RegisterPushTokenMutation,
  RegisterPushTokenMutationVariables
>

/**
 * __useRegisterPushTokenMutation__
 *
 * To run a mutation, you first call `useRegisterPushTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterPushTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerPushTokenMutation, { data, loading, error }] = useRegisterPushTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterPushTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterPushTokenMutation,
    RegisterPushTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RegisterPushTokenMutation,
    RegisterPushTokenMutationVariables
  >(RegisterPushTokenDocument, options)
}
export type RegisterPushTokenMutationHookResult = ReturnType<
  typeof useRegisterPushTokenMutation
>
export type RegisterPushTokenMutationResult =
  Apollo.MutationResult<RegisterPushTokenMutation>
export type RegisterPushTokenMutationOptions = Apollo.BaseMutationOptions<
  RegisterPushTokenMutation,
  RegisterPushTokenMutationVariables
>
export const VerifyMobileDocument = gql`
  mutation verifyMobile($input: VerifyMobileInput!) {
    verifyMobile(input: $input)
  }
`
export type VerifyMobileMutationFn = Apollo.MutationFunction<
  VerifyMobileMutation,
  VerifyMobileMutationVariables
>

/**
 * __useVerifyMobileMutation__
 *
 * To run a mutation, you first call `useVerifyMobileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyMobileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyMobileMutation, { data, loading, error }] = useVerifyMobileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyMobileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifyMobileMutation,
    VerifyMobileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    VerifyMobileMutation,
    VerifyMobileMutationVariables
  >(VerifyMobileDocument, options)
}
export type VerifyMobileMutationHookResult = ReturnType<
  typeof useVerifyMobileMutation
>
export type VerifyMobileMutationResult =
  Apollo.MutationResult<VerifyMobileMutation>
export type VerifyMobileMutationOptions = Apollo.BaseMutationOptions<
  VerifyMobileMutation,
  VerifyMobileMutationVariables
>
export const LinkWithGoogleDocument = gql`
  mutation linkWithGoogle($input: GoogleLoginInput!) {
    linkWithGoogle(input: $input)
  }
`
export type LinkWithGoogleMutationFn = Apollo.MutationFunction<
  LinkWithGoogleMutation,
  LinkWithGoogleMutationVariables
>

/**
 * __useLinkWithGoogleMutation__
 *
 * To run a mutation, you first call `useLinkWithGoogleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkWithGoogleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkWithGoogleMutation, { data, loading, error }] = useLinkWithGoogleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkWithGoogleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LinkWithGoogleMutation,
    LinkWithGoogleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    LinkWithGoogleMutation,
    LinkWithGoogleMutationVariables
  >(LinkWithGoogleDocument, options)
}
export type LinkWithGoogleMutationHookResult = ReturnType<
  typeof useLinkWithGoogleMutation
>
export type LinkWithGoogleMutationResult =
  Apollo.MutationResult<LinkWithGoogleMutation>
export type LinkWithGoogleMutationOptions = Apollo.BaseMutationOptions<
  LinkWithGoogleMutation,
  LinkWithGoogleMutationVariables
>
export const RevokeGoogleDocument = gql`
  mutation revokeGoogle {
    revokeGoogle
  }
`
export type RevokeGoogleMutationFn = Apollo.MutationFunction<
  RevokeGoogleMutation,
  RevokeGoogleMutationVariables
>

/**
 * __useRevokeGoogleMutation__
 *
 * To run a mutation, you first call `useRevokeGoogleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeGoogleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeGoogleMutation, { data, loading, error }] = useRevokeGoogleMutation({
 *   variables: {
 *   },
 * });
 */
export function useRevokeGoogleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RevokeGoogleMutation,
    RevokeGoogleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RevokeGoogleMutation,
    RevokeGoogleMutationVariables
  >(RevokeGoogleDocument, options)
}
export type RevokeGoogleMutationHookResult = ReturnType<
  typeof useRevokeGoogleMutation
>
export type RevokeGoogleMutationResult =
  Apollo.MutationResult<RevokeGoogleMutation>
export type RevokeGoogleMutationOptions = Apollo.BaseMutationOptions<
  RevokeGoogleMutation,
  RevokeGoogleMutationVariables
>
export const RevokeWechatDocument = gql`
  mutation revokeWechat {
    revokeWechat
  }
`
export type RevokeWechatMutationFn = Apollo.MutationFunction<
  RevokeWechatMutation,
  RevokeWechatMutationVariables
>

/**
 * __useRevokeWechatMutation__
 *
 * To run a mutation, you first call `useRevokeWechatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeWechatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeWechatMutation, { data, loading, error }] = useRevokeWechatMutation({
 *   variables: {
 *   },
 * });
 */
export function useRevokeWechatMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RevokeWechatMutation,
    RevokeWechatMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RevokeWechatMutation,
    RevokeWechatMutationVariables
  >(RevokeWechatDocument, options)
}
export type RevokeWechatMutationHookResult = ReturnType<
  typeof useRevokeWechatMutation
>
export type RevokeWechatMutationResult =
  Apollo.MutationResult<RevokeWechatMutation>
export type RevokeWechatMutationOptions = Apollo.BaseMutationOptions<
  RevokeWechatMutation,
  RevokeWechatMutationVariables
>
export const WechatLoginDocument = gql`
  mutation wechatLogin($input: WechatLoginInput!) {
    wechatLogin(input: $input) {
      accessToken
      user {
        ...UserDetail
      }
    }
  }
  ${UserDetailFragmentDoc}
`
export type WechatLoginMutationFn = Apollo.MutationFunction<
  WechatLoginMutation,
  WechatLoginMutationVariables
>

/**
 * __useWechatLoginMutation__
 *
 * To run a mutation, you first call `useWechatLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWechatLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wechatLoginMutation, { data, loading, error }] = useWechatLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWechatLoginMutation(
  baseOptions?: Apollo.MutationHookOptions<
    WechatLoginMutation,
    WechatLoginMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<WechatLoginMutation, WechatLoginMutationVariables>(
    WechatLoginDocument,
    options
  )
}
export type WechatLoginMutationHookResult = ReturnType<
  typeof useWechatLoginMutation
>
export type WechatLoginMutationResult =
  Apollo.MutationResult<WechatLoginMutation>
export type WechatLoginMutationOptions = Apollo.BaseMutationOptions<
  WechatLoginMutation,
  WechatLoginMutationVariables
>
export const WechatCheckDocument = gql`
  mutation wechatCheck($input: WechatLoginInput!) {
    wechatCheck(input: $input) {
      accountExists
      ssoName
    }
  }
`
export type WechatCheckMutationFn = Apollo.MutationFunction<
  WechatCheckMutation,
  WechatCheckMutationVariables
>

/**
 * __useWechatCheckMutation__
 *
 * To run a mutation, you first call `useWechatCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWechatCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wechatCheckMutation, { data, loading, error }] = useWechatCheckMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWechatCheckMutation(
  baseOptions?: Apollo.MutationHookOptions<
    WechatCheckMutation,
    WechatCheckMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<WechatCheckMutation, WechatCheckMutationVariables>(
    WechatCheckDocument,
    options
  )
}
export type WechatCheckMutationHookResult = ReturnType<
  typeof useWechatCheckMutation
>
export type WechatCheckMutationResult =
  Apollo.MutationResult<WechatCheckMutation>
export type WechatCheckMutationOptions = Apollo.BaseMutationOptions<
  WechatCheckMutation,
  WechatCheckMutationVariables
>
export const LinkWithWechatDocument = gql`
  mutation linkWithWechat($input: WechatLoginInput!) {
    linkWithWechat(input: $input)
  }
`
export type LinkWithWechatMutationFn = Apollo.MutationFunction<
  LinkWithWechatMutation,
  LinkWithWechatMutationVariables
>

/**
 * __useLinkWithWechatMutation__
 *
 * To run a mutation, you first call `useLinkWithWechatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkWithWechatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkWithWechatMutation, { data, loading, error }] = useLinkWithWechatMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkWithWechatMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LinkWithWechatMutation,
    LinkWithWechatMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    LinkWithWechatMutation,
    LinkWithWechatMutationVariables
  >(LinkWithWechatDocument, options)
}
export type LinkWithWechatMutationHookResult = ReturnType<
  typeof useLinkWithWechatMutation
>
export type LinkWithWechatMutationResult =
  Apollo.MutationResult<LinkWithWechatMutation>
export type LinkWithWechatMutationOptions = Apollo.BaseMutationOptions<
  LinkWithWechatMutation,
  LinkWithWechatMutationVariables
>
export const WechatSignatureDocument = gql`
  mutation wechatSignature($input: WechatJDKSignatureInput!) {
    wechatSignature(input: $input) {
      nonceStr
      signature
      timestamp
    }
  }
`
export type WechatSignatureMutationFn = Apollo.MutationFunction<
  WechatSignatureMutation,
  WechatSignatureMutationVariables
>

/**
 * __useWechatSignatureMutation__
 *
 * To run a mutation, you first call `useWechatSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWechatSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wechatSignatureMutation, { data, loading, error }] = useWechatSignatureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWechatSignatureMutation(
  baseOptions?: Apollo.MutationHookOptions<
    WechatSignatureMutation,
    WechatSignatureMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    WechatSignatureMutation,
    WechatSignatureMutationVariables
  >(WechatSignatureDocument, options)
}
export type WechatSignatureMutationHookResult = ReturnType<
  typeof useWechatSignatureMutation
>
export type WechatSignatureMutationResult =
  Apollo.MutationResult<WechatSignatureMutation>
export type WechatSignatureMutationOptions = Apollo.BaseMutationOptions<
  WechatSignatureMutation,
  WechatSignatureMutationVariables
>
export const SendTestNotificationDocument = gql`
  mutation sendTestNotification($message: String!) {
    sendTestNotification(message: $message) {
      success
      message
      userId
      provider
    }
  }
`
export type SendTestNotificationMutationFn = Apollo.MutationFunction<
  SendTestNotificationMutation,
  SendTestNotificationMutationVariables
>

/**
 * __useSendTestNotificationMutation__
 *
 * To run a mutation, you first call `useSendTestNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestNotificationMutation, { data, loading, error }] = useSendTestNotificationMutation({
 *   variables: {
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSendTestNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendTestNotificationMutation,
    SendTestNotificationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SendTestNotificationMutation,
    SendTestNotificationMutationVariables
  >(SendTestNotificationDocument, options)
}
export type SendTestNotificationMutationHookResult = ReturnType<
  typeof useSendTestNotificationMutation
>
export type SendTestNotificationMutationResult =
  Apollo.MutationResult<SendTestNotificationMutation>
export type SendTestNotificationMutationOptions = Apollo.BaseMutationOptions<
  SendTestNotificationMutation,
  SendTestNotificationMutationVariables
>
export const MyCorankDocument = gql`
  query myCorank($nodeId: ID) {
    myCorank(nodeId: $nodeId)
  }
`

/**
 * __useMyCorankQuery__
 *
 * To run a query within a React component, call `useMyCorankQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCorankQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCorankQuery({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useMyCorankQuery(
  baseOptions?: Apollo.QueryHookOptions<MyCorankQuery, MyCorankQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<MyCorankQuery, MyCorankQueryVariables>(
    MyCorankDocument,
    options
  )
}
export function useMyCorankLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyCorankQuery,
    MyCorankQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<MyCorankQuery, MyCorankQueryVariables>(
    MyCorankDocument,
    options
  )
}
export function useMyCorankSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MyCorankQuery,
    MyCorankQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<MyCorankQuery, MyCorankQueryVariables>(
    MyCorankDocument,
    options
  )
}
export type MyCorankQueryHookResult = ReturnType<typeof useMyCorankQuery>
export type MyCorankLazyQueryHookResult = ReturnType<
  typeof useMyCorankLazyQuery
>
export type MyCorankSuspenseQueryHookResult = ReturnType<
  typeof useMyCorankSuspenseQuery
>
export type MyCorankQueryResult = Apollo.QueryResult<
  MyCorankQuery,
  MyCorankQueryVariables
>
export const CorankUserDifferenceDocument = gql`
  query corankUserDifference($profileUserId: ID!, $nodeId: ID) {
    corankUserDifference(profileUserId: $profileUserId, nodeId: $nodeId) {
      viewerLastUpdateScore
      profileUserLastUpdateScore
      isCommonContributionContext
    }
  }
`

/**
 * __useCorankUserDifferenceQuery__
 *
 * To run a query within a React component, call `useCorankUserDifferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCorankUserDifferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorankUserDifferenceQuery({
 *   variables: {
 *      profileUserId: // value for 'profileUserId'
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useCorankUserDifferenceQuery(
  baseOptions: Apollo.QueryHookOptions<
    CorankUserDifferenceQuery,
    CorankUserDifferenceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CorankUserDifferenceQuery,
    CorankUserDifferenceQueryVariables
  >(CorankUserDifferenceDocument, options)
}
export function useCorankUserDifferenceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CorankUserDifferenceQuery,
    CorankUserDifferenceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CorankUserDifferenceQuery,
    CorankUserDifferenceQueryVariables
  >(CorankUserDifferenceDocument, options)
}
export function useCorankUserDifferenceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CorankUserDifferenceQuery,
    CorankUserDifferenceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CorankUserDifferenceQuery,
    CorankUserDifferenceQueryVariables
  >(CorankUserDifferenceDocument, options)
}
export type CorankUserDifferenceQueryHookResult = ReturnType<
  typeof useCorankUserDifferenceQuery
>
export type CorankUserDifferenceLazyQueryHookResult = ReturnType<
  typeof useCorankUserDifferenceLazyQuery
>
export type CorankUserDifferenceSuspenseQueryHookResult = ReturnType<
  typeof useCorankUserDifferenceSuspenseQuery
>
export type CorankUserDifferenceQueryResult = Apollo.QueryResult<
  CorankUserDifferenceQuery,
  CorankUserDifferenceQueryVariables
>
export const ProfileCorankComparisonDocument = gql`
  query profileCorankComparison(
    $profileUserId: ID!
    $viewerUserId: ID!
    $nodeId: ID
  ) {
    viewerCorank: myCorank(nodeId: $nodeId)
    profileUserCorank: userCorank(userId: $profileUserId, nodeId: $nodeId)
    viewerCorankTimeline: corankUpdatedTimelineSeries(
      nodeId: $nodeId
      userId: $viewerUserId
    ) {
      eventCount
      windowStart
      windowEnd
      points {
        coRank
        timestamp
      }
    }
    profileCorankTimeline: corankUpdatedTimelineSeries(
      nodeId: $nodeId
      userId: $profileUserId
    ) {
      eventCount
      windowStart
      windowEnd
      points {
        coRank
        timestamp
      }
    }
  }
`

/**
 * __useProfileCorankComparisonQuery__
 *
 * To run a query within a React component, call `useProfileCorankComparisonQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileCorankComparisonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileCorankComparisonQuery({
 *   variables: {
 *      profileUserId: // value for 'profileUserId'
 *      viewerUserId: // value for 'viewerUserId'
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useProfileCorankComparisonQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProfileCorankComparisonQuery,
    ProfileCorankComparisonQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ProfileCorankComparisonQuery,
    ProfileCorankComparisonQueryVariables
  >(ProfileCorankComparisonDocument, options)
}
export function useProfileCorankComparisonLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProfileCorankComparisonQuery,
    ProfileCorankComparisonQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProfileCorankComparisonQuery,
    ProfileCorankComparisonQueryVariables
  >(ProfileCorankComparisonDocument, options)
}
export function useProfileCorankComparisonSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProfileCorankComparisonQuery,
    ProfileCorankComparisonQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ProfileCorankComparisonQuery,
    ProfileCorankComparisonQueryVariables
  >(ProfileCorankComparisonDocument, options)
}
export type ProfileCorankComparisonQueryHookResult = ReturnType<
  typeof useProfileCorankComparisonQuery
>
export type ProfileCorankComparisonLazyQueryHookResult = ReturnType<
  typeof useProfileCorankComparisonLazyQuery
>
export type ProfileCorankComparisonSuspenseQueryHookResult = ReturnType<
  typeof useProfileCorankComparisonSuspenseQuery
>
export type ProfileCorankComparisonQueryResult = Apollo.QueryResult<
  ProfileCorankComparisonQuery,
  ProfileCorankComparisonQueryVariables
>
export const UpdateTimelineReadUntilDocument = gql`
  mutation UpdateTimelineReadUntil {
    updateTimelineReadUntil
  }
`
export type UpdateTimelineReadUntilMutationFn = Apollo.MutationFunction<
  UpdateTimelineReadUntilMutation,
  UpdateTimelineReadUntilMutationVariables
>

/**
 * __useUpdateTimelineReadUntilMutation__
 *
 * To run a mutation, you first call `useUpdateTimelineReadUntilMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimelineReadUntilMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimelineReadUntilMutation, { data, loading, error }] = useUpdateTimelineReadUntilMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateTimelineReadUntilMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTimelineReadUntilMutation,
    UpdateTimelineReadUntilMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateTimelineReadUntilMutation,
    UpdateTimelineReadUntilMutationVariables
  >(UpdateTimelineReadUntilDocument, options)
}
export type UpdateTimelineReadUntilMutationHookResult = ReturnType<
  typeof useUpdateTimelineReadUntilMutation
>
export type UpdateTimelineReadUntilMutationResult =
  Apollo.MutationResult<UpdateTimelineReadUntilMutation>
export type UpdateTimelineReadUntilMutationOptions = Apollo.BaseMutationOptions<
  UpdateTimelineReadUntilMutation,
  UpdateTimelineReadUntilMutationVariables
>
export const CollaboratorsDocument = gql`
  query collaborators($pagination: PaginationInput, $search: String) {
    collaborators(pagination: $pagination, search: $search) {
      total
      users {
        id
        username
        firstName
        lastName
        bio
        publicCoRank
        collaboratorId
        lists {
          id
          name
          color
        }
        lastEvent {
          id
          title
          timestamp
          action
          targetType
          targetId
          nodeName
          payload {
            type
          }
        }
        incompleteTasks {
          id
          title
          type
          targetId
          targetType
          createdAt
          isArchived
          isCompleted
        }
      }
    }
  }
`

/**
 * __useCollaboratorsQuery__
 *
 * To run a query within a React component, call `useCollaboratorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollaboratorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollaboratorsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useCollaboratorsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CollaboratorsQuery,
    CollaboratorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CollaboratorsQuery, CollaboratorsQueryVariables>(
    CollaboratorsDocument,
    options
  )
}
export function useCollaboratorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CollaboratorsQuery,
    CollaboratorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CollaboratorsQuery, CollaboratorsQueryVariables>(
    CollaboratorsDocument,
    options
  )
}
export function useCollaboratorsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CollaboratorsQuery,
    CollaboratorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CollaboratorsQuery,
    CollaboratorsQueryVariables
  >(CollaboratorsDocument, options)
}
export type CollaboratorsQueryHookResult = ReturnType<
  typeof useCollaboratorsQuery
>
export type CollaboratorsLazyQueryHookResult = ReturnType<
  typeof useCollaboratorsLazyQuery
>
export type CollaboratorsSuspenseQueryHookResult = ReturnType<
  typeof useCollaboratorsSuspenseQuery
>
export type CollaboratorsQueryResult = Apollo.QueryResult<
  CollaboratorsQuery,
  CollaboratorsQueryVariables
>
export const MyCollaboratorsTimelineDocument = gql`
  query MyCollaboratorsTimeline(
    $pagination: PaginationInput
    $actions: [TimeLineAction!]
    $userId: ID
    $nodeId: ID
  ) {
    myCollaboratorsEvents(
      input: {
        pagination: $pagination
        actions: $actions
        userId: $userId
        nodeId: $nodeId
      }
    ) {
      total
      results {
        id
        action
        timestamp
        isNew
        targetId
        targetType
        title
        nodeName
        user {
          id
          username
        }
        payload {
          title
          type
          originalText
        }
      }
    }
  }
`

/**
 * __useMyCollaboratorsTimelineQuery__
 *
 * To run a query within a React component, call `useMyCollaboratorsTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCollaboratorsTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCollaboratorsTimelineQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      actions: // value for 'actions'
 *      userId: // value for 'userId'
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useMyCollaboratorsTimelineQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MyCollaboratorsTimelineQuery,
    MyCollaboratorsTimelineQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    MyCollaboratorsTimelineQuery,
    MyCollaboratorsTimelineQueryVariables
  >(MyCollaboratorsTimelineDocument, options)
}
export function useMyCollaboratorsTimelineLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyCollaboratorsTimelineQuery,
    MyCollaboratorsTimelineQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    MyCollaboratorsTimelineQuery,
    MyCollaboratorsTimelineQueryVariables
  >(MyCollaboratorsTimelineDocument, options)
}
export function useMyCollaboratorsTimelineSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MyCollaboratorsTimelineQuery,
    MyCollaboratorsTimelineQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    MyCollaboratorsTimelineQuery,
    MyCollaboratorsTimelineQueryVariables
  >(MyCollaboratorsTimelineDocument, options)
}
export type MyCollaboratorsTimelineQueryHookResult = ReturnType<
  typeof useMyCollaboratorsTimelineQuery
>
export type MyCollaboratorsTimelineLazyQueryHookResult = ReturnType<
  typeof useMyCollaboratorsTimelineLazyQuery
>
export type MyCollaboratorsTimelineSuspenseQueryHookResult = ReturnType<
  typeof useMyCollaboratorsTimelineSuspenseQuery
>
export type MyCollaboratorsTimelineQueryResult = Apollo.QueryResult<
  MyCollaboratorsTimelineQuery,
  MyCollaboratorsTimelineQueryVariables
>
export const MyTimelineEventsDocument = gql`
  query MyTimelineEvents(
    $pagination: PaginationInput
    $actions: [TimeLineAction!]
    $nodeId: ID
  ) {
    myTimelineEvents(
      input: { pagination: $pagination, actions: $actions, nodeId: $nodeId }
    ) {
      total
      results {
        id
        action
        timestamp
        targetId
        targetType
        title
        nodeName
        user {
          id
          username
        }
        payload {
          title
          type
          originalText
        }
      }
    }
  }
`

/**
 * __useMyTimelineEventsQuery__
 *
 * To run a query within a React component, call `useMyTimelineEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTimelineEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTimelineEventsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      actions: // value for 'actions'
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useMyTimelineEventsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MyTimelineEventsQuery,
    MyTimelineEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<MyTimelineEventsQuery, MyTimelineEventsQueryVariables>(
    MyTimelineEventsDocument,
    options
  )
}
export function useMyTimelineEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyTimelineEventsQuery,
    MyTimelineEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    MyTimelineEventsQuery,
    MyTimelineEventsQueryVariables
  >(MyTimelineEventsDocument, options)
}
export function useMyTimelineEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MyTimelineEventsQuery,
    MyTimelineEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    MyTimelineEventsQuery,
    MyTimelineEventsQueryVariables
  >(MyTimelineEventsDocument, options)
}
export type MyTimelineEventsQueryHookResult = ReturnType<
  typeof useMyTimelineEventsQuery
>
export type MyTimelineEventsLazyQueryHookResult = ReturnType<
  typeof useMyTimelineEventsLazyQuery
>
export type MyTimelineEventsSuspenseQueryHookResult = ReturnType<
  typeof useMyTimelineEventsSuspenseQuery
>
export type MyTimelineEventsQueryResult = Apollo.QueryResult<
  MyTimelineEventsQuery,
  MyTimelineEventsQueryVariables
>
export const UserTimelineEventsDocument = gql`
  query UserTimelineEvents(
    $userId: String!
    $pagination: PaginationInput
    $actions: [TimeLineAction!]
    $nodeId: ID
  ) {
    userTimelineEvents(
      userId: $userId
      input: { pagination: $pagination, actions: $actions, nodeId: $nodeId }
    ) {
      total
      results {
        id
        action
        timestamp
        targetId
        targetType
        title
        nodeName
        user {
          id
          username
        }
        payload {
          title
          type
          originalText
        }
      }
    }
  }
`

/**
 * __useUserTimelineEventsQuery__
 *
 * To run a query within a React component, call `useUserTimelineEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTimelineEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTimelineEventsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      pagination: // value for 'pagination'
 *      actions: // value for 'actions'
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useUserTimelineEventsQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserTimelineEventsQuery,
    UserTimelineEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    UserTimelineEventsQuery,
    UserTimelineEventsQueryVariables
  >(UserTimelineEventsDocument, options)
}
export function useUserTimelineEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserTimelineEventsQuery,
    UserTimelineEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UserTimelineEventsQuery,
    UserTimelineEventsQueryVariables
  >(UserTimelineEventsDocument, options)
}
export function useUserTimelineEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UserTimelineEventsQuery,
    UserTimelineEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UserTimelineEventsQuery,
    UserTimelineEventsQueryVariables
  >(UserTimelineEventsDocument, options)
}
export type UserTimelineEventsQueryHookResult = ReturnType<
  typeof useUserTimelineEventsQuery
>
export type UserTimelineEventsLazyQueryHookResult = ReturnType<
  typeof useUserTimelineEventsLazyQuery
>
export type UserTimelineEventsSuspenseQueryHookResult = ReturnType<
  typeof useUserTimelineEventsSuspenseQuery
>
export type UserTimelineEventsQueryResult = Apollo.QueryResult<
  UserTimelineEventsQuery,
  UserTimelineEventsQueryVariables
>
export const GetNewEventsCountDocument = gql`
  query GetNewEventsCount($input: GetNewEventsCountInput!) {
    getNewEventsCount(input: $input)
  }
`

/**
 * __useGetNewEventsCountQuery__
 *
 * To run a query within a React component, call `useGetNewEventsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewEventsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewEventsCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetNewEventsCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetNewEventsCountQuery,
    GetNewEventsCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetNewEventsCountQuery,
    GetNewEventsCountQueryVariables
  >(GetNewEventsCountDocument, options)
}
export function useGetNewEventsCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNewEventsCountQuery,
    GetNewEventsCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetNewEventsCountQuery,
    GetNewEventsCountQueryVariables
  >(GetNewEventsCountDocument, options)
}
export function useGetNewEventsCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetNewEventsCountQuery,
    GetNewEventsCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GetNewEventsCountQuery,
    GetNewEventsCountQueryVariables
  >(GetNewEventsCountDocument, options)
}
export type GetNewEventsCountQueryHookResult = ReturnType<
  typeof useGetNewEventsCountQuery
>
export type GetNewEventsCountLazyQueryHookResult = ReturnType<
  typeof useGetNewEventsCountLazyQuery
>
export type GetNewEventsCountSuspenseQueryHookResult = ReturnType<
  typeof useGetNewEventsCountSuspenseQuery
>
export type GetNewEventsCountQueryResult = Apollo.QueryResult<
  GetNewEventsCountQuery,
  GetNewEventsCountQueryVariables
>
export const MyCollaboratorListsDocument = gql`
  query MyCollaboratorLists {
    myCollaboratorLists {
      id
      ownerId
      name
      color
      createdAt
      updatedAt
    }
  }
`

/**
 * __useMyCollaboratorListsQuery__
 *
 * To run a query within a React component, call `useMyCollaboratorListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCollaboratorListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCollaboratorListsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyCollaboratorListsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MyCollaboratorListsQuery,
    MyCollaboratorListsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    MyCollaboratorListsQuery,
    MyCollaboratorListsQueryVariables
  >(MyCollaboratorListsDocument, options)
}
export function useMyCollaboratorListsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyCollaboratorListsQuery,
    MyCollaboratorListsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    MyCollaboratorListsQuery,
    MyCollaboratorListsQueryVariables
  >(MyCollaboratorListsDocument, options)
}
export function useMyCollaboratorListsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MyCollaboratorListsQuery,
    MyCollaboratorListsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    MyCollaboratorListsQuery,
    MyCollaboratorListsQueryVariables
  >(MyCollaboratorListsDocument, options)
}
export type MyCollaboratorListsQueryHookResult = ReturnType<
  typeof useMyCollaboratorListsQuery
>
export type MyCollaboratorListsLazyQueryHookResult = ReturnType<
  typeof useMyCollaboratorListsLazyQuery
>
export type MyCollaboratorListsSuspenseQueryHookResult = ReturnType<
  typeof useMyCollaboratorListsSuspenseQuery
>
export type MyCollaboratorListsQueryResult = Apollo.QueryResult<
  MyCollaboratorListsQuery,
  MyCollaboratorListsQueryVariables
>
export const CreateCollaboratorListDocument = gql`
  mutation CreateCollaboratorList($input: CreateCollaboratorListInput!) {
    createCollaboratorList(input: $input) {
      id
      ownerId
      name
      color
      createdAt
      updatedAt
    }
  }
`
export type CreateCollaboratorListMutationFn = Apollo.MutationFunction<
  CreateCollaboratorListMutation,
  CreateCollaboratorListMutationVariables
>

/**
 * __useCreateCollaboratorListMutation__
 *
 * To run a mutation, you first call `useCreateCollaboratorListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCollaboratorListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCollaboratorListMutation, { data, loading, error }] = useCreateCollaboratorListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCollaboratorListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCollaboratorListMutation,
    CreateCollaboratorListMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateCollaboratorListMutation,
    CreateCollaboratorListMutationVariables
  >(CreateCollaboratorListDocument, options)
}
export type CreateCollaboratorListMutationHookResult = ReturnType<
  typeof useCreateCollaboratorListMutation
>
export type CreateCollaboratorListMutationResult =
  Apollo.MutationResult<CreateCollaboratorListMutation>
export type CreateCollaboratorListMutationOptions = Apollo.BaseMutationOptions<
  CreateCollaboratorListMutation,
  CreateCollaboratorListMutationVariables
>
export const UpdateCollaboratorListDocument = gql`
  mutation UpdateCollaboratorList(
    $listId: String!
    $input: UpdateCollaboratorListInput!
  ) {
    updateCollaboratorList(listId: $listId, input: $input) {
      id
      ownerId
      name
      color
      createdAt
      updatedAt
    }
  }
`
export type UpdateCollaboratorListMutationFn = Apollo.MutationFunction<
  UpdateCollaboratorListMutation,
  UpdateCollaboratorListMutationVariables
>

/**
 * __useUpdateCollaboratorListMutation__
 *
 * To run a mutation, you first call `useUpdateCollaboratorListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCollaboratorListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCollaboratorListMutation, { data, loading, error }] = useUpdateCollaboratorListMutation({
 *   variables: {
 *      listId: // value for 'listId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCollaboratorListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCollaboratorListMutation,
    UpdateCollaboratorListMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateCollaboratorListMutation,
    UpdateCollaboratorListMutationVariables
  >(UpdateCollaboratorListDocument, options)
}
export type UpdateCollaboratorListMutationHookResult = ReturnType<
  typeof useUpdateCollaboratorListMutation
>
export type UpdateCollaboratorListMutationResult =
  Apollo.MutationResult<UpdateCollaboratorListMutation>
export type UpdateCollaboratorListMutationOptions = Apollo.BaseMutationOptions<
  UpdateCollaboratorListMutation,
  UpdateCollaboratorListMutationVariables
>
export const DeleteCollaboratorListDocument = gql`
  mutation DeleteCollaboratorList($listId: String!) {
    deleteCollaboratorList(listId: $listId)
  }
`
export type DeleteCollaboratorListMutationFn = Apollo.MutationFunction<
  DeleteCollaboratorListMutation,
  DeleteCollaboratorListMutationVariables
>

/**
 * __useDeleteCollaboratorListMutation__
 *
 * To run a mutation, you first call `useDeleteCollaboratorListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCollaboratorListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCollaboratorListMutation, { data, loading, error }] = useDeleteCollaboratorListMutation({
 *   variables: {
 *      listId: // value for 'listId'
 *   },
 * });
 */
export function useDeleteCollaboratorListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCollaboratorListMutation,
    DeleteCollaboratorListMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteCollaboratorListMutation,
    DeleteCollaboratorListMutationVariables
  >(DeleteCollaboratorListDocument, options)
}
export type DeleteCollaboratorListMutationHookResult = ReturnType<
  typeof useDeleteCollaboratorListMutation
>
export type DeleteCollaboratorListMutationResult =
  Apollo.MutationResult<DeleteCollaboratorListMutation>
export type DeleteCollaboratorListMutationOptions = Apollo.BaseMutationOptions<
  DeleteCollaboratorListMutation,
  DeleteCollaboratorListMutationVariables
>
export const AssignCollaboratorToListDocument = gql`
  mutation AssignCollaboratorToList($input: AssignCollaboratorToListInput!) {
    assignCollaboratorToList(input: $input)
  }
`
export type AssignCollaboratorToListMutationFn = Apollo.MutationFunction<
  AssignCollaboratorToListMutation,
  AssignCollaboratorToListMutationVariables
>

/**
 * __useAssignCollaboratorToListMutation__
 *
 * To run a mutation, you first call `useAssignCollaboratorToListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignCollaboratorToListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignCollaboratorToListMutation, { data, loading, error }] = useAssignCollaboratorToListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignCollaboratorToListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignCollaboratorToListMutation,
    AssignCollaboratorToListMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AssignCollaboratorToListMutation,
    AssignCollaboratorToListMutationVariables
  >(AssignCollaboratorToListDocument, options)
}
export type AssignCollaboratorToListMutationHookResult = ReturnType<
  typeof useAssignCollaboratorToListMutation
>
export type AssignCollaboratorToListMutationResult =
  Apollo.MutationResult<AssignCollaboratorToListMutation>
export type AssignCollaboratorToListMutationOptions =
  Apollo.BaseMutationOptions<
    AssignCollaboratorToListMutation,
    AssignCollaboratorToListMutationVariables
  >
export const RemoveCollaboratorFromListDocument = gql`
  mutation RemoveCollaboratorFromList(
    $input: RemoveCollaboratorFromListInput!
  ) {
    removeCollaboratorFromList(input: $input)
  }
`
export type RemoveCollaboratorFromListMutationFn = Apollo.MutationFunction<
  RemoveCollaboratorFromListMutation,
  RemoveCollaboratorFromListMutationVariables
>

/**
 * __useRemoveCollaboratorFromListMutation__
 *
 * To run a mutation, you first call `useRemoveCollaboratorFromListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCollaboratorFromListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCollaboratorFromListMutation, { data, loading, error }] = useRemoveCollaboratorFromListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveCollaboratorFromListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveCollaboratorFromListMutation,
    RemoveCollaboratorFromListMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RemoveCollaboratorFromListMutation,
    RemoveCollaboratorFromListMutationVariables
  >(RemoveCollaboratorFromListDocument, options)
}
export type RemoveCollaboratorFromListMutationHookResult = ReturnType<
  typeof useRemoveCollaboratorFromListMutation
>
export type RemoveCollaboratorFromListMutationResult =
  Apollo.MutationResult<RemoveCollaboratorFromListMutation>
export type RemoveCollaboratorFromListMutationOptions =
  Apollo.BaseMutationOptions<
    RemoveCollaboratorFromListMutation,
    RemoveCollaboratorFromListMutationVariables
  >
export const CollaboratorListWithMembersDocument = gql`
  query CollaboratorListWithMembers($listId: String!) {
    collaboratorListWithMembers(listId: $listId) {
      list {
        id
        ownerId
        name
        color
        createdAt
        updatedAt
        collaborators {
          id
          username
          firstName
          lastName
        }
      }
      collaboratorCount
    }
  }
`

/**
 * __useCollaboratorListWithMembersQuery__
 *
 * To run a query within a React component, call `useCollaboratorListWithMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollaboratorListWithMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollaboratorListWithMembersQuery({
 *   variables: {
 *      listId: // value for 'listId'
 *   },
 * });
 */
export function useCollaboratorListWithMembersQuery(
  baseOptions: Apollo.QueryHookOptions<
    CollaboratorListWithMembersQuery,
    CollaboratorListWithMembersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CollaboratorListWithMembersQuery,
    CollaboratorListWithMembersQueryVariables
  >(CollaboratorListWithMembersDocument, options)
}
export function useCollaboratorListWithMembersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CollaboratorListWithMembersQuery,
    CollaboratorListWithMembersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CollaboratorListWithMembersQuery,
    CollaboratorListWithMembersQueryVariables
  >(CollaboratorListWithMembersDocument, options)
}
export function useCollaboratorListWithMembersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CollaboratorListWithMembersQuery,
    CollaboratorListWithMembersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CollaboratorListWithMembersQuery,
    CollaboratorListWithMembersQueryVariables
  >(CollaboratorListWithMembersDocument, options)
}
export type CollaboratorListWithMembersQueryHookResult = ReturnType<
  typeof useCollaboratorListWithMembersQuery
>
export type CollaboratorListWithMembersLazyQueryHookResult = ReturnType<
  typeof useCollaboratorListWithMembersLazyQuery
>
export type CollaboratorListWithMembersSuspenseQueryHookResult = ReturnType<
  typeof useCollaboratorListWithMembersSuspenseQuery
>
export type CollaboratorListWithMembersQueryResult = Apollo.QueryResult<
  CollaboratorListWithMembersQuery,
  CollaboratorListWithMembersQueryVariables
>
export const MyTasksDocument = gql`
  query MyTasks($offset: Float!, $size: Float!) {
    myTasks(offset: $offset, size: $size) {
      results {
        task {
          id
          title
          type
          targetId
          targetType
          createdAt
          isArchived
          isCompleted
        }
        contributors {
          id
          userId
          user {
            id
            username
            firstName
            lastName
          }
        }
      }
      count
    }
  }
`

/**
 * __useMyTasksQuery__
 *
 * To run a query within a React component, call `useMyTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTasksQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useMyTasksQuery(
  baseOptions: Apollo.QueryHookOptions<MyTasksQuery, MyTasksQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<MyTasksQuery, MyTasksQueryVariables>(
    MyTasksDocument,
    options
  )
}
export function useMyTasksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MyTasksQuery, MyTasksQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<MyTasksQuery, MyTasksQueryVariables>(
    MyTasksDocument,
    options
  )
}
export function useMyTasksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MyTasksQuery,
    MyTasksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<MyTasksQuery, MyTasksQueryVariables>(
    MyTasksDocument,
    options
  )
}
export type MyTasksQueryHookResult = ReturnType<typeof useMyTasksQuery>
export type MyTasksLazyQueryHookResult = ReturnType<typeof useMyTasksLazyQuery>
export type MyTasksSuspenseQueryHookResult = ReturnType<
  typeof useMyTasksSuspenseQuery
>
export type MyTasksQueryResult = Apollo.QueryResult<
  MyTasksQuery,
  MyTasksQueryVariables
>
export const InviteCollaboratorsByTaskDocument = gql`
  mutation InviteCollaboratorsByTask($input: InviteCollaboratorsByTaskInput!) {
    inviteCollaboratorsByTask(input: $input) {
      id
      taskId
      userId
      user {
        id
        username
        firstName
        lastName
      }
      isCompleted
      completedAt
      createdAt
    }
  }
`
export type InviteCollaboratorsByTaskMutationFn = Apollo.MutationFunction<
  InviteCollaboratorsByTaskMutation,
  InviteCollaboratorsByTaskMutationVariables
>

/**
 * __useInviteCollaboratorsByTaskMutation__
 *
 * To run a mutation, you first call `useInviteCollaboratorsByTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteCollaboratorsByTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteCollaboratorsByTaskMutation, { data, loading, error }] = useInviteCollaboratorsByTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteCollaboratorsByTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InviteCollaboratorsByTaskMutation,
    InviteCollaboratorsByTaskMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    InviteCollaboratorsByTaskMutation,
    InviteCollaboratorsByTaskMutationVariables
  >(InviteCollaboratorsByTaskDocument, options)
}
export type InviteCollaboratorsByTaskMutationHookResult = ReturnType<
  typeof useInviteCollaboratorsByTaskMutation
>
export type InviteCollaboratorsByTaskMutationResult =
  Apollo.MutationResult<InviteCollaboratorsByTaskMutation>
export type InviteCollaboratorsByTaskMutationOptions =
  Apollo.BaseMutationOptions<
    InviteCollaboratorsByTaskMutation,
    InviteCollaboratorsByTaskMutationVariables
  >
export const InviteCollaboratorToTaskDocument = gql`
  mutation InviteCollaboratorToTask($input: InviteCollaboratorToTaskInput!) {
    inviteCollaboratorToTask(input: $input) {
      id
      taskId
      userId
      user {
        id
        username
        firstName
        lastName
        bio
      }
      isCompleted
      completedAt
      createdAt
    }
  }
`
export type InviteCollaboratorToTaskMutationFn = Apollo.MutationFunction<
  InviteCollaboratorToTaskMutation,
  InviteCollaboratorToTaskMutationVariables
>

/**
 * __useInviteCollaboratorToTaskMutation__
 *
 * To run a mutation, you first call `useInviteCollaboratorToTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteCollaboratorToTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteCollaboratorToTaskMutation, { data, loading, error }] = useInviteCollaboratorToTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteCollaboratorToTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InviteCollaboratorToTaskMutation,
    InviteCollaboratorToTaskMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    InviteCollaboratorToTaskMutation,
    InviteCollaboratorToTaskMutationVariables
  >(InviteCollaboratorToTaskDocument, options)
}
export type InviteCollaboratorToTaskMutationHookResult = ReturnType<
  typeof useInviteCollaboratorToTaskMutation
>
export type InviteCollaboratorToTaskMutationResult =
  Apollo.MutationResult<InviteCollaboratorToTaskMutation>
export type InviteCollaboratorToTaskMutationOptions =
  Apollo.BaseMutationOptions<
    InviteCollaboratorToTaskMutation,
    InviteCollaboratorToTaskMutationVariables
  >
